// Auto-generated from ALL state legislators CSV data
// Contains real current state legislators from Open States for all 50 states + DC
// Total: 7361 legislators from 51 states/jurisdictions

export interface Legislator {
  state: string;
  chamber: string;
  district: string;
  name: string;
  party: string;
}

export const stateLegislators: Legislator[] = [
  {
    "state": "al",
    "chamber": "House",
    "district": "97",
    "name": "Adline Clarke",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "66",
    "name": "Alan Baker",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "51",
    "name": "Allen Treadaway",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "10",
    "name": "Andrew Jones",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "6",
    "name": "Andy Whitt",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "53",
    "name": "Anthony Daniels",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "14",
    "name": "April Weaver",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "43",
    "name": "Arnold Mooney",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "3",
    "name": "Arthur Orr",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "71",
    "name": "A.J. McCampbell",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "32",
    "name": "Barbara Boyd",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "103",
    "name": "Barbara Drummond",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "2",
    "name": "Ben Harrison",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "33",
    "name": "Ben Robbins",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "84",
    "name": "Berry Forte",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "62",
    "name": "Bill Lamb",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "37",
    "name": "Bob Fincher",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "24",
    "name": "Bobby Singleton",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "65",
    "name": "Brett Easterbrook",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "26",
    "name": "Brock Colvin",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "16",
    "name": "Bryan Brinyark",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "40",
    "name": "Chad Robertson",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "105",
    "name": "Chip Brown",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "80",
    "name": "Chris Blackshear",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "32",
    "name": "Chris Elliott",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "70",
    "name": "Chris England",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "101",
    "name": "Chris Pringle",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "90",
    "name": "Chris Sells",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "30",
    "name": "Clyde Chambliss",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "41",
    "name": "Corley Ellis",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "30",
    "name": "Craig Lipscomb",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "72",
    "name": "Curtis Travis",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "15",
    "name": "Dan Roberts",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "5",
    "name": "Danny Crawford",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "44",
    "name": "Danny Garrett",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "46",
    "name": "David Faulkner",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "35",
    "name": "David Sessions",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "34",
    "name": "David Standridge",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "38",
    "name": "Debbie Wood",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "64",
    "name": "Donna Givens",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "29",
    "name": "Donnie Chesteen",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "81",
    "name": "Ed Oliver",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "7",
    "name": "Ernie Yarbrough",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "95",
    "name": "Frances Holk-Jones",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "4",
    "name": "Garlan Gudger",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "21",
    "name": "Gerald Allen",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "39",
    "name": "Ginny Shaver",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "22",
    "name": "Greg Albritton",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "42",
    "name": "Van Smith",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "16",
    "name": "Jabo Waggoner",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "34",
    "name": "Jack Williams",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "20",
    "name": "James Lomax",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "18",
    "name": "Jamie Kiel",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "27",
    "name": "Jay Hovey",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "27",
    "name": "Jeana Ross",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "87",
    "name": "Jeff Sorrells",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "94",
    "name": "Jennifer Fidler",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "83",
    "name": "Jeremy Gray",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "88",
    "name": "Jerry Starnes",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "48",
    "name": "Jim Carns",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "50",
    "name": "Jim Hill",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "79",
    "name": "Joe Lovvorn",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "31",
    "name": "Josh Carnley",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "60",
    "name": "Juandalynn Givan",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "12",
    "name": "Keith Kelley",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "52",
    "name": "Kelvin Datcher",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "69",
    "name": "Kelvin Lawrence",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "73",
    "name": "Kenneth Paschal",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "78",
    "name": "Kenyatté Hassell",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "3",
    "name": "Bubba Underwood",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "26",
    "name": "Kirk Hatcher",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "11",
    "name": "Lance Bell",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "6",
    "name": "Larry Stutts",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "19",
    "name": "Laura Hall",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "15",
    "name": "Leigh Hulsey",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "20",
    "name": "Linda Coleman-Madison",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "28",
    "name": "Mack Butler",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "89",
    "name": "Marcus Paramore",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "104",
    "name": "Margie Wilcox",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "10",
    "name": "Marilyn Lands",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "29",
    "name": "Mark Gidley",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "100",
    "name": "Mark Shirey",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "59",
    "name": "Mary Moore",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "96",
    "name": "Matt Simpson",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "5",
    "name": "Matt Woods",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "92",
    "name": "Matthew Hammett",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "19",
    "name": "Merika Coleman",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "23",
    "name": "Mike Kirkland",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "47",
    "name": "Mike Shaw",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "98",
    "name": "Napoleon Bracy",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "24",
    "name": "Nathaniel Ledbetter",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "54",
    "name": "Neil Rafferty",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "56",
    "name": "Ontario Tillman",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "4",
    "name": "Parker Moore",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "76",
    "name": "Penni McClammy",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "57",
    "name": "Patrick Sellers",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "86",
    "name": "Paul Lee",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "82",
    "name": "Pebblin Warren",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "74",
    "name": "Phillip Ensler",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "1",
    "name": "Phillip Pettus",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "25",
    "name": "Phillip Rigsby",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "67",
    "name": "Prince Chestnut",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "13",
    "name": "Randy Price",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "36",
    "name": "Randy Wood",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "75",
    "name": "Reed Ingram",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "21",
    "name": "Rex Reynolds",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "91",
    "name": "Rhett Marques",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "85",
    "name": "Rick Rehm",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "22",
    "name": "Ritchie Whorton",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "23",
    "name": "Rob Stewart",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "18",
    "name": "Rodger Smitherman",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "58",
    "name": "Rolanda Hollis",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "61",
    "name": "Ron Bolton",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "49",
    "name": "Russell Bedsole",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "7",
    "name": "Sam Givhan",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "99",
    "name": "Sam Jones",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "9",
    "name": "Scott Stadthagen",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "102",
    "name": "Shane Stringer",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "17",
    "name": "Shay Shelnutt",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "93",
    "name": "Steve Clouse",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "35",
    "name": "Steve Hurst",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "8",
    "name": "Steve Livingston",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "45",
    "name": "Susan DuBose",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "77",
    "name": "TaShina Morris",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "8",
    "name": "Terri Collins",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "68",
    "name": "Thomas Jackson",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "1",
    "name": "Tim Melson",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "14",
    "name": "Tim Wadsworth",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "2",
    "name": "Tom Butler",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "17",
    "name": "Tracy Estes",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "55",
    "name": "Travis Hendrix",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "House",
    "district": "31",
    "name": "Troy Stubbs",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "33",
    "name": "Vivian Figures",
    "party": "D"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "9",
    "name": "Wes Kitchens",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "25",
    "name": "Will Barfoot",
    "party": "R"
  },
  {
    "state": "al",
    "chamber": "Senate",
    "district": "28",
    "name": "Billy Beasley",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "14",
    "name": "Alyse Galvin",
    "party": "I"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "3",
    "name": "Andi Story",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "20",
    "name": "Andrew Gray",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "13",
    "name": "Andy Josephson",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "35",
    "name": "Ashley Carrick",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "36",
    "name": "Becky Schwanke",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "A",
    "name": "Bert Stedman",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "8",
    "name": "Bill Elam",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "K",
    "name": "Bill Wielechowski",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "37",
    "name": "Bryce Edgmon",
    "party": "I"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "12",
    "name": "Calvin Schrage",
    "party": "I"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "16",
    "name": "Carolyn Hall",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "E",
    "name": "Cathy Giessel",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "26",
    "name": "Cathy Tilton",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "10",
    "name": "Chuck Kopp",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "24",
    "name": "Dan Saddler",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "18",
    "name": "David Nelson",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "25",
    "name": "DeLena Johnson",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "21",
    "name": "Donna Mears",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "T",
    "name": "Donny Olson",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "28",
    "name": "Elexie Moore",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "G",
    "name": "Elvi Gray-Jackson",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "J",
    "name": "Forrest Dunbar",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "34",
    "name": "Frank Tomaszewski",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "C",
    "name": "Gary Stevens",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "19",
    "name": "Genevieve Mina",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "29",
    "name": "George Rauscher",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "F",
    "name": "James Kaufman",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "23",
    "name": "Jamie Allard",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "1",
    "name": "Jeremy Bynum",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "D",
    "name": "Jesse Bjorkman",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "B",
    "name": "Jesse Kiehl",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "27",
    "name": "Jubilee Underwood",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "11",
    "name": "Julie Coulombe",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "7",
    "name": "Justin Ruffridge",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "L",
    "name": "Kelly Merrick",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "30",
    "name": "Kevin McCabe",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "9",
    "name": "Ky Holland",
    "party": "N"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "I",
    "name": "Löki Tobin",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "5",
    "name": "Louise Stutes",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "S",
    "name": "Lyman Hoffman",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "H",
    "name": "Matt Claman",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "31",
    "name": "Maxine Dibert",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "15",
    "name": "Mia Costello",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "R",
    "name": "Mike Cronk",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "33",
    "name": "Mike Prax",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "O",
    "name": "Mike Shower",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "39",
    "name": "Neal Foster",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "38",
    "name": "Nellie Jimmie",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "2",
    "name": "Rebecca Himschoot",
    "party": "I"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "N",
    "name": "Rob Yundt",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "Q",
    "name": "Robert Myers",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "40",
    "name": "Robyn Burke",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "4",
    "name": "Sara Hannan",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "6",
    "name": "Sarah Vance",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "P",
    "name": "Scott Kawasaki",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "Senate",
    "district": "M",
    "name": "Shelley Hughes",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "22",
    "name": "Ted Eischeid",
    "party": "D"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "32",
    "name": "Will Stapp",
    "party": "R"
  },
  {
    "state": "ak",
    "chamber": "House",
    "district": "17",
    "name": "Zack Fields",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "5",
    "name": "Aaron Marquez",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "3",
    "name": "Alexander Kolodin",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "20",
    "name": "Alma Hernández",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "24",
    "name": "Analise Ortiz",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "24",
    "name": "Anna Abeytia",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "20",
    "name": "Betty Villegas",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "28",
    "name": "Beverly Pingerelli",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "23",
    "name": "Brian Fernandez",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "8",
    "name": "Brian Garcia",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "4",
    "name": "Carine Werner",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "11",
    "name": "Catherine Miranda",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "26",
    "name": "Cesar Aguilar",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "16",
    "name": "Chris Lopez",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "18",
    "name": "Chris Mathis",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "21",
    "name": "Consuelo Hernandez",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "10",
    "name": "Dave Farnsworth",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "19",
    "name": "David Gowan",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "28",
    "name": "David Livingston",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "7",
    "name": "David Marshall",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "12",
    "name": "Mitzi Epstein",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "22",
    "name": "Elda Luna-Nájera",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "22",
    "name": "Eva Diaz",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "26",
    "name": "Flavio Bravo",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "28",
    "name": "Frank Carroll",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "19",
    "name": "Gail Griffin",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "30",
    "name": "Hildy Angius",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "15",
    "name": "Jake Hoffman",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "29",
    "name": "James Taylor",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "29",
    "name": "Janae Shamp",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "8",
    "name": "Janeen Connolly",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "13",
    "name": "J.D. Mesnard",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "13",
    "name": "Jeff Weninger",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "30",
    "name": "John Gillette",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "3",
    "name": "John Kavanagh",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "3",
    "name": "Joseph Chaplik",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "13",
    "name": "Julie Willoughby",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "11",
    "name": "Junelle Cavero",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "10",
    "name": "Justin Olson",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "2",
    "name": "Justin Wilmeth",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "27",
    "name": "Kevin Payne",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "17",
    "name": "Kevin Volk",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "14",
    "name": "Khyl Powell",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "9",
    "name": "Kiana Sears",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "8",
    "name": "Lauren Kuby",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "14",
    "name": "Laurin Hendrix",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "5",
    "name": "Lela Alston",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "30",
    "name": "Leo Biasiucci",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "27",
    "name": "Lisa Fink",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "9",
    "name": "Lorena Austin",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "22",
    "name": "Lupe Contreras",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "19",
    "name": "Lupe Diaz",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "24",
    "name": "Lydia Hernandez",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "6",
    "name": "Mae Peshlakai",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "23",
    "name": "Mariana Sandoval",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "1",
    "name": "Mark Finchem",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "4",
    "name": "Matt Gress",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "25",
    "name": "Michael Carbone",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "15",
    "name": "Michael Way",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "23",
    "name": "Michele Peña",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "6",
    "name": "Myron Tsosie",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "18",
    "name": "Nancy Gutierrez",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "15",
    "name": "Neal Carter",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "25",
    "name": "Nick Kupper",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "11",
    "name": "Oscar De Los Santos",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "4",
    "name": "Pamela Carter",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "12",
    "name": "Patty Contreras",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "18",
    "name": "Priya Sundareshan",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "1",
    "name": "Quang Nguyen",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "26",
    "name": "Quantá Crews",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "17",
    "name": "Rachel Keshel",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "10",
    "name": "Ralph Heap",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "21",
    "name": "Rosanna Gabaldón",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "20",
    "name": "Sally Gonzales",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "5",
    "name": "Sarah Liguori",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "1",
    "name": "Selina Bliss",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "9",
    "name": "Seth Blattman",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "2",
    "name": "Shawnna Bolick",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "12",
    "name": "Stacey Travers",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "21",
    "name": "Stephanie Stahl Hamilton",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "2",
    "name": "Stephanie Simacek",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "29",
    "name": "Steve Montenegro",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "16",
    "name": "Teresa Martinez",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "6",
    "name": "Theresa Hatathlie",
    "party": "D"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "16",
    "name": "T.J. Shope",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "25",
    "name": "Tim Dunn",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "27",
    "name": "Tony Rivero",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "17",
    "name": "Vince Leach",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "House",
    "district": "7",
    "name": "Walt Blackman",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "14",
    "name": "Warren Petersen",
    "party": "R"
  },
  {
    "state": "az",
    "chamber": "Senate",
    "district": "7",
    "name": "Wendy Rogers",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "45",
    "name": "Aaron Pilkington",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "7",
    "name": "Alan Clark",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "41",
    "name": "Alyssa Brown",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "73",
    "name": "Andrew Collins",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "75",
    "name": "Ashley Hudson",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "8",
    "name": "Austin McCollum",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "33",
    "name": "Bart Hester",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "28",
    "name": "Bart Schulz",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "1",
    "name": "Ben Gilmore",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "21",
    "name": "Blake Johnson",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "24",
    "name": "Brad Hall",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "71",
    "name": "Brandon Achor",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "25",
    "name": "Breanne Davis",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "68",
    "name": "Brian Evans",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "7",
    "name": "Brit McKenzie",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "91",
    "name": "Bruce Cozart",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "28",
    "name": "Bryan King",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "57",
    "name": "Cameron Cooper",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "70",
    "name": "Carlton Wing",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "100",
    "name": "Carol Dalby",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "25",
    "name": "Chad Puryear",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "51",
    "name": "Cindy Crawford",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "14",
    "name": "Clarke Tucker",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "31",
    "name": "Clint Penzo",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "20",
    "name": "Dan Sullivan",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "69",
    "name": "David Ray",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "19",
    "name": "Dave Wallace",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "22",
    "name": "David Whitaker",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "87",
    "name": "DeAnn Vaught",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "80",
    "name": "Denise Ennett",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "20",
    "name": "Denise Garner",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "9",
    "name": "Diana Gonzales Worthen",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "88",
    "name": "Dolly Henley",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "38",
    "name": "Dwight Tosh",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "30",
    "name": "Fran Cavenaugh",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "77",
    "name": "Fred Allen",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "15",
    "name": "Fred Love",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "26",
    "name": "Gary Stubblefield",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "65",
    "name": "Glenn Barnes",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "30",
    "name": "Greg Leding",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "6",
    "name": "Harlan Breaux",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "12",
    "name": "Hope Duke",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "95",
    "name": "Howard Beaty",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "32",
    "name": "Jack Ladyman",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "26",
    "name": "James Eaton",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "12",
    "name": "Jamie Scott",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "13",
    "name": "Jane English",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "4",
    "name": "Jason Nazarenko",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "49",
    "name": "Jay Richardson",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "94",
    "name": "Jeff Wardlaw",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "61",
    "name": "Jeremiah Moore",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "1",
    "name": "Jeremy Wooldridge",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "35",
    "name": "Jessie McGruder",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "34",
    "name": "Jim Dotson",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "29",
    "name": "Jim Petty",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "59",
    "name": "Jim Wooten",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "31",
    "name": "Jimmy Gazaway",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "4",
    "name": "Jimmy Hickey",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "34",
    "name": "Joey Carr",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "86",
    "name": "John Maddox",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "15",
    "name": "John Carr",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "22",
    "name": "John Payton",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "36",
    "name": "Johnny Rye",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "33",
    "name": "Jon Milligan",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "46",
    "name": "Jon Eubanks",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "18",
    "name": "Jonathan Dismang",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "32",
    "name": "Josh Bryant",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "76",
    "name": "Joy Springer",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "92",
    "name": "Julie Mayberry",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "27",
    "name": "Justin Boyd",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "89",
    "name": "Justin Gonzales",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "67",
    "name": "Karilyn Brown",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "78",
    "name": "Keith Brooks",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "16",
    "name": "Kendon Underwood",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "23",
    "name": "Kendra Moore",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "64",
    "name": "Ken Ferguson",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "16",
    "name": "Kim Hammer",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "99",
    "name": "Lane Jean",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "47",
    "name": "Lee Johnson",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "58",
    "name": "Les Eaves",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "84",
    "name": "Les Warren",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "63",
    "name": "Lincoln Barnett",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "52",
    "name": "Marcus Richmond",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "62",
    "name": "Mark McElroy",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "17",
    "name": "Mark Johnson",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "66",
    "name": "Mark Perry",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "54",
    "name": "Mary Bentley",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "55",
    "name": "Matt Brown",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "53",
    "name": "Matt Duffield",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "6",
    "name": "Matt McKee",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "2",
    "name": "Matt Stone",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "97",
    "name": "Matthew Shepherd",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "93",
    "name": "Mike Holcomb",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "10",
    "name": "Mindy McAlindon",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "24",
    "name": "Missy Irvin",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "14",
    "name": "Nick Burkes",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "21",
    "name": "Nicole Clowney",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "83",
    "name": "Paul Childress",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "81",
    "name": "R.J. Hawk",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "17",
    "name": "Randy Torres",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "11",
    "name": "Rebecca Burkes",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "9",
    "name": "Reginald Murdock",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "85",
    "name": "Richard McGrew",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "90",
    "name": "Richard Womack",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "43",
    "name": "Rick Beck",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "29",
    "name": "Rick McClure",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "11",
    "name": "Ricky Hill",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "18",
    "name": "Robin Lundstrum",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "60",
    "name": "Roger Lynch",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "5",
    "name": "Ron McNair",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "10",
    "name": "Ron Caldwell",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "48",
    "name": "Ryan Rose",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "23",
    "name": "Scott Flippo",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "13",
    "name": "Scott Richardson",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "40",
    "name": "Shad Pearce",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "96",
    "name": "Sonia Barker",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "44",
    "name": "Stan Berry",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "8",
    "name": "Stephanie Flowers",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "56",
    "name": "Steve Magie",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "42",
    "name": "Stephen Meeks",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "3",
    "name": "Stetson Painter",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "3",
    "name": "Steve Crowell",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "37",
    "name": "Steve Hollowell",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "19",
    "name": "Steve Unger",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "27",
    "name": "Steven Walker",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "79",
    "name": "Tara Shephard",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "5",
    "name": "Terry Rice",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "74",
    "name": "Tippi McCullough",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "82",
    "name": "Tony Furman",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "72",
    "name": "Tracy Steele",
    "party": "D"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "2",
    "name": "Trey Steimel",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "Senate",
    "district": "35",
    "name": "Tyler Dees",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "98",
    "name": "Wade Andrews",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "39",
    "name": "Wayne Long",
    "party": "R"
  },
  {
    "state": "ar",
    "chamber": "House",
    "district": "50",
    "name": "Zack Gramlich",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "10",
    "name": "Aisha Wahab",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "39",
    "name": "Akilah Weber Pierson",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "66",
    "name": "Al Muratsuchi",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "24",
    "name": "Alex Lee",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "33",
    "name": "Ali Macedo",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "15",
    "name": "Anamarie Avila Farias",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "8",
    "name": "Angelique Ashby",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "14",
    "name": "Anna Caballero",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "25",
    "name": "Ash Kalra",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "68",
    "name": "Avelino Valencia",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "24",
    "name": "Ben Allen",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "48",
    "name": "Blanca Rubio",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "64",
    "name": "Blanca Pacheco",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "30",
    "name": "Bob Archuleta",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "40",
    "name": "Brian Jones",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "14",
    "name": "Buffy Wicks",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "75",
    "name": "Carl DeMaio",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "20",
    "name": "Caroline Menjivar",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "38",
    "name": "Catherine Blakespear",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "19",
    "name": "Catherine Stefani",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "4",
    "name": "Cecilia Aguiar-Curry",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "43",
    "name": "Celeste Rodriguez",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "2",
    "name": "Chris Rogers",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "3",
    "name": "Christopher Cabaldon",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "78",
    "name": "Chris Ward",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "60",
    "name": "Corey Jackson",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "73",
    "name": "Cottie Petrie-Norris",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "12",
    "name": "Damon Connolly",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "76",
    "name": "Darsh Patel",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "15",
    "name": "Dave Cortese",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "80",
    "name": "David Alvarez",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "8",
    "name": "David Tangipa",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "30",
    "name": "Dawn Addis",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "72",
    "name": "Diane Dixon",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "21",
    "name": "Diane Papan",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "31",
    "name": "Joaquin Arambula",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "29",
    "name": "Eloise Reyes",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "27",
    "name": "Esmeralda Soria",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "28",
    "name": "Gail Pellerin",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "47",
    "name": "Greg Wallis",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "37",
    "name": "Gregg Hart",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "9",
    "name": "Heath Flora",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "1",
    "name": "Heather Hadwick",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "27",
    "name": "Henry Stern",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "55",
    "name": "Isaac Bryan",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "42",
    "name": "Jacqui Irwin",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "45",
    "name": "James Ramos",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "3",
    "name": "James Gallagher",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "35",
    "name": "Jasmeet Bains",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "36",
    "name": "Jeff Gonzalez",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "5",
    "name": "Jerry McNerney",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "7",
    "name": "Jesse Arreguín",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "46",
    "name": "Jesse Gabriel",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "52",
    "name": "Jessica Caloza",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "5",
    "name": "Joe Patterson",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "41",
    "name": "John Harabedian",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "17",
    "name": "John Laird",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "62",
    "name": "José Solache",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "13",
    "name": "Josh Becker",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "7",
    "name": "Joshua Hoover",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "69",
    "name": "Josh Lowenthal",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "22",
    "name": "Juan Alanis",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "39",
    "name": "Juan Carrillo",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "71",
    "name": "Kate Sanchez",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "32",
    "name": "Kelly Seyarto",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "79",
    "name": "LaShae Sharp-Collins",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "35",
    "name": "Laura Richardson",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "74",
    "name": "Laurie Davies",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "33",
    "name": "Lena Gonzalez",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "58",
    "name": "Leticia Castillo",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "56",
    "name": "Lisa Calderon",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "20",
    "name": "Liz Ortega",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "28",
    "name": "Lola Smallwood-Cuevas",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "11",
    "name": "Lori Wilson",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "6",
    "name": "Maggy Krell",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "23",
    "name": "Marc Berman",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "26",
    "name": "María Elena Durazo",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "4",
    "name": "Marie Alvarado-Gil",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "54",
    "name": "Mark González",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "17",
    "name": "Matt Haney",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "1",
    "name": "Megan Dahle",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "16",
    "name": "Melissa Hurtado",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "18",
    "name": "Mia Bonta",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "53",
    "name": "Michelle Rodriguez",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "65",
    "name": "Mike Gipson",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "49",
    "name": "Mike Fong",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "2",
    "name": "Mike McGuire",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "21",
    "name": "Monique Limón",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "44",
    "name": "Nick Schultz",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "26",
    "name": "Patrick Ahrens",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "59",
    "name": "Phillip Chen",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "40",
    "name": "Pilar Schiavo",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "16",
    "name": "Rebecca Bauer-Kahan",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "13",
    "name": "Rhodesia Ransom",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "51",
    "name": "Rick Zbur",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "50",
    "name": "Robert Garcia",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "29",
    "name": "Robert Rivas",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "6",
    "name": "Roger Niello",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "19",
    "name": "Rosilicie Ochoa Bogh",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "31",
    "name": "Sabrina Cervantes",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "57",
    "name": "Sade Elhawary",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "25",
    "name": "Sasha Pérez",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "11",
    "name": "Scott Wiener",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "12",
    "name": "Shannon Grove",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "67",
    "name": "Sharon Quirk-Silva",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "32",
    "name": "Stan Ellis",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "10",
    "name": "Stephanie Nguyen",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "38",
    "name": "Steve Bennett",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "18",
    "name": "Steve Padilla",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "37",
    "name": "Steve Choi",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "22",
    "name": "Susan Rubio",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "23",
    "name": "Suzette Valladares",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "77",
    "name": "Tasha Boerner",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "34",
    "name": "Tom Umberg",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "9",
    "name": "Tim Grayson",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "61",
    "name": "Tina McKinnor",
    "party": "D"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "34",
    "name": "Tom Lackey",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "Senate",
    "district": "36",
    "name": "Tony Strickland",
    "party": "R"
  },
  {
    "state": "ca",
    "chamber": "House",
    "district": "70",
    "name": "Tri Ta",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "5",
    "name": "Alex Valdez",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "18",
    "name": "Amy Paschal",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "53",
    "name": "Andy Boesenecker",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "44",
    "name": "Tony Hartsook",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "23",
    "name": "Barbara Kirkmeyer",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "43",
    "name": "Bob Marshall",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "39",
    "name": "Brandi Bradley",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "27",
    "name": "Brianna Titone",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "1",
    "name": "Byron Pelton",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "48",
    "name": "Carlos Barron",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "14",
    "name": "Cathy Kipp",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "4",
    "name": "Cecelia Espenoza",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "37",
    "name": "Chad Clifford",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "16",
    "name": "Chris Kolker",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "56",
    "name": "Chris Richardson",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "6",
    "name": "Cleave Simpson",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "21",
    "name": "Dafna Michaelson Jenet",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "19",
    "name": "Dan Woog",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "63",
    "name": "Dusty Johnson",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "8",
    "name": "Dylan Roberts",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "61",
    "name": "Eliza Hamrick",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "57",
    "name": "Elizabeth Velasco",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "9",
    "name": "Emily Sirota",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "25",
    "name": "Faith Winter",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "38",
    "name": "Gretchen Rydin",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "29",
    "name": "Iman Jodeh",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "31",
    "name": "Jacque Phillips",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "33",
    "name": "James Coleman",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "41",
    "name": "Jamie Jackson",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "15",
    "name": "Janice Marchman",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "7",
    "name": "Janice Rich",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "20",
    "name": "Jarvis Caldwell",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "1",
    "name": "Javier Mabrey",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "26",
    "name": "Jeff Bridges",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "7",
    "name": "Jennifer Bacon",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "34",
    "name": "Jenny Willford",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "22",
    "name": "Jessie Danielson",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "30",
    "name": "John Carson",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "18",
    "name": "Judy Amabile",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "34",
    "name": "Julie Gonzales",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "13",
    "name": "Julie McCluskie",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "10",
    "name": "Junie Joseph",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "11",
    "name": "Karen McCormick",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "59",
    "name": "Katie Stewart",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "17",
    "name": "Katie Wallace",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "22",
    "name": "Ken DeGraaf",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "12",
    "name": "Kyle Brown",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "24",
    "name": "Kyle Mullica",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "10",
    "name": "Larry Liston",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "58",
    "name": "Larry Suckla",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "49",
    "name": "Lesley Smith",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "8",
    "name": "Lindsay Gilchrist",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "19",
    "name": "Lindsey Daugherty",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "20",
    "name": "Lisa Cutter",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "24",
    "name": "Lisa Feret",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "2",
    "name": "Lisa Frizell",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "35",
    "name": "Lorena García",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "65",
    "name": "Lori Sander",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "9",
    "name": "Lynda Zamora Wilson",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "42",
    "name": "Mandy Lindsay",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "32",
    "name": "Manny Rutinel",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "5",
    "name": "Marc Catlin",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "12",
    "name": "Marc Snyder",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "4",
    "name": "Mark Baisley",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "21",
    "name": "Mary Bradfield",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "31",
    "name": "Matt Ball",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "54",
    "name": "Matt Soper",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "62",
    "name": "Matt Martinez",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "45",
    "name": "Max Brooks",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "3",
    "name": "Meg Froelich",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "26",
    "name": "Meghan Lukens",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "36",
    "name": "Michael Carter",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "28",
    "name": "Mike Weissman",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "23",
    "name": "Monica Duran",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "40",
    "name": "Naquetta Ricks",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "3",
    "name": "Nick Hinrichsen",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "16",
    "name": "Rebecca Keltie",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "30",
    "name": "Rebekah Stewart",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "17",
    "name": "Regina English",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "55",
    "name": "Rick Taggart",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "32",
    "name": "Robert Rodriguez",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "35",
    "name": "Rod Pelton",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "51",
    "name": "Ron Weinberg",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "14",
    "name": "Rose Pugliese",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "64",
    "name": "Ryan Armagost",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "50",
    "name": "Ryan Gonzalez",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "15",
    "name": "Scott Bottoms",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "13",
    "name": "Scott Bright",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "6",
    "name": "Sean Camacho",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "29",
    "name": "Shannon Bird",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "28",
    "name": "Sheila Lieder",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "60",
    "name": "Stephanie Luck",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "2",
    "name": "Steven Woodrow",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "25",
    "name": "Tammy Story",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "46",
    "name": "Tisha Mauro",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "27",
    "name": "Tom Sullivan",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "Senate",
    "district": "11",
    "name": "Tony Exum",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "47",
    "name": "Ty Winter",
    "party": "R"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "33",
    "name": "William Lindstedt",
    "party": "D"
  },
  {
    "state": "co",
    "chamber": "House",
    "district": "52",
    "name": "Yara Zokaie",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "111",
    "name": "Aimee Berger-Girvalo",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "97",
    "name": "Al Paolillo",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "28",
    "name": "Amy Morrin Bello",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "113",
    "name": "Amy Romano",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "124",
    "name": "Andre Baker",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "44",
    "name": "Anne Dauphinais",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "135",
    "name": "Anne Hughes",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "39",
    "name": "Anthony Nolan",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "130",
    "name": "Antonio Felipe",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "131",
    "name": "Arnie Jensen",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "41",
    "name": "Aundré Bumgardner",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "122",
    "name": "Ben McGorty",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "67",
    "name": "Billy Buckbee",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "115",
    "name": "Bill Heffernan",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "25",
    "name": "Bob Duff",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "110",
    "name": "Bob Godfrey",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "15",
    "name": "Bobby Gibson",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "33",
    "name": "Brandon Chafee",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "45",
    "name": "Brian Lanoue",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "77",
    "name": "Cara Pavalock-D'Amato",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "59",
    "name": "Carol Hall",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "19",
    "name": "Cathy Osten",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "26",
    "name": "Ceci Maher",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "35",
    "name": "Chris Aniskovich",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "51",
    "name": "Chris Stewart",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "32",
    "name": "Christie Carpino",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "12",
    "name": "Christine Cohen",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "81",
    "name": "Chris Poulos",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "128",
    "name": "Christopher Rosario",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "145",
    "name": "Corey Paris",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "90",
    "name": "Craig Fishbein",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "133",
    "name": "Cristin McCarthy Vahey",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "40",
    "name": "Dan Gaiewski",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "26",
    "name": "Dave DeFronzo",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "87",
    "name": "Dave Yaccarino",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "123",
    "name": "Dave Rutigliano",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "5",
    "name": "Derek Slap",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "46",
    "name": "Derell Wilson",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "23",
    "name": "Devin Carney",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "143",
    "name": "Dominique Johnson",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "30",
    "name": "Donna Veach",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "47",
    "name": "Doug Dubitsky",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "2",
    "name": "Doug McCrory",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "146",
    "name": "Eilish Collins Main",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "17",
    "name": "Eleni DeGraw",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "24",
    "name": "Manny Sanchez",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "32",
    "name": "Eric Berthel",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "109",
    "name": "Farley Santos",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "118",
    "name": "Frank Smith",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "126",
    "name": "Fred Gee",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "80",
    "name": "Gale Mastrofrancesco",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "10",
    "name": "Gary Winfield",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "27",
    "name": "Gary Turco",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "12",
    "name": "Geoff Luxenberg",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "75",
    "name": "Geraldo Reyes",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "43",
    "name": "Greg Howard",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "54",
    "name": "Gregg Haddad",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "18",
    "name": "Heather Somers",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "151",
    "name": "Hector Arzeno",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "31",
    "name": "Henri Martin",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "10",
    "name": "Henry Genga",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "23",
    "name": "Herron Gaston",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "84",
    "name": "Hilda Santiago",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "144",
    "name": "Hubert Delany",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "34",
    "name": "Irene Haines",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "57",
    "name": "Jaime Foster",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "14",
    "name": "James Maroney",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "6",
    "name": "Jimmy Sánchez",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "13",
    "name": "Jan Hochadel",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "60",
    "name": "Jane Garibay",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "69",
    "name": "Jason Buchsbaum",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "13",
    "name": "Jason Doucette",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "21",
    "name": "Jason Perillo",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "9",
    "name": "Jason Rojas",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "63",
    "name": "Jay Case",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "35",
    "name": "Jeff Gordon",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "132",
    "name": "Jenn Leeper",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "31",
    "name": "Jill Barry",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "18",
    "name": "Jillian Gilchrest",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "15",
    "name": "Joan Hartley",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "65",
    "name": "Joe Canino",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "78",
    "name": "Joe Hoxha",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "68",
    "name": "Joe Polletta",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "7",
    "name": "John Kissel",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "76",
    "name": "John Piscopo",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "101",
    "name": "John-Michael Parker",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "58",
    "name": "John Santanella",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "1",
    "name": "John Fonfara",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "83",
    "name": "Jack Fazzino",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "148",
    "name": "Jonathan Jacobson",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "136",
    "name": "Jonathan Steinberg",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "17",
    "name": "Jorge Cabrera",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "99",
    "name": "Joe Zullo",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "121",
    "name": "Joe Gresko",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "88",
    "name": "Josh Elliott",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "7",
    "name": "Joshua Hall",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "95",
    "name": "Juan Candelaria",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "24",
    "name": "Julie Kushner",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "4",
    "name": "Julio Concepción",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "137",
    "name": "Kadeem Roberts",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "100",
    "name": "Kai Belton",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "120",
    "name": "Kaitlyn Shake",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "104",
    "name": "Kara Rochelle",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "66",
    "name": "Karen Reddington-Hughes",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "20",
    "name": "Kate Farrar",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "119",
    "name": "Kathy Kennedy",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "138",
    "name": "Ken Gucker",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "29",
    "name": "Kerry Wood",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "56",
    "name": "Kevin Brown",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "139",
    "name": "Kevin Ryan",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "52",
    "name": "Kurt Vail",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "72",
    "name": "Larry Butler",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "91",
    "name": "Laurie Sweet",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "89",
    "name": "Lezlye Zupkus",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "103",
    "name": "Liz Linehan",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "142",
    "name": "Lucy Dathan",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "4",
    "name": "M.D. Rahman",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "117",
    "name": "M.J. Shannon",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "29",
    "name": "Mae Flexer",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "127",
    "name": "Marcus Brown",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "64",
    "name": "Maria Horn",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "48",
    "name": "Mark DeCaprio",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "62",
    "name": "Mark Anderson",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "20",
    "name": "Martha Marx",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "11",
    "name": "Martin Looney",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "107",
    "name": "Marty Foncello",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "79",
    "name": "Mary Fortier",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "85",
    "name": "Mary Mushinsky",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "114",
    "name": "Mary Welander",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "5",
    "name": "Maryam Khan",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "147",
    "name": "Matt Blumenthal",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "9",
    "name": "Matt Lesser",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "1",
    "name": "Matthew Ritter",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "16",
    "name": "Melissa Osborne",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "82",
    "name": "Michael Quinn",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "74",
    "name": "Michael DiGiovancarlo",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "21",
    "name": "Mike Demicco",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "3",
    "name": "Minnie Gonzalez",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "106",
    "name": "Mitch Bolinsky",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "98",
    "name": "Moira Rader",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "38",
    "name": "Nick Gauthier",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "37",
    "name": "Nick Menapace",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "105",
    "name": "Nicole Klarides-Ditria",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "33",
    "name": "Norm Needleman",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "92",
    "name": "Pat Dillon",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "27",
    "name": "Pat Miller",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "11",
    "name": "Patrick Biggins",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "108",
    "name": "Pat Callahan",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "50",
    "name": "Pat Boyd",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "34",
    "name": "Paul Cicarella",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "8",
    "name": "Paul Honig",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "2",
    "name": "Raghib Allie-Brennan",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "22",
    "name": "Rebecca Martinez",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "36",
    "name": "Renee Muir",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "6",
    "name": "Rick Lopes",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "16",
    "name": "Rob Sampson",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "25",
    "name": "Bobby Sanchez",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "102",
    "name": "Robin Comey",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "96",
    "name": "Roland Lemar",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "73",
    "name": "Ron Napoli",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "36",
    "name": "Ryan Fazio",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "134",
    "name": "Sarah Keitt",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "3",
    "name": "Saud Anwar",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "42",
    "name": "Savet Constantine",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "70",
    "name": "Seth Bronko",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "30",
    "name": "Stephen Harding",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "150",
    "name": "Steve Meskers",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "55",
    "name": "Steve Weir",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "129",
    "name": "Steve Stafstrom",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "94",
    "name": "Steven Winter",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "22",
    "name": "Sujata Gadkar-Wilcox",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "49",
    "name": "Susan Johnson",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "61",
    "name": "Tami Zawistowski",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "53",
    "name": "Tammy Nuccio",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "19",
    "name": "Tammy Exum",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "8",
    "name": "Tim Ackert",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "149",
    "name": "Tina Courpas",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "14",
    "name": "Tom Delnicki",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "125",
    "name": "Tom O'Dea",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "93",
    "name": "Toni Walker",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "Senate",
    "district": "28",
    "name": "Tony Hwang",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "112",
    "name": "Tony Scott",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "141",
    "name": "Tracy Marra",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "140",
    "name": "Travis Simms",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "116",
    "name": "Treneé McGee",
    "party": "D"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "86",
    "name": "Vincent Candelora",
    "party": "R"
  },
  {
    "state": "ct",
    "chamber": "House",
    "district": "71",
    "name": "Bill Pizzuto",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "19",
    "name": "Brian Pettyjohn",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "11",
    "name": "Bryan Townsend",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "36",
    "name": "Bryan Shupe",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "21",
    "name": "Bryant Richardson",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "33",
    "name": "Charles Postles",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "14",
    "name": "Claire Snyder-Hall",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "25",
    "name": "Cyndie Romer",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "1",
    "name": "Dan Cruce",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "39",
    "name": "Danny Short",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "2",
    "name": "Darius Brown",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "15",
    "name": "Dave Lawson",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "18",
    "name": "Dave Wilson",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "8",
    "name": "Dave Sokola",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "13",
    "name": "DeShanna Neal",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "6",
    "name": "Debra Heffernan",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "24",
    "name": "Ed Osienski",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "16",
    "name": "Eric Buckson",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "27",
    "name": "Eric Morrison",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "21",
    "name": "Frank Burns",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "16",
    "name": "Frank Cooke",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "20",
    "name": "Gerald Hocker",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "4",
    "name": "Jeff Hilovsky",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "11",
    "name": "Jeff Spiegelman",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "35",
    "name": "Jesse Vanderwende",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "9",
    "name": "Jack Walsh",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "3",
    "name": "Josue Ortega",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "15",
    "name": "Kam Smith",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "5",
    "name": "Kendra Johnson",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "32",
    "name": "Kerri Harris",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "9",
    "name": "Kevin Hensley",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "19",
    "name": "Kim Williams",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "12",
    "name": "Krista Griffith",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "14",
    "name": "Kyra Hoffner",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "7",
    "name": "Larry Lambert",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "4",
    "name": "Laura Sturgeon",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "34",
    "name": "Lyndon Yearick",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "26",
    "name": "Madinah Wilson-Anton",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "23",
    "name": "Mara Gorman",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "13",
    "name": "Marie Pinkney",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "10",
    "name": "Melanie Ross Levin",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "17",
    "name": "Melissa Minor-Brown",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "22",
    "name": "Mike Smith",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "12",
    "name": "Nicole Poore",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "1",
    "name": "Nnamdi Chukwuocha",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "5",
    "name": "Ray Seigfried",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "41",
    "name": "Rich Collins",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "38",
    "name": "Ron Gray",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "6",
    "name": "Russ Huxtable",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "3",
    "name": "Tizzy Lockman",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "31",
    "name": "Sean Lynn",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "8",
    "name": "Rae Moore",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "18",
    "name": "Sophie Phillips",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "7",
    "name": "Spiros Mantzavinos",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "10",
    "name": "Stephanie Hansen",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "2",
    "name": "Stephanie Bolden",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "40",
    "name": "Tim Dukes",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "Senate",
    "district": "17",
    "name": "Trey Paradee",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "37",
    "name": "Valerie Giltner",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "30",
    "name": "Shannon Morris",
    "party": "R"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "29",
    "name": "Bill Bush",
    "party": "D"
  },
  {
    "state": "de",
    "chamber": "House",
    "district": "28",
    "name": "Bill Carson",
    "party": "D"
  },
  {
    "state": "dc",
    "chamber": "House",
    "district": "Ward 1",
    "name": "Brianne Nadeau",
    "party": "D"
  },
  {
    "state": "dc",
    "chamber": "House",
    "district": "Ward 2",
    "name": "Brooke Pinto",
    "party": "D"
  },
  {
    "state": "dc",
    "chamber": "House",
    "district": "Ward 6",
    "name": "Charles Allen",
    "party": "D"
  },
  {
    "state": "dc",
    "chamber": "House",
    "district": "Ward 4",
    "name": "Janeese Lewis George",
    "party": "D"
  },
  {
    "state": "dc",
    "chamber": "House",
    "district": "Ward 3",
    "name": "Matt Frumin",
    "party": "D"
  },
  {
    "state": "dc",
    "chamber": "House",
    "district": "Chairman",
    "name": "Phil Mendelson",
    "party": "D"
  },
  {
    "state": "dc",
    "chamber": "House",
    "district": "Ward 7",
    "name": "Wendell Felder",
    "party": "D"
  },
  {
    "state": "dc",
    "chamber": "House",
    "district": "Ward 5",
    "name": "Zachary Parker",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "57",
    "name": "Adam Anderson",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "80",
    "name": "Adam Botana",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "112",
    "name": "Alex Rizo",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "38",
    "name": "Alexis Calatayud",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "9",
    "name": "Allison Tant",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "40",
    "name": "Ana Maria Rodriguez",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "13",
    "name": "Angie Nixon",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "42",
    "name": "Anna Eskamani",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "93",
    "name": "Anne Gerwig",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "109",
    "name": "Ashley Gantt",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "35",
    "name": "Barbara Sharief",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "27",
    "name": "Ben Albritton",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "59",
    "name": "Berny Jacques",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "72",
    "name": "Bill Conerly",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "28",
    "name": "Bill Partington",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "11",
    "name": "Blaise Ingoglia",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "56",
    "name": "Brad Yeager",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "32",
    "name": "Brian Hodgers",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "41",
    "name": "Bruce Antone",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "39",
    "name": "Bryan Ávila",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "17",
    "name": "Carlos Smith",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "22",
    "name": "Chad Johnson",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "30",
    "name": "Chase Tramont",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "100",
    "name": "Chip LaMarca",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "95",
    "name": "Christine Hunschofsky",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "4",
    "name": "Clay Yarborough",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "12",
    "name": "Colleen Burton",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "3",
    "name": "Corey Simon",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "96",
    "name": "Dan Daley",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "84",
    "name": "Dana Trabulsy",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "69",
    "name": "Danny Alvarez",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "116",
    "name": "Daniel Perez",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "23",
    "name": "Danny Burgess",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "75",
    "name": "Danny Nix",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "16",
    "name": "Darryl Rouson",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "99",
    "name": "Daryl Campbell",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "111",
    "name": "David Borrero",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "38",
    "name": "Dave Smith",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "15",
    "name": "Dean Black",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "19",
    "name": "Debbie Mayfield",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "89",
    "name": "Debra Tendrich",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "114",
    "name": "Demi Busatta",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "63",
    "name": "Dianne Hart",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "1",
    "name": "Don Gaetz",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "108",
    "name": "Dotie Joseph",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "39",
    "name": "Doug Bankson",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "21",
    "name": "Ed Hooper",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "35",
    "name": "Erika Booth",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "29",
    "name": "Erin Grall",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "106",
    "name": "Fabián Basabe",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "104",
    "name": "Felicia Robinson",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "67",
    "name": "Fentrice Driskell",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "73",
    "name": "Fiona McFarland",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "8",
    "name": "Gallop Franklin",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "31",
    "name": "Gayle Harrell",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "101",
    "name": "Hillary Cassel",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "36",
    "name": "Ileana Garcia",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "23",
    "name": "J.J. Grow",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "74",
    "name": "James Buchanan",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "120",
    "name": "Jim Mooney",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "10",
    "name": "Jason Brodeur",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "7",
    "name": "Jason Shoaf",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "37",
    "name": "Jason Pizzo",
    "party": "I"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "14",
    "name": "Jay Collins",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "2",
    "name": "Jay Trumbull",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "53",
    "name": "Jeff Holcomb",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "78",
    "name": "Jenna Persons-Mulicka",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "6",
    "name": "Jennifer Bradley",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "50",
    "name": "Jennifer Canady",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "49",
    "name": "Jennifer Kincart Jonsson",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "44",
    "name": "Rita Harris",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "88",
    "name": "Tae Edmonds",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "17",
    "name": "Jessica Baker",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "20",
    "name": "Jim Boyd",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "22",
    "name": "Joe Gruters",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "43",
    "name": "Johanna López",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "52",
    "name": "John Temple",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "86",
    "name": "John Snyder",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "48",
    "name": "Jon Albert",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "33",
    "name": "Jonathan Martin",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "46",
    "name": "Jose Alvarez",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "90",
    "name": "Joe Casello",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "51",
    "name": "Josie Tomkow",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "119",
    "name": "Juan Porras",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "20",
    "name": "Judson Sapp",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "65",
    "name": "Karen Gonzalez Pittman",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "28",
    "name": "Kathleen Passidomo",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "83",
    "name": "Kaylee Tuck",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "13",
    "name": "Keith Truenow",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "92",
    "name": "Kelly Skidmore",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "117",
    "name": "Kevin Chambliss",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "55",
    "name": "Kevin Steele",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "18",
    "name": "Kim Kendall",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "58",
    "name": "Kim Berfield",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "14",
    "name": "Kim Daniels",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "16",
    "name": "Kiyan Michael",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "25",
    "name": "Kristen Arrington",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "40",
    "name": "LaVon Bracy Davis",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "82",
    "name": "Lauren Melo",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "68",
    "name": "Lawrence McClure",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "45",
    "name": "Leonard Spencer",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "61",
    "name": "Linda Chaney",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "60",
    "name": "Lindsay Cross",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "97",
    "name": "Lisa Dunkley",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "26",
    "name": "Lori Berman",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "24",
    "name": "Mack Bernard",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "105",
    "name": "Marie Woodson",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "94",
    "name": "Meg Weinberger",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "87",
    "name": "Mike Caruso",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "102",
    "name": "Mike Gottlieb",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "70",
    "name": "Michael Owen",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "62",
    "name": "Michele Rayner",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "1",
    "name": "Michelle Salzman",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "79",
    "name": "Mike Giallombardo",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "118",
    "name": "Mike Redondo",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "98",
    "name": "Mitch Rosenwald",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "33",
    "name": "Monique Miller",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "26",
    "name": "Nan Cobb",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "3",
    "name": "Nathan Boyles",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "18",
    "name": "Nick DiCeglie",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "115",
    "name": "Omar Blanco",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "47",
    "name": "Paula Stark",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "91",
    "name": "Peggy Gossett-Seidman",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "6",
    "name": "Griff Griffitts",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "36",
    "name": "Rachel Plakon",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "54",
    "name": "Randy Maggard",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "27",
    "name": "Richard Gentry",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "34",
    "name": "Robbie Brackett",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "2",
    "name": "Alex Andrade",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "10",
    "name": "Chuck Brannan",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "103",
    "name": "Robin Bartleman",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "32",
    "name": "Rosalind Osgood",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "24",
    "name": "Ryan Chamberlin",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "11",
    "name": "Sam Garrison",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "19",
    "name": "Sam Greco",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "5",
    "name": "Shane Abbott",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "34",
    "name": "Shev Jones",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "9",
    "name": "Stan McClain",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "64",
    "name": "Susan Valdés",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "37",
    "name": "Susan Plasencia",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "25",
    "name": "Taylor Yarkosky",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "7",
    "name": "Tom Leek",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "4",
    "name": "Patt Maney",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "77",
    "name": "Tiffany Esposito",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "30",
    "name": "Tina Polsky",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "85",
    "name": "Toby Overdorf",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "8",
    "name": "Tommy Wright",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "110",
    "name": "Tom Fabricio",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "66",
    "name": "Traci Koster",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "Senate",
    "district": "5",
    "name": "Tracie Davis",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "31",
    "name": "Tyler Sirois",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "76",
    "name": "Vanessa Oliver",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "113",
    "name": "Vicki Lopez",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "107",
    "name": "Wallace Aristide",
    "party": "D"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "29",
    "name": "Webster Barnaby",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "71",
    "name": "Will Robinson",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "12",
    "name": "Wyman Duggan",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "81",
    "name": "Yvette Benarroch",
    "party": "R"
  },
  {
    "state": "fl",
    "chamber": "House",
    "district": "21",
    "name": "Yvonne Hinson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "168",
    "name": "Al Williams",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "33",
    "name": "Alan Powell",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "91",
    "name": "Angela Moore",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "169",
    "name": "Angie O'Steen",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "163",
    "name": "Anne Westbrook",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "96",
    "name": "Arlene Beckles",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "1",
    "name": "Ben Watson",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "135",
    "name": "Beth Camp",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "147",
    "name": "Bethany Ballard",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "54",
    "name": "Betsy Holland",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "46",
    "name": "Bill Cowsert",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "161",
    "name": "Bill Hitchens",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "157",
    "name": "Bill Werkheiser",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "152",
    "name": "Bill Yearta",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "4",
    "name": "Billy Hickman",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "88",
    "name": "Billy Mitchell",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "19",
    "name": "Blake Tillery",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "50",
    "name": "Bo Hatchett",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "21",
    "name": "Brad Thomas",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "28",
    "name": "Brent Cox",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "132",
    "name": "Brian Prince",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "42",
    "name": "Brian Strickland",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "112",
    "name": "Bruce Williamson",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "56",
    "name": "Bryce Berry",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "167",
    "name": "Buddy DeLoach",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "158",
    "name": "Butch Parrish",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "13",
    "name": "Carden Summers",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "162",
    "name": "Carl Gilliard",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "139",
    "name": "Carmen Rice",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "141",
    "name": "Carolyn Hugley",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "24",
    "name": "Carter Barrett",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "172",
    "name": "Chas Cannon",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "20",
    "name": "Charlice Byrd",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "32",
    "name": "Chris Erwin",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "49",
    "name": "Chuck Martin",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "104",
    "name": "Chuck Efstration",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "52",
    "name": "Chuck Hufstetler",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "54",
    "name": "Chuck Payne",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "118",
    "name": "Clint Crowe",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "45",
    "name": "Clint Dixon",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "53",
    "name": "Colton Moore",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "144",
    "name": "Dale Washburn",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "133",
    "name": "Danny Mathis",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "173",
    "name": "Darlene Taylor",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "95",
    "name": "Dar'shun Kendrick",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "100",
    "name": "David Clark",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "72",
    "name": "David Huddleston",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "136",
    "name": "David Jenkins",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "26",
    "name": "David Lucas",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "153",
    "name": "David Sampson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "38",
    "name": "David Wilkerson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "137",
    "name": "Debbie Buckner",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "53",
    "name": "Deborah Silcox",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "69",
    "name": "Debra Bazemore",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "78",
    "name": "Demetrius Douglas",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "2",
    "name": "Derek Mallow",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "68",
    "name": "Derrick Jackson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "30",
    "name": "Derrick McCollum",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "34",
    "name": "Devan Seabaugh",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "109",
    "name": "Dewey McClain",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "177",
    "name": "Dexter Sharper",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "44",
    "name": "Don Parsons",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "28",
    "name": "Donzella James",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "93",
    "name": "Doreen Carter",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "49",
    "name": "Drew Echols",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "15",
    "name": "Ed Harbison",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "37",
    "name": "Ed Setzler",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "12",
    "name": "Eddie Lumsden",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "165",
    "name": "Edna Jackson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "116",
    "name": "El-Mahdi Holly",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "44",
    "name": "Elena Parent",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "10",
    "name": "Emanuel Jones",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "31",
    "name": "Emory Dunahoo",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "75",
    "name": "Eric Bell",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "51",
    "name": "Esther Panitch",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "149",
    "name": "Floyd Griffin",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "47",
    "name": "Frank Ginn",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "12",
    "name": "Freddie Sims",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "102",
    "name": "Gabe Okoye",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "42",
    "name": "Gabriel Sanchez",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "17",
    "name": "Gail Davenport",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "125",
    "name": "Gary Richardson",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "154",
    "name": "Gerald Greene",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "36",
    "name": "Ginny Ehrhart",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "27",
    "name": "Greg Dolezal",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "22",
    "name": "Harold Jones",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "119",
    "name": "Holt Persinger",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "120",
    "name": "Houston Gaines",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "86",
    "name": "Imani Barnes",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "55",
    "name": "Inga Willis",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "170",
    "name": "Jaclyn Ford",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "176",
    "name": "James Burchett",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "47",
    "name": "Jan Jones",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "108",
    "name": "Jasmine Clark",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "31",
    "name": "Jason Anavitarte",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "35",
    "name": "Jason Esteves",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "6",
    "name": "Jason Ridley",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "166",
    "name": "Jesse Petrea",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "171",
    "name": "Joe Campbell",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "56",
    "name": "John Albers",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "46",
    "name": "John Carson",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "174",
    "name": "John Corbett",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "18",
    "name": "John Kennedy",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "175",
    "name": "John LaHood",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "7",
    "name": "Johnny Chastain",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "159",
    "name": "Jon Burns",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "22",
    "name": "Jordan Ridley",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "19",
    "name": "Joseph Gullett",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "73",
    "name": "Josh Bonner",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "14",
    "name": "Josh McLaurin",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "71",
    "name": "Jutt Howard",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "94",
    "name": "Karen Bennett",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "83",
    "name": "Karen Lupton",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "82",
    "name": "Karen Mathiak",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "85",
    "name": "Karla Drenner",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "129",
    "name": "Karlton Howard",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "4",
    "name": "Kasey Carpenter",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "13",
    "name": "Katie Dempsey",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "32",
    "name": "Kay Kirkpatrick",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "34",
    "name": "Kenya Wicks",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "41",
    "name": "Kim Jackson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "63",
    "name": "Kim Schofield",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "66",
    "name": "Kimberly Alexander",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "40",
    "name": "Kimberly New",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "126",
    "name": "L.C. Myles",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "20",
    "name": "Larry Walker",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "26",
    "name": "Lauren McDonald",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "24",
    "name": "Lee Anderson",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "27",
    "name": "Lee Hawkins",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "156",
    "name": "Leesa Hagan",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "160",
    "name": "Lehman Franklin",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "35",
    "name": "Lisa Campbell",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "80",
    "name": "Long Tran",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "67",
    "name": "Lydia Glaize",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "130",
    "name": "Lynn Heffner",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "70",
    "name": "Lynn Smith",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "128",
    "name": "Mack Jackson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "23",
    "name": "Mandi Ballinger",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "121",
    "name": "Marcus Wiedower",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "127",
    "name": "Mark Newton",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "17",
    "name": "Martin Momtahan",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "16",
    "name": "Marty Harbin",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "98",
    "name": "Marvin Lim",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "117",
    "name": "Mary Ann Santos",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "37",
    "name": "Mary Frances Williams",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "84",
    "name": "Mary Margaret Oliver",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "5",
    "name": "Matt Barton",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "6",
    "name": "Matt Brass",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "29",
    "name": "Matt Dubnik",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "155",
    "name": "Matt Hatchett",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "99",
    "name": "Matt Reeves",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "15",
    "name": "Matthew Gambill",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "23",
    "name": "Max Burns",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "61",
    "name": "Mekyah McQueen",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "33",
    "name": "Doc Rhett",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "41",
    "name": "Michael Smith",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "50",
    "name": "Michelle Au",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "1",
    "name": "Mike Cameron",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "151",
    "name": "Mike Cheokas",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "3",
    "name": "Mike Hodges",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "142",
    "name": "Miriam Paris",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "3",
    "name": "Mitchell Horner",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "14",
    "name": "Mitchell Scoggins",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "7",
    "name": "Nabilah Islam Parkes",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "36",
    "name": "Nan Orrock",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "9",
    "name": "Nikki Merritt",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "143",
    "name": "Nissa Jones",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "148",
    "name": "Noel Williams",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "81",
    "name": "Noelle Kahaian",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "89",
    "name": "Omari Crawford",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "58",
    "name": "Park Cannon",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "150",
    "name": "Patty Marie Stinson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "59",
    "name": "Phil Olaleye",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "55",
    "name": "Randal Mangham",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "29",
    "name": "Randy Robertson",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "38",
    "name": "RaShaun Kemp",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "115",
    "name": "Regina Lewis-Ward",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "111",
    "name": "Rey Martinez",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "77",
    "name": "Rhonda Burnough",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "92",
    "name": "Rhonda Taylor",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "11",
    "name": "Rick Jasperse",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "179",
    "name": "Rick Townsend",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "25",
    "name": "Rick Williams",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "131",
    "name": "Rob Clifton",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "123",
    "name": "Rob Leverett",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "65",
    "name": "Robert Dawson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "134",
    "name": "Robert Dickey",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "74",
    "name": "Robert Flournoy",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "164",
    "name": "Ron Stephens",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "8",
    "name": "Russ Goodman",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "97",
    "name": "Ruwa Romman",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "90",
    "name": "Saira Draper",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "40",
    "name": "Sally Harrell",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "107",
    "name": "Sam Park",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "11",
    "name": "Sam Watson",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "76",
    "name": "Sandra Scott",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "105",
    "name": "Sandy Donatucci",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "48",
    "name": "Scott Hilton",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "101",
    "name": "Scott Holcomb",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "110",
    "name": "Segun Adeyina",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "45",
    "name": "Sharon Cooper",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "113",
    "name": "Sharon Henderson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "146",
    "name": "Shaw Blackmon",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "48",
    "name": "Shawn Still",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "52",
    "name": "Shea Roberts",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "5",
    "name": "Sheikh Rahman",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "60",
    "name": "Sheila Jones",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "106",
    "name": "Shelly Hutchinson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "43",
    "name": "Solomon Adesanya",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "39",
    "name": "Sonya Halpern",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "103",
    "name": "Soo Hong",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "122",
    "name": "Spencer Frye",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "57",
    "name": "Stacey Evans",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "8",
    "name": "Stan Gunter",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "51",
    "name": "Steve Gooch",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "2",
    "name": "Steve Tarvin",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "178",
    "name": "Steven Meeks",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "180",
    "name": "Steven Sainz",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "64",
    "name": "Sylvia Wayfer",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "145",
    "name": "Tangie Herring",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "62",
    "name": "Tanya Miller",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "39",
    "name": "Terry Cummings",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "30",
    "name": "Tim Bearden",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "114",
    "name": "Tim Fleming",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "25",
    "name": "Todd Jones",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "Senate",
    "district": "43",
    "name": "Tonya Anderson",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "140",
    "name": "Teddy Reese",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "16",
    "name": "Trey Kelley",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "124",
    "name": "Trey Rhodes",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "18",
    "name": "Tyler Smith",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "138",
    "name": "Vance Smith",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "10",
    "name": "Victor Anderson",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "87",
    "name": "Viola Davis",
    "party": "D"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "9",
    "name": "Will Wade",
    "party": "R"
  },
  {
    "state": "ga",
    "chamber": "House",
    "district": "79",
    "name": "Yasmin Neal",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "24",
    "name": "Adrian Tam",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "46",
    "name": "Amy Perruso",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "22",
    "name": "Andrew Garrett",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "6",
    "name": "Angus McKelvey",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "16",
    "name": "Brandon Elefante",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "23",
    "name": "Brenton Awa",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "11",
    "name": "Carol Fukunaga",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "25",
    "name": "Chris Lee",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "45",
    "name": "Chris Muraoka",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "3",
    "name": "Chris Todd",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "35",
    "name": "Cory Chun",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "28",
    "name": "Daniel Holt",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "44",
    "name": "Darius Kila",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "8",
    "name": "David Tarnas",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "41",
    "name": "David Alcos",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "17",
    "name": "Dee Morikawa",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "26",
    "name": "Della Belatti",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "42",
    "name": "Diamond Garcia",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "14",
    "name": "Donna Kim",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "17",
    "name": "Donovan Dela Cruz",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "3",
    "name": "Dru Kanuha",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "39",
    "name": "Elijah Pierick",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "14",
    "name": "Elle Cochran",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "32",
    "name": "Garner Shimizu",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "15",
    "name": "Glenn Wakai",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "34",
    "name": "Gregg Takayama",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "4",
    "name": "Greggor Ilagan",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "19",
    "name": "Henry Aquino",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "4",
    "name": "Tim Richards",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "29",
    "name": "Ikaika Hussey",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "23",
    "name": "Ikaika Olds",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "21",
    "name": "Jackson Sayama",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "24",
    "name": "Jarrett Keohokalole",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "5",
    "name": "Jeanné Kapela",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "27",
    "name": "Jenna Takenouchi",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "18",
    "name": "Joe Gedeon",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "2",
    "name": "Joy San Buenaventura",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "40",
    "name": "Julie Reyes Oda",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "9",
    "name": "Justin Woodson",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "43",
    "name": "Kanani Souza",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "13",
    "name": "Karl Rhoads",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "25",
    "name": "Kim Coco Iwamoto",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "6",
    "name": "Kirstin Kahaloa",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "20",
    "name": "Kurt Fevella",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "12",
    "name": "Kyle Yamashita",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "38",
    "name": "Lauren Matsumoto",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "10",
    "name": "Les Ihara",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "31",
    "name": "Linda Ichiyama",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "48",
    "name": "Lisa Kitagawa",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "51",
    "name": "Lisa Marten",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "1",
    "name": "Lorraine Inouye",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "16",
    "name": "Luke Evslin",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "7",
    "name": "Lynn DeCoite",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "13",
    "name": "Mahina Poepoe",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "19",
    "name": "Mark Hashem",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "1",
    "name": "Matthias Kusch",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "18",
    "name": "Michelle Kidani",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "21",
    "name": "Mike Gabbard",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "50",
    "name": "Mike Lee",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "15",
    "name": "Nadine Nakamura",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "7",
    "name": "Nicole Lowen",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "36",
    "name": "Rachele Lamosao",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "8",
    "name": "Ron Kouchi",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "33",
    "name": "Sam Kong",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "22",
    "name": "Samantha DeCorte",
    "party": "R"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "49",
    "name": "Scot Matayoshi",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "47",
    "name": "Sean Quinlan",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "12",
    "name": "Sharon Moriwaki",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "30",
    "name": "Shirley Templo",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "9",
    "name": "Stanley Chang",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "2",
    "name": "Sue Lee Loy",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "11",
    "name": "Terez Amato",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "20",
    "name": "Tina Grandinetti",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "37",
    "name": "Trish La Chica",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "Senate",
    "district": "5",
    "name": "Troy Hashimoto",
    "party": "D"
  },
  {
    "state": "hi",
    "chamber": "House",
    "district": "10",
    "name": "Tyson Miyake",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "16",
    "name": "Ali Rabe",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "33A",
    "name": "Barbara Ehardt",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "12",
    "name": "Ben Adams",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "30B",
    "name": "Ben Fuhriman",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "4",
    "name": "Ben Toews",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "6B",
    "name": "Brandon Mitchell",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "9",
    "name": "Brandon Shippy",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "13A",
    "name": "Brent Crane",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "13",
    "name": "Brian Lenney",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "34B",
    "name": "Britt Raybould",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "18B",
    "name": "Brooke Green",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "10B",
    "name": "Bruce Skaug",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "14",
    "name": "Scott Grow",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "11",
    "name": "Camille Blaylock",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "5",
    "name": "Carl Bjerke",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "17",
    "name": "Carrie Semmelroth",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "7B",
    "name": "Charlie Shepherd",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "23A",
    "name": "Chris Bruce",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "19B",
    "name": "Chris Mathias",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "8",
    "name": "Christy Zito",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "7",
    "name": "Cindy Carlson",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "27B",
    "name": "Clay Handy",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "24A",
    "name": "Clint Hostetler",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "15",
    "name": "Codi Galloway",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "1B",
    "name": "Cornel Rasor",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "2B",
    "name": "Dale Hawkins",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "28B",
    "name": "Dan Garner",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "6",
    "name": "Dan Foreman",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "33",
    "name": "Dave Lent",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "25B",
    "name": "David Leavitt",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "30A",
    "name": "David Cannon",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "15B",
    "name": "Dori Healey",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "3",
    "name": "Doug Okuniewicz",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "34",
    "name": "Doug Ricks",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "27A",
    "name": "Doug Pickett",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "29A",
    "name": "Dustin Manwaring",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "14A",
    "name": "Ted Hill",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "4B",
    "name": "Elaine Price",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "8B",
    "name": "Faye Thompson",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "24",
    "name": "Glenneda Zuiderveld",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "2A",
    "name": "Heather Scott",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "18A",
    "name": "Ilana Rubel",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "26B",
    "name": "Jack Nelsen",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "29",
    "name": "James Ruchti",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "20B",
    "name": "James Holtzclaw",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "21A",
    "name": "James Petzke",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "18",
    "name": "Janie Ward-Engelking",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "12B",
    "name": "Jaron Crane",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "22B",
    "name": "Jason Monks",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "21B",
    "name": "Jeff Ehlers",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "12A",
    "name": "Jeff Cornilles",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "31A",
    "name": "Jerald Raymond",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "28",
    "name": "Jim Guthrie",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "1",
    "name": "Jim Woodward",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "4A",
    "name": "Joe Alfieri",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "20A",
    "name": "Joe Palmer",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "17A",
    "name": "John Gannon",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "9A",
    "name": "John Shirts",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "22A",
    "name": "John Vander Woude",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "34A",
    "name": "Jon Weber",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "3B",
    "name": "Jordan Redman",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "20",
    "name": "Josh Keyser",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "25",
    "name": "Josh Kohl",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "14B",
    "name": "Josh Tanner",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "35B",
    "name": "Josh Wheeler",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "9B",
    "name": "Judy Boyle",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "30",
    "name": "Julie VanOrden",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "27",
    "name": "Kelly Anthon",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "11A",
    "name": "Kent Marmon",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "35A",
    "name": "Kevin Andrus",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "32",
    "name": "Kevin Cook",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "7A",
    "name": "Kyle Harris",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "25A",
    "name": "Lance Clow",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "22",
    "name": "Lori Den Hartog",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "6A",
    "name": "Lori McCann",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "11B",
    "name": "Lucas Cayler",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "33B",
    "name": "Marco Erickson",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "35",
    "name": "Mark Harris",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "1A",
    "name": "Mark Sauter",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "17B",
    "name": "Megan Egbert",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "19",
    "name": "Melissa Wintrow",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "10A",
    "name": "Mike Moyle",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "26A",
    "name": "Mike Pohanka",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "19A",
    "name": "Monica Church",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "2",
    "name": "Phil Hart",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "28A",
    "name": "Rick Cheatum",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "8A",
    "name": "Rob Beiswenger",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "31B",
    "name": "Rod Furniss",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "26",
    "name": "Ron Taylor",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "5A",
    "name": "Ron Mendive",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "23B",
    "name": "Shawn Dygert",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "16A",
    "name": "Soñia Galaviz",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "32A",
    "name": "Stephanie Mickelsen",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "15A",
    "name": "Steve Berch",
    "party": "D"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "13B",
    "name": "Steve Tanner",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "24B",
    "name": "Steve Miller",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "10",
    "name": "Tammy Nichols",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "29B",
    "name": "Tanya Burgoyne",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "23",
    "name": "Todd Lakey",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "5B",
    "name": "Tony Wisniewski",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "21",
    "name": "Treg Bernt",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "Senate",
    "district": "31",
    "name": "Van Burtenshaw",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "3A",
    "name": "Vito Barbieri",
    "party": "R"
  },
  {
    "state": "id",
    "chamber": "House",
    "district": "32B",
    "name": "Wendy Horman",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "1",
    "name": "Aarón Ortíz",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "21",
    "name": "Abdelnasser Rashid",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "102",
    "name": "Adam Niemerg",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "30",
    "name": "Adriane Johnson",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "111",
    "name": "Amy Elik",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "47",
    "name": "Amy Grant",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "45",
    "name": "Andrew Chesney",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "22",
    "name": "Angelica Guerrero-Cuellar",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "11",
    "name": "Ann Williams",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "43",
    "name": "Anna Moeller",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "81",
    "name": "Anne Stava-Murray",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "80",
    "name": "Anthony DeLuca",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "50",
    "name": "Barbara Hernandez",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "110",
    "name": "Blaine Wilhour",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "58",
    "name": "Bob Morgan",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "107",
    "name": "Brad Halbrook",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "74",
    "name": "Brad Fritts",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "20",
    "name": "Brad Stephens",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "104",
    "name": "Brandun Schweizer",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "100",
    "name": "C.D. Davidsmeyer",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "78",
    "name": "Camille Lilly",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "103",
    "name": "Carol Ammons",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "12",
    "name": "Celina Villanueva",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "51",
    "name": "Chapin Rose",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "109",
    "name": "Charlie Meier",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "53",
    "name": "Chris Balkema",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "101",
    "name": "Chris Miller",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "57",
    "name": "Christopher Belt",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "32",
    "name": "Craig Wilcox",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "22",
    "name": "Cristina Castro",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "25",
    "name": "Curtis Tarver",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "85",
    "name": "Dee Avelar",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "59",
    "name": "Dale Fowler",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "65",
    "name": "Dan Ugaste",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "59",
    "name": "Dan Didech",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "71",
    "name": "Dan Swanson",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "26",
    "name": "Darby Hills",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "116",
    "name": "Dave Severin",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "35",
    "name": "Dave Syverson",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "68",
    "name": "Dave Vella",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "115",
    "name": "David Friess",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "46",
    "name": "Dave Koehler",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "38",
    "name": "Debbie Meyers-Martin",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "105",
    "name": "Dennis Tipsword",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "46",
    "name": "Diane Blair-Sherlock",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "39",
    "name": "Don Harmon",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "33",
    "name": "Don DeWitte",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "48",
    "name": "Doris Turner",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "23",
    "name": "Edgar González",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "17",
    "name": "Elgie Sims",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "2",
    "name": "Lisa Hernandez",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "7",
    "name": "Chris Welch",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "14",
    "name": "Emil Jones",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "56",
    "name": "Erica Harriss",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "3",
    "name": "Eva-Dina Delgado",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "44",
    "name": "Fred Crespo",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "20",
    "name": "Graciela Guzmán",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "72",
    "name": "Gregg Johnson",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "97",
    "name": "Harry Benton",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "13",
    "name": "Hoan Huynh",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "79",
    "name": "Jackie Haas",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "40",
    "name": "Jaime Andrade",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "41",
    "name": "Janet Yang Rohr",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "106",
    "name": "Jason Bunting",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "55",
    "name": "Jason Plummer",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "1",
    "name": "Javier Cervantes",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "10",
    "name": "Omar Williams",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "113",
    "name": "Jay Hoffman",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "75",
    "name": "Jed Davis",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "70",
    "name": "Jeff Keicher",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "92",
    "name": "Jehan Gordon-Booth",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "17",
    "name": "Jen Gong-Gershowitz",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "48",
    "name": "Jennifer Sanalitro",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "50",
    "name": "Jil Tracy",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "69",
    "name": "Joe Sosnowski",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "41",
    "name": "John Curran",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "90",
    "name": "John Cabello",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "61",
    "name": "Joyce Mason",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "29",
    "name": "Julie Morrison",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "27",
    "name": "Justin Slaughter",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "26",
    "name": "Kam Buckner",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "25",
    "name": "Karina Villa",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "112",
    "name": "Katie Stuart",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "14",
    "name": "Kelly Cassidy",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "16",
    "name": "Kevin Olickal",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "114",
    "name": "Kevin Schmidt",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "4",
    "name": "Kimberly Lightford",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "5",
    "name": "Kimberly Du Buclet",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "99",
    "name": "Kyle Moore",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "8",
    "name": "La Shawn Ford",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "5",
    "name": "Lakesia Collins",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "21",
    "name": "Laura Ellman",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "62",
    "name": "Laura Faver Dias",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "9",
    "name": "Laura Fine",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "28",
    "name": "Laura Murphy",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "86",
    "name": "Larry Walsh",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "37",
    "name": "Li Arellano",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "4",
    "name": "Lilian Jiménez",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "42",
    "name": "Linda Holmes",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "19",
    "name": "Lindsey LaPointe",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "32",
    "name": "Lisa Davis",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "33",
    "name": "Marcus Evans",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "12",
    "name": "Margaret Croke",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "27",
    "name": "Mark Walker",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "45",
    "name": "Marti Deuter",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "55",
    "name": "Marty Moylan",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "52",
    "name": "Marty McLaughlin",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "54",
    "name": "Mary Beth Canty",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "31",
    "name": "Mary Edly-Allen",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "35",
    "name": "Mary Gill",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "83",
    "name": "Matt Hanson",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "3",
    "name": "Mattie Hunter",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "49",
    "name": "Maura Hirschauer",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "67",
    "name": "Maurice West",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "49",
    "name": "Meg Loughran Cappel",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "19",
    "name": "Mike Hastings",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "36",
    "name": "Mike Halpin",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "95",
    "name": "Mike Coffey",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "15",
    "name": "Michael Kelly",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "56",
    "name": "Michelle Mussman",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "31",
    "name": "Mike Crawford",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "11",
    "name": "Mike Porfirio",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "7",
    "name": "Mike Simmons-Gessesse",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "76",
    "name": "Murri Briel",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "51",
    "name": "Nabeela Syed",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "15",
    "name": "Napoleon Harris",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "98",
    "name": "Natalie Manley",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "47",
    "name": "Neil Anderson",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "34",
    "name": "Nick Smith",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "82",
    "name": "Nicole La Ha",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "53",
    "name": "Nicolle Grasse",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "94",
    "name": "Norine Hammond",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "77",
    "name": "Norma Hernandez",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "2",
    "name": "Omar Aquino",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "40",
    "name": "Patrick Joyce",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "37",
    "name": "Patrick Sheehan",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "117",
    "name": "Patrick Windhorst",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "52",
    "name": "Paul Faraci",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "118",
    "name": "Paul Jacobs",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "43",
    "name": "Rachel Ventura",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "8",
    "name": "Ram Villivalam",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "88",
    "name": "Regan Deering",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "36",
    "name": "Rick Ryan",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "60",
    "name": "Rita Mayfield",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "10",
    "name": "Rob Martwick",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "13",
    "name": "Robert Peters",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "28",
    "name": "Bob Rita",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "18",
    "name": "Robyn Gabel",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "73",
    "name": "Ryan Spain",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "44",
    "name": "Sally Turner",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "6",
    "name": "Sara Feigenholtz",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "24",
    "name": "Seth Lewis",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "91",
    "name": "Sharon Chung",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "6",
    "name": "Sonya Harper",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "84",
    "name": "Stephanie Kifowit",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "54",
    "name": "Steve McClure",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "34",
    "name": "Steve Stadelman",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "63",
    "name": "Steve Reick",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "38",
    "name": "Sue Rezin",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "96",
    "name": "Sue Scherer",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "66",
    "name": "Suzanne Ness",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "23",
    "name": "Suzy Glowiak Hilton",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "42",
    "name": "Terra Costa Howard",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "58",
    "name": "Terri Bryant",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "29",
    "name": "Thaddeus Jones",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "24",
    "name": "Theresa Mah",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "64",
    "name": "Tom Weber",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "89",
    "name": "Tony McCombie",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "57",
    "name": "Tracy Katz Muhl",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "93",
    "name": "Travis Weaver",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "108",
    "name": "Wayne Rosenthal",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "39",
    "name": "Will Guzzardi",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "18",
    "name": "Bill Cunningham",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "30",
    "name": "Will Davis",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "87",
    "name": "Bill Hauter",
    "party": "R"
  },
  {
    "state": "il",
    "chamber": "Senate",
    "district": "16",
    "name": "Willie Preston",
    "party": "D"
  },
  {
    "state": "il",
    "chamber": "House",
    "district": "9",
    "name": "Yolonda Morris",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "32",
    "name": "Aaron Freeman",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "29",
    "name": "Alaina Shonkwiler",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "77",
    "name": "Alex Burton",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "67",
    "name": "Alex Zimmerman",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "46",
    "name": "Andrea Hunley",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "90",
    "name": "Andrew Ireland",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "17",
    "name": "Andy Zay",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "44",
    "name": "Beau Baird",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "25",
    "name": "Becky Cash",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "52",
    "name": "Ben Smaltz",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "12",
    "name": "Blake Doriot",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "100",
    "name": "Blake Johnson",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "56",
    "name": "Brad Barrett",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "24",
    "name": "Brett Clark",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "7",
    "name": "Brian Buchanan",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "45",
    "name": "Bruce Borders",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "87",
    "name": "Carey Hamilton",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "1",
    "name": "Carolyn Jackson",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "10",
    "name": "Chuck Moseley",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "94",
    "name": "Cherrish Pryor",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "26",
    "name": "Chris Campbell",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "45",
    "name": "Chris Garten",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "88",
    "name": "Chris Jeter",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "83",
    "name": "Chris Judy",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "65",
    "name": "Chris May",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "75",
    "name": "Cindy Ledbetter",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "54",
    "name": "Cory Criswell",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "57",
    "name": "Craig Haggard",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "22",
    "name": "Craig Snow",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "36",
    "name": "Cyndi Carrasco",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "5",
    "name": "Dale DeVon",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "1",
    "name": "Dan Dernulc",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "39",
    "name": "Danny Lopez",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "48",
    "name": "Daryl Schmitt",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "62",
    "name": "Dave Hall",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "85",
    "name": "Dave Heine",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "18",
    "name": "David Abbott",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "10",
    "name": "David Niezgodski",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "48",
    "name": "Doug Miller",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "2",
    "name": "Earl Harris",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "5",
    "name": "Ed Charbonneau",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "4",
    "name": "Ed Soliday",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "72",
    "name": "Ed Clere",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "86",
    "name": "Ed DeLaney",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "35",
    "name": "Elizabeth Rowray",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "39",
    "name": "Eric Bassler",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "44",
    "name": "Eric Koch",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "53",
    "name": "Ethan Lawson",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "23",
    "name": "Ethan Manning",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "30",
    "name": "Fady Qaddoura",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "68",
    "name": "Garrett Bascom",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "47",
    "name": "Gary Byrne",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "38",
    "name": "Greg Goode",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "33",
    "name": "Greg Taylor",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "41",
    "name": "Greg Walker",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "96",
    "name": "Gregory Porter",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "40",
    "name": "Greg Steuerwald",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "15",
    "name": "Hal Slager",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "38",
    "name": "Heath VanNatter",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "24",
    "name": "Hunter Smith",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "29",
    "name": "J.D. Ford",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "33",
    "name": "J.D. Prescott",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "17",
    "name": "Jack Jordan",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "7",
    "name": "Jake Teshka",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "21",
    "name": "Jim Buck",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "49",
    "name": "Jim Tomes",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "42",
    "name": "Jean Leising",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "27",
    "name": "Jeff Raatz",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "28",
    "name": "Jeff Thompson",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "73",
    "name": "Jenny Meltzer",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "69",
    "name": "Jim Lucas",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "20",
    "name": "Jim Pressel",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "49",
    "name": "Joanna King",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "95",
    "name": "John Bartlett",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "93",
    "name": "Julie McGuire",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "19",
    "name": "Julie Olthoff",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "16",
    "name": "Justin Busch",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "97",
    "name": "Justin Moed",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "70",
    "name": "Karen Engleman",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "16",
    "name": "Kendell Culp",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "82",
    "name": "Kyle Miller",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "36",
    "name": "Kyle Pierce",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "31",
    "name": "Kyle Walker",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "34",
    "name": "La Keisha Jackson",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "11",
    "name": "Linda Rogers",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "55",
    "name": "Lindsay Patterson",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "15",
    "name": "Liz Brown",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "2",
    "name": "Lonnie Randolph",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "31",
    "name": "Lori Goss-Reaves",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "50",
    "name": "Lorissa Sweet",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "41",
    "name": "Mark Genda",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "3",
    "name": "Mark Spencer",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "81",
    "name": "Martin Carbaugh",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "13",
    "name": "Matt Commons",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "64",
    "name": "Matt Hostettler",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "79",
    "name": "Matt Lehman",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "61",
    "name": "Matt Pierce",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "6",
    "name": "Maureen Bauer",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "28",
    "name": "Michael Crider",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "30",
    "name": "Mike Karickhoff",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "35",
    "name": "Mike Young",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "58",
    "name": "Michelle Davis",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "12",
    "name": "Mike Andrade",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "11",
    "name": "Mike Aylesworth",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "8",
    "name": "Mike Bohacek",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "25",
    "name": "Mike Gaskill",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "89",
    "name": "Mitch Gore",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "9",
    "name": "Patricia Boy",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "60",
    "name": "Peggy Mayfield",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "80",
    "name": "Phil GiaQuinta",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "3",
    "name": "Ragen Hatcher",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "43",
    "name": "Randy Maxwell",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "92",
    "name": "Reneé Pack",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "6",
    "name": "Rick Niemeyer",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "47",
    "name": "Robb Greene",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "91",
    "name": "Bob Behning",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "46",
    "name": "Bob Heaton",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "84",
    "name": "Bob Morris",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "98",
    "name": "Robin Shackleford",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "4",
    "name": "Rodney Pol",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "37",
    "name": "Rod Bray",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "22",
    "name": "Ron Alting",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "8",
    "name": "Ryan Dvorak",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "59",
    "name": "Ryan Lauer",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "9",
    "name": "Ryan Mishler",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "26",
    "name": "Scott Alexander",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "20",
    "name": "Scott Baldwin",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "63",
    "name": "Shane Lindauer",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "27",
    "name": "Sheila Klinker",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "40",
    "name": "Shelli Yoder",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "23",
    "name": "Spencer Deery",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "18",
    "name": "Stacey Donato",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "74",
    "name": "Steve Bartels",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "34",
    "name": "Sue Errington",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "13",
    "name": "Sue Glick",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "78",
    "name": "Tim O'Brien",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "42",
    "name": "Tim Yocum",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "21",
    "name": "Tim Wesco",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "37",
    "name": "Todd Huston",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "51",
    "name": "Tony Isa",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "43",
    "name": "Tonya Pfaff",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "19",
    "name": "Travis Holdman",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "14",
    "name": "Tyler Johnson",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "99",
    "name": "Vanessa Summers",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "Senate",
    "district": "50",
    "name": "Vaneta Becker",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "14",
    "name": "Vernon Smith",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "32",
    "name": "Victoria Garcia Wilburn",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "71",
    "name": "Wendy Dant Chesser",
    "party": "D"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "76",
    "name": "Wendy McNamara",
    "party": "R"
  },
  {
    "state": "in",
    "chamber": "House",
    "district": "66",
    "name": "Zach Payne",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "90",
    "name": "Adam Zabner",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "44",
    "name": "Adrian Dickey",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "80",
    "name": "Aime Wichtendahl",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "85",
    "name": "Amy Nielsen",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "12",
    "name": "Amy Sinclair",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "78",
    "name": "Angel Ramirez",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "8",
    "name": "Ann Meyer",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "27",
    "name": "Annette Sweeney",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "40",
    "name": "Art Staed",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "36",
    "name": "Austin Baeth",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "26",
    "name": "Austin Harris",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "37",
    "name": "Barb Kniff McCulla",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "49",
    "name": "Beth Wessel-Kroeschell",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "40",
    "name": "Bill Gustoff",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "100",
    "name": "Blaine Watkins",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "75",
    "name": "Bob Kressig",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "82",
    "name": "Bobby Kaufmann",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "19",
    "name": "Brent Siegrist",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "51",
    "name": "Brett Barker",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "45",
    "name": "Brian Lohse",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "29",
    "name": "Brian Meyer",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "21",
    "name": "Brooke Boden",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "33",
    "name": "Carrie Koelker",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "47",
    "name": "Carter Nordman",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "48",
    "name": "Chad Behn",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "68",
    "name": "Chad Ingels",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "58",
    "name": "Charley Thomson",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "42",
    "name": "Charlie McClintock",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "13",
    "name": "Cherielynn Westrich",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "59",
    "name": "Christian Hermanson",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "83",
    "name": "Cindy Golding",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "49",
    "name": "Cindy Winckler",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "16",
    "name": "Claire Celsi",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "67",
    "name": "Craig Johnson",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "11",
    "name": "Craig Williams",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "10",
    "name": "Dan Dawson",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "46",
    "name": "Dan Gehlbach",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "81",
    "name": "Dan Gosa",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "34",
    "name": "Dan Zumbach",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "38",
    "name": "Dave Sires",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "52",
    "name": "David Blom",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "5",
    "name": "Dave Rowley",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "28",
    "name": "David Young",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "86",
    "name": "Dave Jacoby",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "16",
    "name": "David Sieck",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "46",
    "name": "Dawn Driscoll",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "53",
    "name": "Dean Fisher",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "28",
    "name": "Dennis Guth",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "76",
    "name": "Derek Wulf",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "17",
    "name": "Devon Wood",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "30",
    "name": "Doug Campbell",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "43",
    "name": "Eddie Andrews",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "89",
    "name": "Elinor Levin",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "73",
    "name": "Elizabeth Wilson",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "74",
    "name": "Eric Gjerde",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "93",
    "name": "Gary Mohr",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "25",
    "name": "Hans Wilz",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "92",
    "name": "Heather Hora",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "42",
    "name": "Heather Matson",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "88",
    "name": "Helena Hayes",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "9",
    "name": "Henry Stone",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "25",
    "name": "Herman Quirmbach",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "17",
    "name": "Izaah Knox",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "1",
    "name": "J.D. Scholten",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "23",
    "name": "Jack Whitver",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "14",
    "name": "Jacob Bossman",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "60",
    "name": "Jane Bloomingdale",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "18",
    "name": "Janet Petersen",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "45",
    "name": "Janice Weiner",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "64",
    "name": "Jason Gearhart",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "6",
    "name": "Jason Schultz",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "77",
    "name": "Jeff Cooling",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "50",
    "name": "Jeff Reichman",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "87",
    "name": "Jeff Shipley",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "2",
    "name": "Jeff Taylor",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "32",
    "name": "Jennifer Konfrst",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "72",
    "name": "Jennifer Smith",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "62",
    "name": "Jerome Amos",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "24",
    "name": "Jesse Green",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "10",
    "name": "John Wills",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "38",
    "name": "Jon Dunwell",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "20",
    "name": "Josh Turek",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "54",
    "name": "Josh Meggers",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "91",
    "name": "Judd Lawler",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "11",
    "name": "Julian Garrett",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "26",
    "name": "Kara Warme",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "97",
    "name": "Ken Croken",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "19",
    "name": "Ken Rozenboom",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "27",
    "name": "Kenan Judge",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "41",
    "name": "Kerry Gruenhagen",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "7",
    "name": "Kevin Alons",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "44",
    "name": "Larry McBurney",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "71",
    "name": "Lindsay James",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "39",
    "name": "Liz Bennett",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "3",
    "name": "Lynn Evans",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "96",
    "name": "Mark Cisneros",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "8",
    "name": "Mark Costello",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "56",
    "name": "Mark Thompson",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "48",
    "name": "Mark Lofgren",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "31",
    "name": "Mary Madison",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "22",
    "name": "Matt Blake",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "15",
    "name": "Matt Windschitl",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "99",
    "name": "Matt Rinker",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "6",
    "name": "Megan Jones",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "30",
    "name": "Megan Srinivas",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "63",
    "name": "Michael Bergan",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "21",
    "name": "Mike Bousselot",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "32",
    "name": "Mike Klimesh",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "20",
    "name": "Mike Pike",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "7",
    "name": "Mike Sexton",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "94",
    "name": "Mike Vondran",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "35",
    "name": "Mike Zimmer",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "37",
    "name": "Molly Donahue",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "98",
    "name": "Monica Kurth",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "70",
    "name": "Norlin Mommsen",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "57",
    "name": "Pat Grassley",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "23",
    "name": "Bubba Sorensen",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "39",
    "name": "Rick Olson",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "34",
    "name": "Rob Johnson",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "2",
    "name": "Bob Henderson",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "50",
    "name": "Ross Wilburn",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "33",
    "name": "Ruth Ann Gaines",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "41",
    "name": "Ryan Weldon",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "24",
    "name": "Sam Wengryn",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "22",
    "name": "Samantha Fett",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "29",
    "name": "Sandy Salmon",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "14",
    "name": "Sarah Garriott",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "47",
    "name": "Scott Webster",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "35",
    "name": "Sean Bagniewski",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "55",
    "name": "Shannon Latham",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "65",
    "name": "Shannon Lundgren",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "4",
    "name": "Skyler Wheeler",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "66",
    "name": "Steve Bradley",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "12",
    "name": "Steven Holt",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "95",
    "name": "Taylor Collins",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "84",
    "name": "Tom Gerhold",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "4",
    "name": "Tim Kraayenbrink",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "61",
    "name": "Timi Brown-Powers",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "69",
    "name": "Tom Determann",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "3",
    "name": "Tom Jeneary",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "18",
    "name": "Tom Moore",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "9",
    "name": "Tom Shipley",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "36",
    "name": "Tom Townsend",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "15",
    "name": "Tony Bisignano",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "79",
    "name": "Tracy Ehlert",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "13",
    "name": "Travis Sitzmann",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "31",
    "name": "Bill Dotzler",
    "party": "D"
  },
  {
    "state": "ia",
    "chamber": "House",
    "district": "5",
    "name": "Zach Dieken",
    "party": "R"
  },
  {
    "state": "ia",
    "chamber": "Senate",
    "district": "43",
    "name": "Zach Wahls",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "120",
    "name": "Adam Smith",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "23",
    "name": "Adam Thomas",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "117",
    "name": "Adam Turk",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "58",
    "name": "Alexis Simmons",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "63",
    "name": "Allen Reavis",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "67",
    "name": "Angel Roeser",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "103",
    "name": "Angela Martinez",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "39",
    "name": "Angela Stiens",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "72",
    "name": "Avery Anderson",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "44",
    "name": "Barbara Ballard",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "111",
    "name": "Barb Wasinger",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "9",
    "name": "Beverly Gossage",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "39",
    "name": "Bill Clifford",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "80",
    "name": "Bill Rhiley",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "43",
    "name": "Bill Sutton",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "81",
    "name": "Blake Carpenter",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "123",
    "name": "Bob Lewis",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "76",
    "name": "Brad Barrett",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "22",
    "name": "Brad Starnes",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "108",
    "name": "Brandon Woodard",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "20",
    "name": "Brenda Dietrich",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "113",
    "name": "Brett Fairchild",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "93",
    "name": "Brian Bergkamp",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "46",
    "name": "Brooklynne Mosley",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "28",
    "name": "Carl Turner",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "5",
    "name": "Carrie Barth",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "12",
    "name": "Caryn Tyson",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "3",
    "name": "Chuck Smith",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "14",
    "name": "Charlotte Esau",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "26",
    "name": "Chase Blasi",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "26",
    "name": "Chip VanHouden",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "8",
    "name": "Chris Croft",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "8",
    "name": "Cindy Holscher",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "18",
    "name": "Cindy Neighbor",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "69",
    "name": "Clarke Sanders",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "1",
    "name": "Craig Bowser",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "98",
    "name": "Cyndi Howerton",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "1",
    "name": "Dale Helwig",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "7",
    "name": "Dan Goddard",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "48",
    "name": "Dan Osman",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "100",
    "name": "Dan Hawkins",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "40",
    "name": "Dave Buehler",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "4",
    "name": "David Haley",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "107",
    "name": "Dawn Wolf",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "21",
    "name": "Dinah Sykes",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "12",
    "name": "Doug Blex",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "37",
    "name": "Doug Shane",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "13",
    "name": "Duane Droge",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "36",
    "name": "Elaine Bowers",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "91",
    "name": "Emil Bergquist",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "7",
    "name": "Ethan Corson",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "84",
    "name": "Ford Carr",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "61",
    "name": "Francis Awerkamp",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "9",
    "name": "Fred Gardner",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "115",
    "name": "Gary White",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "29",
    "name": "Heather Meyer",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "83",
    "name": "Henry Helgerson",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "24",
    "name": "Jarrod Ousley",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "119",
    "name": "Jason Goetz",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "5",
    "name": "Jeff Klemp",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "21",
    "name": "Jerry Stogsdill",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "52",
    "name": "Jesse Borjon",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "105",
    "name": "Jill Ward",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "118",
    "name": "Jim Minnix",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "17",
    "name": "Jo Ella Hoye",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "27",
    "name": "Joe Claeys",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "101",
    "name": "Joe Seiwert",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "57",
    "name": "John Alcala",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "92",
    "name": "John Carmichael",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "121",
    "name": "John Resman",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "89",
    "name": "K.C. Ohaebosim",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "11",
    "name": "Kellie Warren",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "54",
    "name": "Ken Corbet",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "110",
    "name": "Ken Rahjes",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "2",
    "name": "Ken Collins",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "18",
    "name": "Kenny Titus",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "114",
    "name": "Kevin Schwertfeger",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "53",
    "name": "Kirk Haskins",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "77",
    "name": "Kristey Williams",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "116",
    "name": "Kyle Hoffman",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "50",
    "name": "Kyle McNorton",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "102",
    "name": "Kyler Sweely",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "42",
    "name": "Lance Neelly",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "32",
    "name": "Larry Alley",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "30",
    "name": "Laura Williams",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "15",
    "name": "Lauren Bohi",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "82",
    "name": "Leah Howell",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "94",
    "name": "Leo Delperdang",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "64",
    "name": "Bill Bloom",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "16",
    "name": "Linda Featherston",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "22",
    "name": "Lindsay Vaughn",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "106",
    "name": "Lisa Moser",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "122",
    "name": "Lon Pishny",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "31",
    "name": "Louis Ruiz",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "36",
    "name": "Lynn Melton",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "2",
    "name": "Marci Francisco",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "20",
    "name": "Mari-Lynn Poskin",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "60",
    "name": "Mark Schreiber",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "124",
    "name": "Marty Long",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "25",
    "name": "Mary Ware",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "51",
    "name": "Megan Steele",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "37",
    "name": "Melissa Oropeza",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "14",
    "name": "Mike Fagg",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "34",
    "name": "Mike Murphy",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "45",
    "name": "Mike Amyx",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "17",
    "name": "Mike Argabright",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "74",
    "name": "Mike King",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "28",
    "name": "Mike Petersen",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "33",
    "name": "Mike Thompson",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "10",
    "name": "Mike Thompson",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "68",
    "name": "Nate Butler",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "97",
    "name": "Nick Hoheisel",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "49",
    "name": "Nikki McDonald",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "29",
    "name": "Oletha Faust-Goudeau",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "32",
    "name": "Pam Curtis",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "6",
    "name": "Pat Pettey",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "41",
    "name": "Pat Proctor",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "19",
    "name": "Patrick Schmidt",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "104",
    "name": "Paul Waggoner",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "59",
    "name": "Rebecca Schmoe",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "30",
    "name": "Renee Erickson",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "40",
    "name": "Rick Billinger",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "4",
    "name": "Rick James",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "3",
    "name": "Rick Kloos",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "73",
    "name": "Rick Wilborn",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "78",
    "name": "Robyn Essex",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "11",
    "name": "Ron Bryce",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "47",
    "name": "Ronald Ellis",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "38",
    "name": "Ron Ryckman",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "25",
    "name": "Rui Xu",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "6",
    "name": "Samantha Poetter Parshall",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "88",
    "name": "Sandy Pickert",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "24",
    "name": "Scott Hill",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "27",
    "name": "Sean Tarwater",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "62",
    "name": "Sean Willcott",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "125",
    "name": "Shannon Francis",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "65",
    "name": "Shawn Chauncey",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "112",
    "name": "Sherri Brantley",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "86",
    "name": "Silas Miller",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "19",
    "name": "Stephanie Sawyer-Clayton",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "31",
    "name": "Stephen Owens",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "85",
    "name": "Steve Brunk",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "90",
    "name": "Steve Huebert",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "71",
    "name": "Steve Howe",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "87",
    "name": "Susan Estes",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "99",
    "name": "Susan Humphries",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "23",
    "name": "Susan Ruiz",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "10",
    "name": "Suzanne Wikle",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "66",
    "name": "Sydney Carlin",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "35",
    "name": "T.J. Rose",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "13",
    "name": "Tim Shallenburger",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "38",
    "name": "Tim Johnson",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "55",
    "name": "Tobias Schlingensiepen",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "96",
    "name": "Tom Kessler",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "95",
    "name": "Tom Sawyer",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "33",
    "name": "Tory Marie Blew",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "109",
    "name": "Troy Waymaster",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "16",
    "name": "Ty Masterson",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "34",
    "name": "Valdenia Winn",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "Senate",
    "district": "15",
    "name": "Virgil Peck",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "56",
    "name": "Virgil Weigel",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "35",
    "name": "Wanda Paige",
    "party": "D"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "79",
    "name": "Web Roth",
    "party": "R"
  },
  {
    "state": "ks",
    "chamber": "House",
    "district": "75",
    "name": "Will Carpenter",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "7",
    "name": "Aaron Reed",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "98",
    "name": "Aaron Thompson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "87",
    "name": "Adam Bowling",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "45",
    "name": "Adam Moore",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "93",
    "name": "Adrielle Camuel",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "46",
    "name": "Al Gentry",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "12",
    "name": "Amanda Bledsoe",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "21",
    "name": "Amy Neighbors",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "76",
    "name": "Anne Donworth",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "95",
    "name": "Ashley Laferty",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "44",
    "name": "Beverly Chester-Burton",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "91",
    "name": "Bill Wesley",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "97",
    "name": "Bobby McCool",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "30",
    "name": "Brandon Smith",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "21",
    "name": "Brandon Storm",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "50",
    "name": "Candy Massaroni",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "19",
    "name": "Cassie Armstrong",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "79",
    "name": "Chad Aull",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "6",
    "name": "Chris Freeland",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "84",
    "name": "Chris Fugate",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "29",
    "name": "Chris Lewis",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "23",
    "name": "Chris McDaniel",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "3",
    "name": "Craig Richardson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "13",
    "name": "D.J. Johnson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "54",
    "name": "Daniel Elliott",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "56",
    "name": "Dan Fister",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "30",
    "name": "Daniel Grossberg",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "2",
    "name": "Danny Carroll",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "74",
    "name": "David Hale",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "80",
    "name": "David Meade",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "59",
    "name": "David Osborne",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "9",
    "name": "David Givens",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "37",
    "name": "David Yates",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "81",
    "name": "Deanna Frazier Gordon",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "90",
    "name": "Derek Lewis",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "22",
    "name": "Don Douglas",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "37",
    "name": "Emily Callaway",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "57",
    "name": "Erika Hancock",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "47",
    "name": "Felicia Rabourn",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "8",
    "name": "Gary Boswell",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "77",
    "name": "George Brown",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "33",
    "name": "Gerald Neal",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "20",
    "name": "Gex Williams",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "28",
    "name": "Greg Elkins",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "11",
    "name": "J.T. Payne",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "53",
    "name": "James Tipton",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "28",
    "name": "Jared Bauman",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "34",
    "name": "Jared Carpenter",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "1",
    "name": "Jason Howell",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "33",
    "name": "Jason Nemes",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "16",
    "name": "Jason Petrie",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "58",
    "name": "Jennifer Decker",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "12",
    "name": "Jim Gooch",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "14",
    "name": "Jimmy Higdon",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "92",
    "name": "John Blanton",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "36",
    "name": "John Hodgson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "83",
    "name": "Josh Branscum",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "71",
    "name": "Josh Bray",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "10",
    "name": "Josh Calloway",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "42",
    "name": "Joshua Watkins",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "36",
    "name": "Julie Adams",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "26",
    "name": "Karen Berg",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "48",
    "name": "Ken Fleming",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "52",
    "name": "Ken Upchurch",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "35",
    "name": "Keturah Herron",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "20",
    "name": "Kevin Jackson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "63",
    "name": "Kim Banta",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "2",
    "name": "Kim Holloway",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "55",
    "name": "Kim King",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "64",
    "name": "Kim Moser",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "75",
    "name": "Lindsey Burke",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "6",
    "name": "Lindsey Tichenor",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "35",
    "name": "Lisa Willner",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "60",
    "name": "Marianne Proctor",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "78",
    "name": "Mark Hart",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "5",
    "name": "Mary Beth Imes",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "41",
    "name": "Mary Lou Marzian",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "67",
    "name": "Matt Lehman",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "39",
    "name": "Matt Lockett",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "17",
    "name": "Matt Nunn",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "10",
    "name": "Matt Deneen",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "72",
    "name": "Matt Koch",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "16",
    "name": "Max Wise",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "38",
    "name": "Mike Nemes",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "19",
    "name": "Michael Meredith",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "51",
    "name": "Sarge Pollock",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "68",
    "name": "Mike Clines",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "32",
    "name": "Mike Wilson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "94",
    "name": "Mitch Whitaker",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "9",
    "name": "Myron Dossett",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "27",
    "name": "Nancy Tate",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "82",
    "name": "Nick Wilson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "40",
    "name": "Nima Kulkarni",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "43",
    "name": "Pamela Stevenson",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "96",
    "name": "Patrick Flannery",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "26",
    "name": "Peyton Griffee",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "31",
    "name": "Phillip Wheeler",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "38",
    "name": "Rachel Roarx",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "3",
    "name": "Randy Bridges",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "15",
    "name": "Rebecca Raymer",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "13",
    "name": "Reggie Thomas",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "99",
    "name": "Richard White",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "15",
    "name": "Rick Girdler",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "4",
    "name": "Robby Mills",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "17",
    "name": "Robert Duvall",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "25",
    "name": "Robert Stivers",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "18",
    "name": "Robin Webb",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "24",
    "name": "Ryan Bivens",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "73",
    "name": "Ryan Dotson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "18",
    "name": "Samara Heavrin",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "34",
    "name": "Sarah Stalker",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "61",
    "name": "Savannah Maddox",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "14",
    "name": "Scott Lewis",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "29",
    "name": "Scott Madon",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "100",
    "name": "Scott Sharp",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "85",
    "name": "Shane Baker",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "22",
    "name": "Shawn McPherson",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "24",
    "name": "Shelley Frommeyer",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "65",
    "name": "Stephanie Dietz",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "5",
    "name": "Stephen Meredith",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "27",
    "name": "Steve West",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "25",
    "name": "Steve Bratcher",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "Senate",
    "district": "11",
    "name": "Steve Rawlings",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "23",
    "name": "Steve Riley",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "69",
    "name": "Steven Doan",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "1",
    "name": "Steven Rudy",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "31",
    "name": "Susan Tyler Witten",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "7",
    "name": "Suzanne Miles",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "66",
    "name": "T.J. Roberts",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "49",
    "name": "Thomas Huff",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "89",
    "name": "Timmy Truett",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "32",
    "name": "Tina Bojanowski",
    "party": "D"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "86",
    "name": "Tom Smith",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "62",
    "name": "Tony Hampton",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "88",
    "name": "Vanessa Grossl",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "4",
    "name": "Wade Williams",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "8",
    "name": "Walker Thomas",
    "party": "R"
  },
  {
    "state": "ky",
    "chamber": "House",
    "district": "70",
    "name": "William Lawrence",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "36",
    "name": "Adam Bass",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "16",
    "name": "Adrian Fisher",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "98",
    "name": "Aimee Freeman",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "31",
    "name": "Alan Seabaugh",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "93",
    "name": "Alonzo Knox",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "45",
    "name": "Annie Spell",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "70",
    "name": "Barbara Freiberg",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "63",
    "name": "Barbara Carpenter",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "51",
    "name": "Beryl Amedée",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "56",
    "name": "Beth Billings",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "12",
    "name": "Beth Mizell",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "37",
    "name": "Bill Wheat",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "22",
    "name": "Blake Miguez",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "26",
    "name": "Bob Hensgens",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "1",
    "name": "Bob Owen",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "23",
    "name": "Brach Myers",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "35",
    "name": "Brett Geymann",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "90",
    "name": "Brian Glorioso",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "55",
    "name": "Bryan Fontenot",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "61",
    "name": "Denise Marcelle",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "21",
    "name": "Travis Johnson",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "17",
    "name": "Caleb Kleinpeter",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "99",
    "name": "Candace Newell",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "46",
    "name": "Chad Boyer",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "60",
    "name": "Chad Brown",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "42",
    "name": "Chance Henry",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "30",
    "name": "Chuck Owen",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "12",
    "name": "Chris Turner",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "1",
    "name": "Danny McCormick",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "28",
    "name": "Daryl Deshotel",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "79",
    "name": "Debbie Villio",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "102",
    "name": "Delisha Boyd",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "5",
    "name": "Dennis Bamburg",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "68",
    "name": "Dixon McMakin",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "9",
    "name": "Dodie Horton",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "40",
    "name": "Dustin Miller",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "26",
    "name": "Ed Larvadain",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "18",
    "name": "Eddie Lambert",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "29",
    "name": "Edmond Jordan",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "2",
    "name": "Ed Price",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "66",
    "name": "Emily Chenevert",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "15",
    "name": "Foy Gadberry",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "19",
    "name": "Francis Thompson",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "16",
    "name": "Franklin Foil",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "7",
    "name": "Gary Carter",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "48",
    "name": "Beau Beaullieu",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "24",
    "name": "Gerald Boudreaux",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "32",
    "name": "Glen Womack",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "19",
    "name": "Greg Miller",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "28",
    "name": "Heather Cloud",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "9",
    "name": "Cameron Henry",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "13",
    "name": "Jack McFarland",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "105",
    "name": "Jacob Braud",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "49",
    "name": "Jacob Landry",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "25",
    "name": "Jason DeWitt",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "100",
    "name": "Jason Hughes",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "104",
    "name": "Jay Gallé",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "35",
    "name": "Jay Morris",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "81",
    "name": "Jeff Wiley",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "27",
    "name": "Jeremy Stine",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "18",
    "name": "Jeremy LaCombe",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "52",
    "name": "Jerome Zeringue",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "53",
    "name": "Jessica Domangue",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "4",
    "name": "Jimmy Harris",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "78",
    "name": "John Illg",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "75",
    "name": "John Wyble",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "92",
    "name": "Joe Stagni",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "3",
    "name": "Joe Bouie",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "54",
    "name": "Joe Orgeron",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "43",
    "name": "Josh Carlson",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "4",
    "name": "Joy Walters",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "39",
    "name": "Julie Emerson",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "88",
    "name": "Kathy Edmonston",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "34",
    "name": "Katrina Jackson-Andrews",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "64",
    "name": "Kellee Hennessy",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "58",
    "name": "Ken Brass",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "89",
    "name": "Kim Carver",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "73",
    "name": "Kim Coates",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "10",
    "name": "Kirk Talbot",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "83",
    "name": "Kyle Green",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "14",
    "name": "Larry Selders",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "65",
    "name": "Lauren Ventrella",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "82",
    "name": "Laurie Schlegel",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "7",
    "name": "Larry Bagley",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "33",
    "name": "Les Farnum",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "91",
    "name": "Mandie Landry",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "96",
    "name": "Marcus Bryant",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "25",
    "name": "Mark Abraham",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "77",
    "name": "Mark Wright",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "97",
    "name": "Matt Willard",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "20",
    "name": "Mike Fési",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "14",
    "name": "Michael Echols",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "22",
    "name": "Gabe Firment",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "6",
    "name": "Michael Melerine",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "27",
    "name": "Mike Johnson",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "103",
    "name": "Mike Bayham",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "30",
    "name": "Mike Reese",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "20",
    "name": "Neil Riser",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "86",
    "name": "Nicholas Muscarello",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "17",
    "name": "Pat Moore",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "8",
    "name": "Patrick Connick",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "11",
    "name": "Patrick McMath",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "69",
    "name": "Paula Davis",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "74",
    "name": "Peter Egan",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "36",
    "name": "Phil Tarver",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "41",
    "name": "Phillip DeVillier",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "80",
    "name": "Polly Thomas",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "32",
    "name": "Dewith Carrier",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "21",
    "name": "Robert Allain",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "11",
    "name": "Rashid Young",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "8",
    "name": "Raymond Crews",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "15",
    "name": "Regina Barrow",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "38",
    "name": "Rhonda Butler",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "6",
    "name": "Rick Edmonds",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "72",
    "name": "Robby Carter",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "87",
    "name": "Rodney Lyons",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "24",
    "name": "Rodney Schamerhorn",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "71",
    "name": "Roger Wilder",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "62",
    "name": "Roy Adams",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "5",
    "name": "Royce Duplessis",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "47",
    "name": "Ryan Bourriaque",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "39",
    "name": "Sam Jenkins",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "23",
    "name": "Shaun Mena",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "95",
    "name": "Shane Mack",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "76",
    "name": "Stephanie Berault",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "94",
    "name": "Stephanie Hilferty",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "2",
    "name": "Steven Jackson",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "33",
    "name": "Stewart Cathey",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "57",
    "name": "Sylvia Taylor",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "3",
    "name": "Tammy Phelps",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "44",
    "name": "Tehmi Chassion",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "67",
    "name": "Terry Landry",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "38",
    "name": "Thomas Pressly",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "84",
    "name": "Tim Kerner",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "59",
    "name": "Tony Bacala",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "37",
    "name": "Troy Romero",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "31",
    "name": "Troy Hebert",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "13",
    "name": "Valarie Hodges",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "101",
    "name": "Vanessa LaFleur",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "85",
    "name": "Vincent Cox",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "50",
    "name": "Vinney St. Blanc",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "Senate",
    "district": "29",
    "name": "Jay Luneau",
    "party": "D"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "10",
    "name": "Wayne McMahen",
    "party": "R"
  },
  {
    "state": "la",
    "chamber": "House",
    "district": "34",
    "name": "Wilford Carter",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "Passamaquoddy Tribe",
    "name": "Aaron Dana",
    "party": "I"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "45",
    "name": "Abden Simmons",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "34",
    "name": "Abigail Griffin",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "89",
    "name": "Adam Lee",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "61",
    "name": "Alicia Collins",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "49",
    "name": "Allison Hepler",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "68",
    "name": "Amanda Collamore",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "21",
    "name": "Ambureen Rana",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "104",
    "name": "Amy Arata",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "111",
    "name": "Amy Kuhn",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "23",
    "name": "Amy Roeder",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "143",
    "name": "Ann Marie Fredericks",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "43",
    "name": "Ann Matlack",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "12",
    "name": "Pinny Beebe-Center",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "29",
    "name": "Anne Carney",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "142",
    "name": "Anne-Marie Mastraccio",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "105",
    "name": "Annie Graham",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "103",
    "name": "Art Bell",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "9",
    "name": "Artie Mingo",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "106",
    "name": "Barbara Bagshaw",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "38",
    "name": "Ben Hymes",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "12",
    "name": "Billy Bob Faulkingham",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "3",
    "name": "Brad Farrin",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "20",
    "name": "Bruce Bickford",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "80",
    "name": "Caldwell Jackson",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "13",
    "name": "Cameron Reny",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "65",
    "name": "Cassie Julia",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "31",
    "name": "Chad Perkins",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "119",
    "name": "Charles Skold",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "99",
    "name": "Cheryl Golek",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "110",
    "name": "Christina Mitchell",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "121",
    "name": "Christopher Kessler",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "14",
    "name": "Craig Hickman",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "20",
    "name": "Dani O'Halloran",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "100",
    "name": "Dan Ankeles",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "55",
    "name": "Dan Shagoury",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "135",
    "name": "Dan Sayre",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "59",
    "name": "Dave Rollins",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "50",
    "name": "David Sinclair",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "139",
    "name": "Woody Woodsome",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "10",
    "name": "David Haggan",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "87",
    "name": "David Boyer",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "69",
    "name": "Dean Cray",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "24",
    "name": "Denise Tepler",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "120",
    "name": "Deqa Dhalac",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "6",
    "name": "Donald Ardell",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "31",
    "name": "Donna Bailey",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "126",
    "name": "Drew Gattine",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "114",
    "name": "Dylan Pugh",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "109",
    "name": "Ellie Sato",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "64",
    "name": "Flavia DeBrito",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "27",
    "name": "Gary Drinkwater",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "14",
    "name": "Gary Friedmann",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "11",
    "name": "Chip Curry",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "113",
    "name": "Grayson Lookner",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "7",
    "name": "Gregg Swallow",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "2",
    "name": "Trey Stewart",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "32",
    "name": "Henry Ingwersen",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "48",
    "name": "Holly Stover",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "15",
    "name": "Holly Eaton",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "147",
    "name": "Holly Sargent",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "28",
    "name": "Irene Gifford",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "35",
    "name": "Jim Thorne",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "26",
    "name": "Jim Dill",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "30",
    "name": "Jim White",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "22",
    "name": "Jim Libby",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "39",
    "name": "Janice Dodge",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "17",
    "name": "Jeff Timberlake",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "144",
    "name": "Jeff Adams",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "70",
    "name": "Jennifer Poirier",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "27",
    "name": "Jill Duson",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "19",
    "name": "Joe Martin",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "71",
    "name": "Jack Ducharme",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "136",
    "name": "John Eder",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "9",
    "name": "Joe Baldacci",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "5",
    "name": "Joseph Underwood",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "34",
    "name": "Joe Rafferty",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "91",
    "name": "Josh Morris",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "93",
    "name": "Julie McCabe",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "54",
    "name": "Karen Montell",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "29",
    "name": "Kathy Javner",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "62",
    "name": "Katrina Smith",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "125",
    "name": "Kelly Murphy",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "33",
    "name": "Ken Fredette",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "98",
    "name": "Kilton Webb",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "36",
    "name": "Kim Haggan",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "85",
    "name": "Kim Pomerleau",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "94",
    "name": "Kristen Cloutier",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "151",
    "name": "Kristi Mathieson",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "22",
    "name": "Laura Supica",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "90",
    "name": "Laurel Libby",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "25",
    "name": "Laurie Osher",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "72",
    "name": "Liz Caruso",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "131",
    "name": "Lori Gramlich",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "141",
    "name": "Lucas Lanigan",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "1",
    "name": "Lucien Daigle",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "46",
    "name": "Lydia Crafts",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "130",
    "name": "Lynn Copeland",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "95",
    "name": "Mana Abdi",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "133",
    "name": "Marc Malon",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "21",
    "name": "Peggy Rotundo",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "6",
    "name": "Marianne Moore",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "107",
    "name": "Mark Cooper",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "138",
    "name": "Mark Blier",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "35",
    "name": "Mark Lawrence",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "3",
    "name": "Mark Babin",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "84",
    "name": "Mark Walker",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "129",
    "name": "Marshall Archer",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "83",
    "name": "Marygrace Cimino",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "18",
    "name": "Mathew McIntyre",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "122",
    "name": "Matt Beck",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "117",
    "name": "Matt Moonen",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "23",
    "name": "Mattie Daughtry",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "33",
    "name": "Matt Harrington",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "102",
    "name": "Melanie Sachs",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "115",
    "name": "Michael Brennan",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "53",
    "name": "Michael Lemelin",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "73",
    "name": "Mike Soboleski",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "8",
    "name": "Mike Tipping",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "96",
    "name": "Mike Lajoie",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "150",
    "name": "Michele Meyer",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "123",
    "name": "Michelle Boyer",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "79",
    "name": "Mike Lance",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "40",
    "name": "Mike Ray",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "127",
    "name": "Morgan Rielly",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "82",
    "name": "Nate Wadsworth",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "137",
    "name": "Nathan Carlow",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "7",
    "name": "Nicole Grohoski",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "16",
    "name": "Nina Milliken",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "108",
    "name": "Parnell Terry",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "63",
    "name": "Paul Flynn",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "81",
    "name": "Peter Wood",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "101",
    "name": "Poppy Arford",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "88",
    "name": "Quentin Chapman",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "78",
    "name": "Rachel Henderson",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "28",
    "name": "Rachel Talbot Ross",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "51",
    "name": "Rafael Macias",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "56",
    "name": "Randall Greenwood",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "74",
    "name": "Randy Hall",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "37",
    "name": "Reagan Paul",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "18",
    "name": "Rick Bennett",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "97",
    "name": "Rick Mason",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "19",
    "name": "Dick Campbell",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "15",
    "name": "Dick Bradstreet",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "145",
    "name": "Bob Foley",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "66",
    "name": "Bob Nutting",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "2",
    "name": "Roger Albert",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "86",
    "name": "Rolf Olsen",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "13",
    "name": "Russ White",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "5",
    "name": "Russell Black",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "132",
    "name": "Ryan Fecteau",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "52",
    "name": "Sally Cluchey",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "116",
    "name": "Sam Zager",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "16",
    "name": "Scott Cyrway",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "24",
    "name": "Sean Faircloth",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "58",
    "name": "Sharon Frost",
    "party": "I"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "76",
    "name": "Sheila Lyman",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "67",
    "name": "Shelley Rudnicki",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "124",
    "name": "Sophie Warren",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "4",
    "name": "Stacey Guerin",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "30",
    "name": "Stacy Brenner",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "92",
    "name": "Steve Wood",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "17",
    "name": "Steve Bishop",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "75",
    "name": "Steve Bunker",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "32",
    "name": "Steven Foster",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "1",
    "name": "Sue Bernard",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "128",
    "name": "Sue Salisbury",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "77",
    "name": "Tammy Schmersal-Burgess",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "57",
    "name": "Tavis Hasenfus",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "25",
    "name": "Teresa Pierce",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "148",
    "name": "Thomas Lavigne",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "149",
    "name": "Tiffany Roberts",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "11",
    "name": "Tiffany Strout",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "4",
    "name": "Timmy Guerrette",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "Senate",
    "district": "26",
    "name": "Tim Nangle",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "134",
    "name": "Traci Gere",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "8",
    "name": "Tracy Quint",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "42",
    "name": "Valli Geiger",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "41",
    "name": "Vicki Doudera",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "112",
    "name": "Ed Crockett",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "146",
    "name": "Gerry Runte",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "47",
    "name": "Wayne Farrin",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "140",
    "name": "Wayne Parry",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "10",
    "name": "Will Tuell",
    "party": "R"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "44",
    "name": "Bill Pluecker",
    "party": "I"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "60",
    "name": "Bill Bridgeo",
    "party": "D"
  },
  {
    "state": "me",
    "chamber": "House",
    "district": "118",
    "name": "Yusuf Yusuf",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "18",
    "name": "Aaron Kaufman",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "23",
    "name": "Adrian Boafo",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "10",
    "name": "Adrienne Jones",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "44B",
    "name": "Aletheia McCaskill",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "22",
    "name": "Alonzo Washington",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "34A",
    "name": "Andre Johnson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "24",
    "name": "Andrea Harrison",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "33A",
    "name": "Andrew Pruski",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "22",
    "name": "Anne Healey",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "14",
    "name": "Anne Kaiser",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "40",
    "name": "Antonio Hayes",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "4",
    "name": "April Miller",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "5",
    "name": "April Rose",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "28",
    "name": "Arthur Ellis",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "22",
    "name": "Ashanti Martínez",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "4",
    "name": "Barrie Ciliberti",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "38B",
    "name": "Barry Beauchamp",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "21",
    "name": "Ben Barnes",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "10",
    "name": "Ben Brooks",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "19",
    "name": "Ben Kramer",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "14",
    "name": "Bernice Mireku-North",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "46",
    "name": "Bill Ferguson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "19",
    "name": "Bonnie Cullison",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "31",
    "name": "Brian Chisholm",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "15",
    "name": "Brian Feldman",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "29B",
    "name": "Brian Crosby",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "31",
    "name": "Bryan Simonaire",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "26",
    "name": "Anthony Muse",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "28",
    "name": "C.T. Wilson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "8",
    "name": "Carl Jackson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "43B",
    "name": "Cathi Forbes",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "45",
    "name": "Caylin Young",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "9A",
    "name": "Chao Wu",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "38A",
    "name": "Charles Otto",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "19",
    "name": "Charlotte Crutchfield",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "17",
    "name": "Cheryl Kagan",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "11A",
    "name": "Cheryl Pasteur",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "5",
    "name": "Chris Tomlinson",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "42",
    "name": "Chris West",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "5",
    "name": "Christopher Bouchat",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "37B",
    "name": "Chris Adams",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "12",
    "name": "Clarence Lam",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "45",
    "name": "Cory McCray",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "9B",
    "name": "Courtney Watson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "14",
    "name": "Craig Zucker",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "41",
    "name": "Dalya Attar",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "30A",
    "name": "Dana Jones",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "11B",
    "name": "Dana Stein",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "15",
    "name": "David Fraser-Hidalgo",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "20",
    "name": "David Moon",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "33",
    "name": "Dawn Gile",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "28",
    "name": "Debra Davis",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "47B",
    "name": "Deni Taveras",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "25",
    "name": "Denise Roberts",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "47A",
    "name": "Diana Fennell",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "30A",
    "name": "Dylan Behler",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "28",
    "name": "Edith Patterson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "43A",
    "name": "Elizabeth Embry",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "18",
    "name": "Emily Shetty",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "44A",
    "name": "Eric Ebersole",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "39",
    "name": "Gabriel Acevero",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "12B",
    "name": "Gary Simmons",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "39",
    "name": "Greg Wims",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "13",
    "name": "Guy Guzzone",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "8",
    "name": "Harry Bhandari",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "33C",
    "name": "Heather Bagnall Tudball",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "44",
    "name": "Charles Sydnor",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "7",
    "name": "J.B. Jennings",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "32",
    "name": "Sandy Bartlett",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "29",
    "name": "Jack Bailey",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "45",
    "name": "Jackie Addison",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "26",
    "name": "Jamila Woods",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "18",
    "name": "Jared Solomon",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "1B",
    "name": "Jason Buckel",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "35",
    "name": "Jason Gallion",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "36",
    "name": "Jay Jacobs",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "24",
    "name": "Jazz Lewis",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "18",
    "name": "Jeff Waldstreicher",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "36",
    "name": "Jeff Ghrist",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "27B",
    "name": "Jeff Long",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "13",
    "name": "Jen Terrasa",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "10",
    "name": "Jennifer White Holland",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "4",
    "name": "Jesse Pippy",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "12A",
    "name": "Jessica Feldmark",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "20",
    "name": "Jheanelle Wilkins",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "1A",
    "name": "Jim Hinebaugh",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "21",
    "name": "Jim Rosapepe",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "24",
    "name": "Joanne Benson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "17",
    "name": "Joe Vogel",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "37",
    "name": "Johnny Mautz",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "6",
    "name": "Johnny Salling",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "11B",
    "name": "Jon Cardin",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "21",
    "name": "Joseline Peña-Melnyk",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "42C",
    "name": "Josh Stonko",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "40",
    "name": "Frank Conaway",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "23",
    "name": "Marvin Holmes",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "6",
    "name": "Robin Grammer",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "36",
    "name": "Steve Hershey",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "20",
    "name": "Will Smith",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "47A",
    "name": "Julian Ivey",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "17",
    "name": "Julie Palakovich Carr",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "5",
    "name": "Justin Ready",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "3",
    "name": "Karen Young",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "3",
    "name": "Karen Simpson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "25",
    "name": "Karen Toles",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "7A",
    "name": "Kathy Szeliga",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "9",
    "name": "Katie Hester",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "3",
    "name": "Ken Kerr",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "25",
    "name": "Kent Roberson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "35B",
    "name": "Kevin Hornberger",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "27A",
    "name": "Kevin Harris",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "8",
    "name": "Kim Ross",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "3",
    "name": "Kris Fair",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "26",
    "name": "Kris Valderrama",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "23",
    "name": "Kym Taylor",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "31",
    "name": "LaToya Nkongolo",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "7B",
    "name": "Lauren Arikan",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "39",
    "name": "Lesley Lopez",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "15",
    "name": "Lily Qi",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "15",
    "name": "Linda Foley",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "20",
    "name": "Lorig Charkoudian",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "46",
    "name": "Luke Clippinger",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "47",
    "name": "Malcolm Augustine",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "41",
    "name": "Malcolm Ruff",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "16",
    "name": "Marc Korman",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "46",
    "name": "Mark Edelson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "27C",
    "name": "Mark Fisher",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "32",
    "name": "Mark Chang",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "40",
    "name": "Marlon Amprey",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "21",
    "name": "Mary Lehman",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "38",
    "name": "Mary Beth Carozza",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "34",
    "name": "Mary-Dulany James",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "43",
    "name": "Mary Washington",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "29A",
    "name": "Matt Morgan",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "2B",
    "name": "Matthew Schindler",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "40",
    "name": "Melissa Wells",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "27",
    "name": "Michael Jackson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "42B",
    "name": "Michele Guyton",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "35A",
    "name": "Mike Griffith",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "1",
    "name": "Mike McKay",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "32",
    "name": "Mike Rogers",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "10",
    "name": "Scott Phillips",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "39",
    "name": "Nancy King",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "9A",
    "name": "Natalie Ziegler",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "31",
    "name": "Nic Kipke",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "8",
    "name": "Nick Allen",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "25",
    "name": "Nick Charles",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "22",
    "name": "Nicole Williams",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "42A",
    "name": "Nino Mangione",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "13",
    "name": "Pam Guzzone",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "14",
    "name": "Pam Queen",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "32",
    "name": "Pamela Beidle",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "2",
    "name": "Paul Corderman",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "43A",
    "name": "Regina Boyce",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "6",
    "name": "Ric Metzgar",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "46",
    "name": "Robbyn Lewis",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "6",
    "name": "Bob Long",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "23",
    "name": "Ron Watson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "7A",
    "name": "Ryan Nawrocki",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "17",
    "name": "Ryan Spiegel",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "41",
    "name": "Sandy Rosenberg",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "16",
    "name": "Sara Love",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "16",
    "name": "Sarah Wolek",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "41",
    "name": "Sean Stinnett",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "30B",
    "name": "Seth Howard",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "30",
    "name": "Shaneka Henson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "44B",
    "name": "Sheila Ruth",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "11",
    "name": "Shelly Hettleman",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "37A",
    "name": "Sheree Sample-Hughes",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "45",
    "name": "Stephanie Smith",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "34A",
    "name": "Steve Johnson",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "36",
    "name": "Steve Arentz",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "33B",
    "name": "Stuart Schmidt",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "34B",
    "name": "Susan McComas",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "35A",
    "name": "Teresa Reilly",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "16",
    "name": "Teresa Woorman",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "12A",
    "name": "Terri Hill",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "1C",
    "name": "Terry Baker",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "24",
    "name": "Tiffany Alston",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "29C",
    "name": "Todd Morgan",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "37B",
    "name": "Tom Hutchinson",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "13",
    "name": "Vanessa Atterbeary",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "19",
    "name": "Vaughn Stewart",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "26",
    "name": "Veronica Turner",
    "party": "D"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "38C",
    "name": "Wayne Hartman",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "Senate",
    "district": "4",
    "name": "William Folden",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "2A",
    "name": "William Wivell",
    "party": "R"
  },
  {
    "state": "md",
    "chamber": "House",
    "district": "2A",
    "name": "William Valentine",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "7th Hampden",
    "name": "Aaron Saunders",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Suffolk",
    "name": "Aaron Michlewitz",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Hampden",
    "name": "Adam Gómez",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "14th Bristol",
    "name": "Adam Scanlon",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Suffolk",
    "name": "Adrian Madaro",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "14th Essex",
    "name": "Adrianne Ramos",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "7th Bristol",
    "name": "Alan Silvia",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "14th Norfolk",
    "name": "Alice Peisch",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "7th Plymouth",
    "name": "Alyson Sullivan-Almeida",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "11th Middlesex",
    "name": "Amy Sangiolo",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Essex",
    "name": "Andy Vargas",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "12th Hampden",
    "name": "Angelo Puppolo",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Essex",
    "name": "Ann-Margaret Ferrante",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "13th Bristol",
    "name": "Tony Cabral",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Second Essex and Middlesex",
    "name": "Barry Finegold",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "20th Middlesex",
    "name": "Brad Jones",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "12th Suffolk",
    "name": "Brandy Fluker-Reid",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Third Essex",
    "name": "Brendan Crighton",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Hampden",
    "name": "Brian Ashe",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "10th Worcester",
    "name": "Brian Murray",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "9th Plymouth",
    "name": "Bridget Plouffe",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "First Essex and Middlesex",
    "name": "Bruce Tarr",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Norfolk",
    "name": "Bruce Ayers",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "11th Hampden",
    "name": "Bud Williams",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "10th Hampden",
    "name": "Carlos González",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "13th Middlesex",
    "name": "Carmine Gentile",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "6th Bristol",
    "name": "Carole Fiola",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "34th Middlesex",
    "name": "Christine Barber",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "11th Bristol",
    "name": "Chris Hendricks",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Suffolk",
    "name": "Chris Worrell",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "9th Bristol",
    "name": "Christopher Markey",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Barnstable",
    "name": "Chris Flanagan",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "7th Suffolk",
    "name": "Chynah Tyler",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Fourth Middlesex",
    "name": "Cindy Friedman",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "36th Middlesex",
    "name": "Colleen Garry",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Norfolk and Middlesex",
    "name": "Cynthia Creem",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "10th Essex",
    "name": "Dan Cahill",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "13th Suffolk",
    "name": "Dan Hunt",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Suffolk",
    "name": "Danny Ryan",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "16th Worcester",
    "name": "Dan Donahue",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Middlesex",
    "name": "Danielle Gregoire",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "37th Middlesex",
    "name": "Dan Sena",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "19th Middlesex",
    "name": "Dave Robertson",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Suffolk",
    "name": "David Biele",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Plymouth",
    "name": "David DeCoste",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "17th Worcester",
    "name": "David LeBoeuf",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "9th Worcester",
    "name": "Dave Muradian",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "24th Middlesex",
    "name": "Dave Rogers",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Middlesex",
    "name": "David Linsky",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Barnstable",
    "name": "Dave Vieira",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Essex",
    "name": "Dawne Shand",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "8th Plymouth",
    "name": "Dennis Gallagher",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "9th Essex",
    "name": "Donald Wong",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Worcester",
    "name": "Donnie Berthiaume",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Plymouth and Barnstable",
    "name": "Dylan Fernandes",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "First Middlesex",
    "name": "Ed Kennedy",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "8th Norfolk",
    "name": "Ted Philips",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "27th Middlesex",
    "name": "Erika Uyterhoeven",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Essex",
    "name": "Estela Reyes",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "16th Essex",
    "name": "Francisco Paulino",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "17th Essex",
    "name": "Frank Moran",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "12th Middlesex",
    "name": "Greg Schwartz",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Barnstable",
    "name": "Hadley Luddy",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "6th Essex",
    "name": "Hannah Bowen",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "11th Worcester",
    "name": "Hannah Kane",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Hampshire",
    "name": "Homar Gomez",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "7th Middlesex",
    "name": "Jack Lewis",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Middlesex",
    "name": "Jim Arciero",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Middlesex and Worcester",
    "name": "Jamie Eldridge",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "8th Middlesex",
    "name": "James Arena-DeRosa",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "14th Worcester",
    "name": "Jim O'Day",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Bristol",
    "name": "Jim Hawkins",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Norfolk",
    "name": "Jamie Murphy",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Fifth Middlesex",
    "name": "Jason Lewis",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "8th Suffolk",
    "name": "Jay Livingstone",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "10th Norfolk",
    "name": "Jeff Roy",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "19th Suffolk",
    "name": "Jeff Turco",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "8th Essex",
    "name": "Jenny Armini",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "16th Suffolk",
    "name": "Jessica Giannino",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Second Essex",
    "name": "Joan Lovely",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Plymouth",
    "name": "Joan Meschino",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Berkshire",
    "name": "John Barrett",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Hampden and Hampshire",
    "name": "John Velis",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Worcester and Middlesex",
    "name": "John Cronin",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Norfolk and Plymouth",
    "name": "John Keenan",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "9th Suffolk",
    "name": "John Moran",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Plymouth",
    "name": "John Gaskey",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "12th Norfolk",
    "name": "John Rogers",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "10th Middlesex",
    "name": "John Lawn",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "13th Worcester",
    "name": "John Mahoney",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "6th Worcester",
    "name": "John Marsi",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Worcester",
    "name": "Jon Zlotnik",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "18th Worcester",
    "name": "Joe McKenna",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "28th Middlesex",
    "name": "Joe McGonagle",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "13th Norfolk",
    "name": "Josh Tarsky",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "11th Suffolk",
    "name": "Judith García",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Cape and Islands",
    "name": "Julian Cyr",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Bristol",
    "name": "Justin Thurber",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Middlesex and Norfolk",
    "name": "Karen Spilka",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "19th Worcester",
    "name": "Kate Donaghue",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Middlesex",
    "name": "Kate Hogan",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "32nd Middlesex",
    "name": "Kate Lipper-Garabedian",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "12th Plymouth",
    "name": "Kathy LaNatra",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Third Bristol and Plymouth",
    "name": "Kelly Dooner",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Hampden",
    "name": "Kelly Pease",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "6th Plymouth",
    "name": "Ken Sweezey",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "21st Middlesex",
    "name": "Ken Gordon",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "17th Suffolk",
    "name": "Kevin Honan",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Worcester",
    "name": "Kim Ferguson",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Barnstable",
    "name": "Kip Diggs",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Essex",
    "name": "Kristin Kassner",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Berkshire",
    "name": "Leigh Davis",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Hampshire",
    "name": "Lindsay Sabadosa",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Bristol",
    "name": "Lisa Field",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Second Suffolk",
    "name": "Liz Miranda",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Third Suffolk",
    "name": "Lydia Edwards",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "7th Essex",
    "name": "Manny Cruz",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "22nd Middlesex",
    "name": "Marc Lombardo",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "9th Norfolk",
    "name": "Marcus Vaughn",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Middlesex",
    "name": "Margaret Scarsdale",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "25th Middlesex",
    "name": "Marjorie Decker",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Second Bristol and Plymouth",
    "name": "Mark Montigny",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Norfolk",
    "name": "Mark Cusack",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "10th Bristol",
    "name": "Mark Sylvia",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "15th Worcester",
    "name": "Mary Keefe",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "12th Worcester",
    "name": "Meg Kilcoyne",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Second Plymouth and Norfolk",
    "name": "Mike Brady",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Norfolk and Suffolk",
    "name": "Mike Rush",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Third Middlesex",
    "name": "Mike Barrett",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "6th Hampden",
    "name": "Mike Finn",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "18th Suffolk",
    "name": "Mike Moran",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "First Bristol and Plymouth",
    "name": "Michael Rodrigues",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "8th Worcester",
    "name": "Mike Soter",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Second Worcester",
    "name": "Mike Moore",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Worcester",
    "name": "Mike Kushmerek",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "31st Middlesex",
    "name": "Mike Day",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Plymouth",
    "name": "Michelle Badger",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "15th Middlesex",
    "name": "Michelle Ciccolo",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "10th Plymouth",
    "name": "Michelle DuBois",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Bristol",
    "name": "Mike Chaisson",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "26th Middlesex",
    "name": "Mike Connolly",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Hampshire",
    "name": "Mindy Domb",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Worcester",
    "name": "Natalie Higgins",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Franklin",
    "name": "Natalie Blais",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Hampden",
    "name": "Nick Boldyga",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "First Suffolk",
    "name": "Nick Collins",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "12th Bristol",
    "name": "Norm Orrall",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "9th Hampden",
    "name": "Orlando Ramos",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Hampden",
    "name": "Pat Duffy",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Second Middlesex",
    "name": "Pat Jehlen",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Plymouth",
    "name": "Patrick Kearney",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "First Plymouth and Norfolk",
    "name": "Patrick O'Connor",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "35th Middlesex",
    "name": "Paul Donato",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "7th Worcester",
    "name": "Paul Frost",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "11th Norfolk",
    "name": "Paul McMurtry",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Bristol and Norfolk",
    "name": "Paul Feeney",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "First Essex",
    "name": "Pavel Payano",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Worcester and Hampshire",
    "name": "Peter Durant",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "6th Middlesex",
    "name": "Priscila Sousa",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "30th Middlesex",
    "name": "Rich Haggerty",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "7th Norfolk",
    "name": "Richard Wells",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "11th Plymouth",
    "name": "Rita Mendes",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "14th Suffolk",
    "name": "Rob Consalvo",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "First Worcester",
    "name": "Robyn Kennedy",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "16th Middlesex",
    "name": "Rodney Elliott",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "3rd Norfolk",
    "name": "Ron Mariano",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "6th Suffolk",
    "name": "Russell Holmes",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Worcester and Hampden",
    "name": "Ryan Fattman",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "15th Essex",
    "name": "Ryan Hamilton",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Middlesex and Suffolk",
    "name": "Sal DiDomenico",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "13th Essex",
    "name": "Sally Kerans",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "15th Suffolk",
    "name": "Sam Montaño",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "23rd Middlesex",
    "name": "Sean Garballey",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "11th Essex",
    "name": "Sean Reid",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "8th Hampden",
    "name": "Shirley Arriaga",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "14th Middlesex",
    "name": "Simon Cataldo",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "29th Middlesex",
    "name": "Steve Owens",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "5th Barnstable",
    "name": "Steve Xiarhos",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "8th Bristol",
    "name": "Steven Ouellette",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "4th Bristol",
    "name": "Steven Howitt",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "33rd Middlesex",
    "name": "Steve Ultrino",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Franklin",
    "name": "Susannah Whipps",
    "party": "I"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Norfolk",
    "name": "Tackey Chan",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "18th Middlesex",
    "name": "Tara Hong",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "9th Middlesex",
    "name": "Tom Stanley",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "12th Essex",
    "name": "Tom Walsh",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "1st Hampden",
    "name": "Todd Smola",
    "party": "R"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "15th Norfolk",
    "name": "Tommy Vitolo",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "18th Essex",
    "name": "Tram Nguyen",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "2nd Berkshire",
    "name": "Tricia Farley-Bouvier",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "17th Middlesex",
    "name": "Vanna Howard",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "6th Norfolk",
    "name": "Bill Galvin",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "House",
    "district": "10th Suffolk",
    "name": "Billy MacGregor",
    "party": "D"
  },
  {
    "state": "ma",
    "chamber": "Senate",
    "district": "Suffolk and Middlesex",
    "name": "Will Brownsberger",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "3",
    "name": "Alabas Farhat",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "62",
    "name": "Alicia St. Germaine",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "94",
    "name": "Amos O'Neal",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "79",
    "name": "Angela Rigas",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "76",
    "name": "Angela Witwer",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "49",
    "name": "Ann Bollin",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "20",
    "name": "Aric Nesbitt",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "103",
    "name": "Betsy Coffia",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "95",
    "name": "Bill Schuette",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "37",
    "name": "Brad Paquette",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "85",
    "name": "Brad Slagh",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "53",
    "name": "Brenda Carter",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "71",
    "name": "Brian BeGole",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "90",
    "name": "Bryan Posthumus",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "106",
    "name": "Cam Cavitt",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "84",
    "name": "Carol Glanville",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "47",
    "name": "Carrie Rheingans",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "102",
    "name": "Curt VanderWall",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "70",
    "name": "Cynthia Neeley",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "25",
    "name": "Dan Lauwers",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "4",
    "name": "Darrin Camilleri",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "68",
    "name": "David Martin",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "108",
    "name": "Dave Prestin",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "5",
    "name": "Dayna Polehanki",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "61",
    "name": "Denise Mentzer",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "11",
    "name": "Donavan McKinney",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "54",
    "name": "Donni Steele",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "59",
    "name": "Doug Wozniak",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "26",
    "name": "Dylan Wegela",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "38",
    "name": "Ed McBroom",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "77",
    "name": "Emily Dievendorf",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "1",
    "name": "Erika Geiss",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "15",
    "name": "Erin Byrnes",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "78",
    "name": "Gina Johnsen",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "88",
    "name": "Greg VanWoerkom",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "98",
    "name": "Greg Alexander",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "110",
    "name": "Greg Markkanen",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "8",
    "name": "Helena Scott",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "65",
    "name": "Jaime Greene",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "29",
    "name": "Jim DeSana",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "28",
    "name": "Jamie Thompson",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "18",
    "name": "Jason Hoskins",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "23",
    "name": "Jason Morgan",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "50",
    "name": "Jason Woolford",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "69",
    "name": "Jaz Martus",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "63",
    "name": "Jay DeBoyer",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "15",
    "name": "Jeff Irwin",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "48",
    "name": "Jennifer Conlin",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "35",
    "name": "Jennifer Wortz",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "7",
    "name": "Jeremy Moss",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "92",
    "name": "Jerry Neyer",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "23",
    "name": "Jim Runestad",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "32",
    "name": "Jimmie Wilson",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "64",
    "name": "Joe Pavlov",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "9",
    "name": "Joe Tate",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "38",
    "name": "Joey Andrews",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "27",
    "name": "John Cherry",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "37",
    "name": "John Damoose",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "83",
    "name": "John Fitzgerald",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "104",
    "name": "J.R. Roth",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "32",
    "name": "Jon Bumstead",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "17",
    "name": "Jonathan Lindsey",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "60",
    "name": "Joe Aragona",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "16",
    "name": "Joe Bellino",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "101",
    "name": "Joseph Fox",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "66",
    "name": "Josh Schriver",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "73",
    "name": "Julie Brixie",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "41",
    "name": "Julie Rogers",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "74",
    "name": "Kara Hope",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "4",
    "name": "Karen Whitsett",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "109",
    "name": "Karl Bohnak",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "46",
    "name": "Kathy Schmaltz",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "21",
    "name": "Kelly Breen",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "105",
    "name": "Ken Borton",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "26",
    "name": "Kevin Daley",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "12",
    "name": "Kevin Hertel",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "12",
    "name": "Kimberly Edwards",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "82",
    "name": "Kristian Grant",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "22",
    "name": "Lana Theis",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "17",
    "name": "Laurie Pohutsky",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "89",
    "name": "Luke Meerman",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "13",
    "name": "Mai Xiong",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "8",
    "name": "Mallory McMorrow",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "30",
    "name": "Mark Huizenga",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "55",
    "name": "Mark Tisdel",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "6",
    "name": "Mary Cavanagh",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "97",
    "name": "Matt Bierlein",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "42",
    "name": "Matt Hall",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "22",
    "name": "Matt Koleszar",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "40",
    "name": "Matt Longjohn",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "51",
    "name": "Matt Maddock",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "9",
    "name": "Michael Webber",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "36",
    "name": "Michele Hoitenga",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "52",
    "name": "Mike Harris",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "99",
    "name": "Mike Hoadley",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "14",
    "name": "Mike McFall",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "72",
    "name": "Mike Mueller",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "33",
    "name": "Morgan Foreman",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "86",
    "name": "Nancy DeBoer",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "34",
    "name": "Nancy Jenkins-Arno",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "6",
    "name": "Natalie Price",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "20",
    "name": "Noah Arbit",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "107",
    "name": "Parker Fairbairn",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "91",
    "name": "Pat Outman",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "10",
    "name": "Paul Wojno",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "39",
    "name": "Pauline Wendzel",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "75",
    "name": "Penelope Tsernoglou",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "25",
    "name": "Peter Herzberg",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "67",
    "name": "Phil Green",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "80",
    "name": "Phil Skaggs",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "43",
    "name": "Rachelle Smit",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "24",
    "name": "Ranjeev Puri",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "31",
    "name": "Reggie Miller",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "5",
    "name": "Regina Weiss",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "33",
    "name": "Rick Outman",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "34",
    "name": "Roger Hauck",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "31",
    "name": "Roger Victory",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "58",
    "name": "Ron Robinson",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "13",
    "name": "Rosemary Bayer",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "24",
    "name": "Ruth Johnson",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "27",
    "name": "Rylee Linting",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "28",
    "name": "Sam Singh",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "19",
    "name": "Samantha Steckloff",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "21",
    "name": "Sarah Anthony",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "45",
    "name": "Sarah Lightner",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "19",
    "name": "Sean McCann",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "56",
    "name": "Sharon MacDonell",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "3",
    "name": "Stephanie Chang",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "16",
    "name": "Stephanie Young",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "81",
    "name": "Stephen Wooden",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "36",
    "name": "Steve Carra",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "44",
    "name": "Steve Frisbie",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "14",
    "name": "Sue Shink",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "2",
    "name": "Sylvia Santana",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "18",
    "name": "Thomas Albert",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "57",
    "name": "Tom Kuhn",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "93",
    "name": "Tim Kelly",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "96",
    "name": "Timmy Beson",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "100",
    "name": "Tom Kunse",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "7",
    "name": "Tonya Phillips",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "2",
    "name": "Tullio Liberati",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "1",
    "name": "Tyrone Carter",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "11",
    "name": "Veronica Klinefelt",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "10",
    "name": "Veronica Paiz",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "30",
    "name": "Will Bruck",
    "party": "R"
  },
  {
    "state": "mi",
    "chamber": "House",
    "district": "87",
    "name": "Will Snyder",
    "party": "D"
  },
  {
    "state": "mi",
    "chamber": "Senate",
    "district": "29",
    "name": "Winnie Brinks",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "62A",
    "name": "Aisha Gomez",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "49A",
    "name": "Alex Falconer",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "50",
    "name": "Alice Mann",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "8B",
    "name": "Liish Kozlowski",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "47A",
    "name": "Amanda Hemmingsen-Jaeger",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "27",
    "name": "Andrew Mathews",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "45A",
    "name": "Andrew Myers",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "16",
    "name": "Andrew Lang",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "25B",
    "name": "Andy Smith",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "43",
    "name": "Ann Rest",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "45",
    "name": "Ann Johnson Stewart",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "62B",
    "name": "Anquam Mahamoud",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "14",
    "name": "Aric Putnam",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "66B",
    "name": "Athena Hollins",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "54B",
    "name": "Ben Bakeberg",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "6A",
    "name": "Ben Davis",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "14A",
    "name": "Bernie Perryman",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "52B",
    "name": "Bianca Virnig",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "2A",
    "name": "Bidal Duran",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "58",
    "name": "Bill Lieske",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "21",
    "name": "Bill Weber",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "22A",
    "name": "Bjorn Olson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "17B",
    "name": "Bobbie Harder",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "59",
    "name": "Bobby Joe Champion",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "42",
    "name": "Bonnie Westlin",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "54A",
    "name": "Brad Tabke",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "36B",
    "name": "Brion Curran",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "29",
    "name": "Bruce Anderson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "27B",
    "name": "Bryan Lawrence",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "31",
    "name": "Cal Bahr",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "7B",
    "name": "Cal Warwas",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "24",
    "name": "Carla Nelson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "49B",
    "name": "Carlie Kotyza-Witthuhn",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "43A",
    "name": "Cedrick Frazier",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "46B",
    "name": "Cheryl Youakim",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "15A",
    "name": "Chris Swedzinski",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "66",
    "name": "Clare Oumou Verbeten",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "61",
    "name": "Scott Dibble",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "14B",
    "name": "Dan Wolgamott",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "34A",
    "name": "Danny Nadeau",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "16B",
    "name": "Dave Baker",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "64B",
    "name": "Dave Pinto",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "40B",
    "name": "David Gottfried",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "17A",
    "name": "Dawn Gillman",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "60",
    "name": "Doron Clark",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "58B",
    "name": "Drew Roach",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "24A",
    "name": "Duane Quam",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "36A",
    "name": "Elliott Engen",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "63B",
    "name": "Emma Greenman",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "30",
    "name": "Eric Lucero",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "54",
    "name": "Eric Pratt",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "18A",
    "name": "Erica Schwartz",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "56",
    "name": "Erin Maye Quade",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "39A",
    "name": "Erin Koegel",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "64",
    "name": "Erin Murphy",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "59B",
    "name": "Esther Agbaje",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "47B",
    "name": "Ethan Cha",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "67",
    "name": "Foung Hawj",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "59A",
    "name": "Fue Lee",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "15",
    "name": "Gary Dahms",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "23",
    "name": "Gene Dornink",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "42B",
    "name": "Ginny Klevorn",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "17",
    "name": "Glenn Gruenhagen",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "3",
    "name": "Grant Hauschild",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "26B",
    "name": "Greg Davids",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "31A",
    "name": "Harry Niska",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "36",
    "name": "Heather Gustafson",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "4A",
    "name": "Heather Keeler",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "38A",
    "name": "Huldah Hiltsley",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "10B",
    "name": "Isaac Schultz",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "61B",
    "name": "Jamie Long",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "11",
    "name": "Jason Rarick",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "67B",
    "name": "Jay Xiong",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "9A",
    "name": "Jeff Backer",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "11A",
    "name": "Jeff Dotseth",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "13",
    "name": "Jeff Howe",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "57B",
    "name": "Jeff Witte",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "8",
    "name": "Jen McEwen",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "26",
    "name": "Jeremy Miller",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "55A",
    "name": "Jess Hanson",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "35",
    "name": "Jim Abeler",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "52",
    "name": "Jim Carlson",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "4B",
    "name": "Jim Joy",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "48A",
    "name": "Jim Nash",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "28A",
    "name": "Jimmy Gordon",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "29A",
    "name": "Joe McDonald",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "21A",
    "name": "Joe Schomacker",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "34",
    "name": "John Hoffman",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "1A",
    "name": "John Burkel",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "56B",
    "name": "John Huot",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "40",
    "name": "John Marty",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "19",
    "name": "John Jasinski",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "57A",
    "name": "Jon Koznick",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "9",
    "name": "Jordan Rasmusson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "6B",
    "name": "Josh Heintzeman",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "33B",
    "name": "Josiah Hill",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "41",
    "name": "Judy Seeberger",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "48",
    "name": "Julia Coleman",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "50A",
    "name": "Julie Greene",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "55B",
    "name": "Kaela Berg",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "64A",
    "name": "Kaohly Her",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "35B",
    "name": "Kari Rehrauer",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "33",
    "name": "Karin Housley",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "61A",
    "name": "Katie Jones",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "19A",
    "name": "Keith Allen",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "40A",
    "name": "Kelly Moller",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "6",
    "name": "Keri Heintzeman",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "25A",
    "name": "Kim Hicks",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "5A",
    "name": "Krista Knudsen",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "58A",
    "name": "Kristi Pursell",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "37B",
    "name": "Kristin Bahner",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "37A",
    "name": "Kristin Robbins",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "46A",
    "name": "Larry Kraft",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "66A",
    "name": "Leigh Finke",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "44B",
    "name": "Leon Lillie",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "55",
    "name": "Lindsey Port",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "13A",
    "name": "Lisa Demuth",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "25",
    "name": "Liz Boldon",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "67A",
    "name": "Liz Lee",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "52A",
    "name": "Liz Reyer",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "48B",
    "name": "Lucy Rehm",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "18B",
    "name": "Luke Frederick",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "65B",
    "name": "María Isa Pérez-Vega",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "29B",
    "name": "Marion Rarick",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "21B",
    "name": "Marj Fogelman",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "1",
    "name": "Mark Johnson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "28",
    "name": "Mark Koran",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "53A",
    "name": "Mary Clardy",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "12B",
    "name": "Mary Franson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "39",
    "name": "Mary Kunesh-Podein",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "2B",
    "name": "Matt Bliss",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "53",
    "name": "Matt Klein",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "32B",
    "name": "Matt Norris",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "28B",
    "name": "Max Rymer",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "51",
    "name": "Melissa Wiklund",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "32",
    "name": "Michael Kreun",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "51A",
    "name": "Mike Howard",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "43B",
    "name": "Mike Freiberg",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "5B",
    "name": "Mike Wiener",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "60B",
    "name": "Mohamud Noor",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "3B",
    "name": "Natalie Zeleznikar",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "51B",
    "name": "Nathan Coulter",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "11B",
    "name": "Nathan Nelson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "10",
    "name": "Nathan Wesenberg",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "42A",
    "name": "Ned Carroll",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "18",
    "name": "Nick Frentz",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "47",
    "name": "Nicole Mitchell",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "32A",
    "name": "Nolan West",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "62",
    "name": "Omar Fateh",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "20A",
    "name": "Pam Altendorf",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "23B",
    "name": "Patty Mueller",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "33A",
    "name": "Patti Anderson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "45B",
    "name": "Patty Acomb",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "12A",
    "name": "Paul Anderson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "5",
    "name": "Paul Utke",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "30B",
    "name": "Paul Novotny",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "15B",
    "name": "Paul Torkelson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "23A",
    "name": "Peggy Bennett",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "31B",
    "name": "Peggy Scott",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "8A",
    "name": "Pete Johnson",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "44A",
    "name": "Peter Fischer",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "22",
    "name": "Rich Draheim",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "53B",
    "name": "Rick Hansen",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "26A",
    "name": "Ripper Repinski",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "56A",
    "name": "Robert Bierman",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "7",
    "name": "Rob Farnsworth",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "4",
    "name": "Rob Kupec",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "3A",
    "name": "Roger Skraba",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "10A",
    "name": "Ron Kresha",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "46",
    "name": "Ron Latz",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "65A",
    "name": "Samakab Hussein",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "63A",
    "name": "Samantha Sencer-Mura",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "38B",
    "name": "Samantha Vang",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "39B",
    "name": "Sandra Feist",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "65",
    "name": "Sandy Pappas",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "16A",
    "name": "Scott Van Binsbergen",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "27A",
    "name": "Shane Mekeland",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "7A",
    "name": "Spencer Igo",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "49",
    "name": "Steve Cwodzinski",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "20",
    "name": "Steve Drazkowski",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "50B",
    "name": "Steve Elkins",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "1B",
    "name": "Steve Gander",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "2",
    "name": "Steve Green",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "20B",
    "name": "Steve Jacob",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "38",
    "name": "Susan Pha",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "60A",
    "name": "Sydney Jordan",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "22B",
    "name": "Terry Stier",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "13B",
    "name": "Tim O'Driscoll",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "24B",
    "name": "Tina Liebling",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "41B",
    "name": "Tom Dippel",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "9B",
    "name": "Tom Murphy",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "19B",
    "name": "Tom Sexton",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "12",
    "name": "Torrey Westrom",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "44",
    "name": "Tou Xiong",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "30A",
    "name": "Walter Hudson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "37",
    "name": "Warren Limmer",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "41A",
    "name": "Wayne Johnson",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "57",
    "name": "Zach Duckworth",
    "party": "R"
  },
  {
    "state": "mn",
    "chamber": "House",
    "district": "35A",
    "name": "Zack Stephenson",
    "party": "D"
  },
  {
    "state": "mn",
    "chamber": "Senate",
    "district": "63",
    "name": "Zaynab Mohamed",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "37",
    "name": "Albert Butler",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "35",
    "name": "Andy Berry",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "37",
    "name": "Andy Boyd",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "40",
    "name": "Angela Hill",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "96",
    "name": "Angela Cockerham",
    "party": "I"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "16",
    "name": "Angela Turner-Ford",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "21",
    "name": "Bradford Blackmon",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "15",
    "name": "Bart Williams",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "92",
    "name": "Becky Currie",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "8",
    "name": "Ben Suber",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "15",
    "name": "Beth Waldo",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "52",
    "name": "Bill Kinkade",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "99",
    "name": "Bill Pigott",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "83",
    "name": "Billy Adam Calvert",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "70",
    "name": "Bo Brown",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "91",
    "name": "Bob Evans",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "2",
    "name": "Brad Mattox",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "122",
    "name": "Brent Anderson",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "59",
    "name": "Brent Powell",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "36",
    "name": "Brian Rhodes",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "52",
    "name": "Brice Wiggins",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "47",
    "name": "Bryant Clark",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "44",
    "name": "C. Scott Bounds",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "42",
    "name": "Carl Mickens",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "121",
    "name": "Carolyn Crawford",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "116",
    "name": "Casey Eure",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "9",
    "name": "Cedric Burnett",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "75",
    "name": "Celeste Hurst",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "6",
    "name": "Chad McMahan",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "38",
    "name": "Cheikh Taylor",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "45",
    "name": "Chris Johnson",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "65",
    "name": "Chris Bell",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "88",
    "name": "Chuck Blackwell",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "17",
    "name": "Chuck Younger",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "12",
    "name": "Clay Deweese",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "56",
    "name": "Clay Mansell",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "25",
    "name": "Dan Eubanks",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "39",
    "name": "Dana McLean",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "5",
    "name": "Daniel Sparks",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "98",
    "name": "Daryl Porter",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "29",
    "name": "David Blount",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "2",
    "name": "David Parker",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "30",
    "name": "Dean Kirby",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "43",
    "name": "Dennis DeBar",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "12",
    "name": "Derrick Simmons",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "28",
    "name": "Doc Harris",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "21",
    "name": "Donnie Bell",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "89",
    "name": "Donnie Scoggin",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "67",
    "name": "Earle Banks",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "57",
    "name": "Lawrence Blackmon",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "105",
    "name": "Elliot Burch",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "66",
    "name": "Fabian Nelson",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "60",
    "name": "Fred Shanks",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "38",
    "name": "Gary Brumfield",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "61",
    "name": "Gene Newman",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "118",
    "name": "Greg Haney",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "82",
    "name": "Gregory Elliott",
    "party": "I"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "76",
    "name": "Gregory Holloway",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "113",
    "name": "Hank Zuber",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "40",
    "name": "Hester Jackson-McCray",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "27",
    "name": "Hillman Frazier",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "7",
    "name": "Hob Bryan",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "25",
    "name": "Walter Michel",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "106",
    "name": "Jansen Owen",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "39",
    "name": "Jason Barrett",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "48",
    "name": "Jason White",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "95",
    "name": "Jay McKnight",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "24",
    "name": "Jeff Hale",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "33",
    "name": "Jeff Tate",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "85",
    "name": "Jeffery Harness",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "119",
    "name": "Jeffrey Hulum",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "114",
    "name": "Jeff Guice",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "110",
    "name": "Jeramey Anderson",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "51",
    "name": "Jeremy England",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "18",
    "name": "Jerry Turner",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "73",
    "name": "Jill Ford",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "33",
    "name": "Jim Estrada",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "111",
    "name": "Jimmy Fondren",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "4",
    "name": "Jody Steverson",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "49",
    "name": "Joel Carter",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "41",
    "name": "Joey Fillingane",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "35",
    "name": "Joey Hood",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "44",
    "name": "John Polk",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "5",
    "name": "John Faulkner",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "112",
    "name": "John Read",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "8",
    "name": "Trey Lamar",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "50",
    "name": "John Hines",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "22",
    "name": "Jon Lancaster",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "58",
    "name": "Jonathan McMillan",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "47",
    "name": "Mike Seymour",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "22",
    "name": "Joseph Thomas",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "87",
    "name": "Joseph Tubb",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "20",
    "name": "Josh Harkins",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "10",
    "name": "Josh Hawkins",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "34",
    "name": "Juan Barnett",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "6",
    "name": "Justin Keen",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "72",
    "name": "Justis Gibbs",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "41",
    "name": "Kabir Karriem",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "36",
    "name": "Karl Gibbs",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "46",
    "name": "Karl Oliver",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "3",
    "name": "Kathy Chism",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "45",
    "name": "Keith Jackson",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "100",
    "name": "Ken Morgan",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "27",
    "name": "Kenji Holloway",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "101",
    "name": "Kent McCarty",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "19",
    "name": "Kevin Blackwell",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "117",
    "name": "Kevin Felsher",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "54",
    "name": "Kevin Ford",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "34",
    "name": "Kevin Horan",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "7",
    "name": "Kimberly Remak",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "62",
    "name": "Lance Varner",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "18",
    "name": "Lane Taylor",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "104",
    "name": "Larry Byrd",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "11",
    "name": "Lataisha Jackson",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "74",
    "name": "Lee Yancey",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "1",
    "name": "Bubba Carpenter",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "14",
    "name": "Lydia Chassaniol",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "109",
    "name": "Manly Barton",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "79",
    "name": "Mark Tullos",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "1",
    "name": "Michael McLendon",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "48",
    "name": "Mike Thompson",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "102",
    "name": "Missy McGee",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "10",
    "name": "Neil Whaley",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "9",
    "name": "Nicole Boyd",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "90",
    "name": "Noah Sanford",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "80",
    "name": "Omeria Scott",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "55",
    "name": "Oscar Denton",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "31",
    "name": "Otis Anthony",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "103",
    "name": "Percy Watson",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "23",
    "name": "Perry Bailey",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "46",
    "name": "Philman Ladner",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "77",
    "name": "Price Wallace",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "19",
    "name": "Randy Boyd",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "78",
    "name": "Randy Rushing",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "120",
    "name": "Richard Bennett",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "16",
    "name": "Rickey Thompson",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "4",
    "name": "Rita Parks",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "43",
    "name": "Rob Roberson",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "11",
    "name": "Reginald Jackson",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "94",
    "name": "Robert Johnson",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "29",
    "name": "Robert Sanders",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "42",
    "name": "Robin Robinson",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "32",
    "name": "Rod Hickman",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "20",
    "name": "Rodney Hall",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "71",
    "name": "Ronnie Crudup",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "97",
    "name": "Sam Mims",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "14",
    "name": "Sam Creekmore",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "13",
    "name": "Sarita Simmons",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "50",
    "name": "Scott DeLano",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "64",
    "name": "Shanda Yates",
    "party": "I"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "17",
    "name": "Shane Aguirre",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "86",
    "name": "Shane Barnett",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "28",
    "name": "Sollie Norwood",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "32",
    "name": "Solomon Osborne",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "108",
    "name": "Stacey Hobgood-Wilkes",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "63",
    "name": "Stephanie Foster",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "81",
    "name": "Steve Horne",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "107",
    "name": "Steve Lott",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "13",
    "name": "Steve Massengill",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "69",
    "name": "Grace Butler-Washington",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "51",
    "name": "Timaka James-Jones",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "93",
    "name": "Timmy Ladner",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "30",
    "name": "Tracey Rosebud",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "84",
    "name": "Troy Smith",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "31",
    "name": "Tyler McCaughn",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "53",
    "name": "Vince Mangold",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "Senate",
    "district": "23",
    "name": "Briggs Hopson",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "3",
    "name": "Tracy Arnold",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "49",
    "name": "Willie Bailey",
    "party": "D"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "115",
    "name": "Zack Grady",
    "party": "R"
  },
  {
    "state": "ms",
    "chamber": "House",
    "district": "68",
    "name": "Zakiya Summers",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "29",
    "name": "Aaron Crossley",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "23",
    "name": "Adam Schnelting",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "47",
    "name": "Adrian Plank",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "134",
    "name": "Alex Riley",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "13",
    "name": "Angela Mosley",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "127",
    "name": "Ann Kelley",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "36",
    "name": "Anthony Ealy",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "14",
    "name": "Ashley Aune",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "9",
    "name": "Barbara Washington",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "146",
    "name": "Barry Hovis",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "117",
    "name": "Becky Laubinger",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "26",
    "name": "Ben Brown",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "101",
    "name": "Ben Keathley",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "143",
    "name": "Bennie Cook",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "135",
    "name": "Betsy Fogle",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "17",
    "name": "Bill Allen",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "10",
    "name": "Bill Falkner",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "121",
    "name": "Bill Hardwick",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "55",
    "name": "Bill Irwin",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "115",
    "name": "Bill Lucas",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "131",
    "name": "Bill Owen",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "130",
    "name": "Bishop Davidson",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "162",
    "name": "Bob Bromley",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "139",
    "name": "Bob Titus",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "119",
    "name": "Brad Banderman",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "96",
    "name": "Brad Christ",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "33",
    "name": "Brad Hudson",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "52",
    "name": "Brad Pollitt",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "54",
    "name": "Brandon Phelps",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "11",
    "name": "Brenda Shields",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "156",
    "name": "Brian Seitz",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "14",
    "name": "Brian Williams",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "93",
    "name": "Bridget Moore",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "61",
    "name": "Bruce Sassmann",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "145",
    "name": "Bryant Wolfin",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "138",
    "name": "Burt Whaley",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "150",
    "name": "Cameron Parker",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "33",
    "name": "Carolyn Caton",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "163",
    "name": "Cathy Loy",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "111",
    "name": "Cecelie Williams",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "40",
    "name": "Chad Perkins",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "75",
    "name": "Chanel Mosley",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "16",
    "name": "Chris Brown",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "128",
    "name": "Chris Warwick",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "18",
    "name": "Cindy O'Laughlin",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "105",
    "name": "Colin Wellenkamp",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "87",
    "name": "Connie Steinmetz",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "20",
    "name": "Curtis Trent",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "116",
    "name": "Dale Wright",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "125",
    "name": "Dane Diehl",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "3",
    "name": "Danny Busick",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "137",
    "name": "Darin Chappell",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "60",
    "name": "Dave Griffith",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "103",
    "name": "Dave Hinman",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "97",
    "name": "David Casteel",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "148",
    "name": "David Dolan",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "15",
    "name": "David Gregory",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "46",
    "name": "David Smith",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "9",
    "name": "Dean VanSchoiack",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "64",
    "name": "Deanna Self",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "84",
    "name": "Del Taylor",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "159",
    "name": "Dirk Deaton",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "124",
    "name": "Don Mayhew",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "28",
    "name": "Donna Barnes",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "149",
    "name": "Donnie Brown",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "1",
    "name": "Doug Beck",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "72",
    "name": "Doug Clemens",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "41",
    "name": "Doyle Justus",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "6",
    "name": "Ed Lewis",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "24",
    "name": "Emily Weber",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "18",
    "name": "Eric Woods",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "89",
    "name": "George Hruza",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "4",
    "name": "Greg Sharpe",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "50",
    "name": "Gregg Bush",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "152",
    "name": "Hardy Billington",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "88",
    "name": "Holly Jones",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "99",
    "name": "Ian Mackey",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "98",
    "name": "Jaclyn Zimmermann",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "27",
    "name": "Jamie Burger",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "140",
    "name": "Jamie Ray Gragg",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "25",
    "name": "Jason Bean",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "32",
    "name": "Jeff Coleman",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "1",
    "name": "Jeff Farnan",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "86",
    "name": "Jeff Hales",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "142",
    "name": "Jeff Knight",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "42",
    "name": "Jeff Myers",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "123",
    "name": "Jeff Vernetti",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "132",
    "name": "Jeremy Dean",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "32",
    "name": "Jill Carter",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "126",
    "name": "Jim Kalberloh",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "94",
    "name": "Jim Murphy",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "49",
    "name": "Jim Schulte",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "91",
    "name": "Jo Doll",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "11",
    "name": "Joe Nicola",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "129",
    "name": "John Black",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "120",
    "name": "John Hewkin",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "44",
    "name": "John Martin",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "109",
    "name": "John Simmons",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "147",
    "name": "John Voss",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "30",
    "name": "Jon Patterson",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "8",
    "name": "Josh Hurlbert",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "16",
    "name": "Justin Brown",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "110",
    "name": "Justin Sparks",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "4",
    "name": "Karla May",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "45",
    "name": "Kathy Steinhoff",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "153",
    "name": "Keith Elliott",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "68",
    "name": "Kem Smith",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "34",
    "name": "Kemp Strickler",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "15",
    "name": "Ken Jamison",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "114",
    "name": "Ken Waller",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "43",
    "name": "Kent Haden",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "35",
    "name": "Keri Ingle",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "77",
    "name": "Kimberly-Ann Collins",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "21",
    "name": "Kurtis Gregory",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "71",
    "name": "LaDonna Appelbaum",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "79",
    "name": "LaKeySha Bosley",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "161",
    "name": "Lane Roberts",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "80",
    "name": "Lilly Fuchs",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "30",
    "name": "Lincoln Hough",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "154",
    "name": "Lisa Durnell",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "5",
    "name": "Louis Riggs",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "17",
    "name": "Maggie Nurrenbern",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "90",
    "name": "Mark Boyko",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "107",
    "name": "Mark Matthiesen",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "39",
    "name": "Mark Meirath",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "51",
    "name": "Mark Nolte",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "37",
    "name": "Mark Sharp",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "74",
    "name": "Marla Smith",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "66",
    "name": "Marlene Terry",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "76",
    "name": "Marlon Anderson",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "38",
    "name": "Marty Jacobs",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "78",
    "name": "Marty Murray",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "22",
    "name": "Mary Elizabeth Coleman",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "155",
    "name": "Matthew Overcast",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "2",
    "name": "Mazzie Christensen",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "133",
    "name": "Melanie Stinnett",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "27",
    "name": "Melissa Douglas",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "141",
    "name": "Melissa Schmidt",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "92",
    "name": "Michael Burton",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "56",
    "name": "Michael Davis",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "23",
    "name": "Michael Johnson",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "6",
    "name": "Mike Bernskoetter",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "8",
    "name": "Mike Cierpiot",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "108",
    "name": "Mike Costlow",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "3",
    "name": "Mike Henderson",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "12",
    "name": "Mike Jones",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "118",
    "name": "Mike McGirl",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "29",
    "name": "Mike Moon",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "20",
    "name": "Mike Steinmeyer",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "157",
    "name": "Mitch Boggs",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "82",
    "name": "Nick Kimble",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "2",
    "name": "Nick Schroer",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "25",
    "name": "Pattie Mansur",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "7",
    "name": "Patty Lewis",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "7",
    "name": "Peggy McGaugh",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "113",
    "name": "Phil Amato",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "100",
    "name": "Philip Oehlerking",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "83",
    "name": "Ray Reed",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "73",
    "name": "Raychel Proudie",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "112",
    "name": "Renee Reuter",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "102",
    "name": "Richard West",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "31",
    "name": "Rick Brattin",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "57",
    "name": "Rodger Reedy",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "31",
    "name": "Ron Fowler",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "59",
    "name": "Rudy Veit",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "12",
    "name": "Rusty Black",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "28",
    "name": "Sandy Crawford",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "158",
    "name": "Scott Cupps",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "69",
    "name": "Scott Miller",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "13",
    "name": "Sean Pouche",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "62",
    "name": "Sherri Gallick",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "70",
    "name": "Stephanie Boykin",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "136",
    "name": "Stephanie Hein",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "19",
    "name": "Stephen Webber",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "81",
    "name": "Steve Butz",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "151",
    "name": "Steve Jordan",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "5",
    "name": "Steve Roberts",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "122",
    "name": "Tara Peters",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "104",
    "name": "Terri Violet",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "53",
    "name": "Terry Thompson",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "26",
    "name": "Tiffany Price",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "48",
    "name": "Tim Taylor",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "144",
    "name": "Tony Harbison",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "34",
    "name": "Tony Luetkemeyer",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "67",
    "name": "Tonya Rush",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "24",
    "name": "Tracy McCreery",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "Senate",
    "district": "10",
    "name": "Travis Fitzwater",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "106",
    "name": "Travis Wilson",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "63",
    "name": "Tricia Byrnes",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "65",
    "name": "Wendy Hausman",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "19",
    "name": "Wick Thomas",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "21",
    "name": "Will Jobe",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "58",
    "name": "Willard Haley",
    "party": "R"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "22",
    "name": "Yolanda Young",
    "party": "D"
  },
  {
    "state": "mo",
    "chamber": "House",
    "district": "85",
    "name": "Yolonda Fountain-Henderson",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "60",
    "name": "Alanah Griffith",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "6",
    "name": "Amy Regier",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "48",
    "name": "Andrea Olsen",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "50",
    "name": "Anthony Nicastro",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "19",
    "name": "Barry Usher",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "38",
    "name": "Becky Beard",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "61",
    "name": "Becky Edwards",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "52",
    "name": "Bill Mercer",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "96",
    "name": "Bob Carter",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "17",
    "name": "Bob Phalen",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "55",
    "name": "Brad Barker",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "33",
    "name": "Brandon Ler",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "5",
    "name": "Braxton Mitchell",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "65",
    "name": "Brian Close",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "9",
    "name": "Butch Gillespie",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "68",
    "name": "Caleb Hinkle",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "3",
    "name": "Carl Glimm",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "42",
    "name": "Chip Fitzpatrick",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "33",
    "name": "Chris Pope",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "92",
    "name": "Connie Keogh",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "30",
    "name": "Cora Neumann",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "7",
    "name": "Courtenay Sprunger",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "90",
    "name": "Curt Cochran",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "48",
    "name": "Curtis Schomer",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "11",
    "name": "Daniel Emrich",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "22",
    "name": "Daniel Zolnikov",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "2",
    "name": "Dave Fern",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "86",
    "name": "Dave Bedey",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "3",
    "name": "Debo Powers",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "45",
    "name": "Denise Baum",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "32",
    "name": "Denise Hayman",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "46",
    "name": "Denise Joy",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "45",
    "name": "Denley Loge",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "25",
    "name": "Dennis Lenz",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "37",
    "name": "Derek Harvey",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "72",
    "name": "Donavon Hawk",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "11",
    "name": "Ed Byrne",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "59",
    "name": "Ed Stafman",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "21",
    "name": "Ed Buttrey",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "47",
    "name": "Ellie Boldman",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "23",
    "name": "Emma Kerr-Carpenter",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "28",
    "name": "Eric Albus",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "66",
    "name": "Eric Matthews",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "23",
    "name": "Eric Tilleman",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "56",
    "name": "Fiona Nave",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "28",
    "name": "Forrest Mandeville",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "31",
    "name": "Frank Smith",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "35",
    "name": "Gary Parry",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "21",
    "name": "Gayle Lammers",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "22",
    "name": "George Nikolakakos",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "7",
    "name": "Greg Hertz",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "36",
    "name": "Greg Kmetz",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "38",
    "name": "Greg Oblander",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "88",
    "name": "Greg Overstreet",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "15",
    "name": "Gregg Hunter",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "46",
    "name": "Jacinda Morigeau",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "41",
    "name": "Jade Sooktis",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "47",
    "name": "James Reavis",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "58",
    "name": "Jamie Isaly",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "77",
    "name": "Jane Gillette",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "19",
    "name": "Jane Weber",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "41",
    "name": "Janet Ellis",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "43",
    "name": "Jason Ellsworth",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "67",
    "name": "Jedediah Hinkle",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "73",
    "name": "Jennifer Lynch",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "10",
    "name": "Jeremy Trebas",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "34",
    "name": "Jerry Schillinger",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "83",
    "name": "Jill Cohenour",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "51",
    "name": "Jodee Etchart",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "29",
    "name": "John Esp",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "76",
    "name": "John Fitzpatrick",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "4",
    "name": "John Fuller",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "98",
    "name": "Jonathan Karlen",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "16",
    "name": "Jonathan Windy Boy",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "62",
    "name": "Josh Seckinger",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "13",
    "name": "Josh Kassmier",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "84",
    "name": "Julie Darling",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "85",
    "name": "Kathy Love",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "93",
    "name": "Katie Sullivan",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "44",
    "name": "Katie Zolnikov",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "64",
    "name": "Kelly Kortum",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "18",
    "name": "Ken Bogner",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "69",
    "name": "Ken Walsh",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "39",
    "name": "Kerri Seekins-Crowe",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "43",
    "name": "Larry Brewster",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "40",
    "name": "Laura Smith",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "54",
    "name": "Lee Deming",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "13",
    "name": "Linda Reksten",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "18",
    "name": "Llew Jones",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "8",
    "name": "Lukas Schubert",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "79",
    "name": "Luke Muszkiewicz",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "4",
    "name": "Lyn Bennett",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "74",
    "name": "Marc Lee",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "94",
    "name": "Marilyn Marler",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "6",
    "name": "Mark Noland",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "89",
    "name": "Mark Thane",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "42",
    "name": "Mary Ann Dunwell",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "81",
    "name": "Mary Caferro",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "5",
    "name": "Matt Regier",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "20",
    "name": "Melissa Nikolakakos",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "80",
    "name": "Melissa Romano",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "97",
    "name": "Melody Cunningham",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "1",
    "name": "Mike Cuffe",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "32",
    "name": "Mike Fox",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "40",
    "name": "Mike Vinton",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "24",
    "name": "Mike Yakawich",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "30",
    "name": "Morgan Thiel",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "1",
    "name": "Neil Duram",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "53",
    "name": "Nelly Nicol",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "31",
    "name": "Pat Flowers",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "14",
    "name": "Paul Fielder",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "27",
    "name": "Paul Tuss",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "82",
    "name": "Pete Elverum",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "63",
    "name": "Peter Strand",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "78",
    "name": "Randyn Gregg",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "26",
    "name": "Russ Miner",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "14",
    "name": "Russel Tempel",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "36",
    "name": "Sara Novak",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "71",
    "name": "Scott DeMarois",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "57",
    "name": "Scott Rosenzweig",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "37",
    "name": "Shane Klakken",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "50",
    "name": "Shane Morigeau",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "70",
    "name": "Shannon Maness",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "34",
    "name": "Shelley Vance",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "91",
    "name": "Shelly Fyant",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "49",
    "name": "Sherry Essmann",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "100",
    "name": "S.J. Howell",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "24",
    "name": "Steve Fitzpatrick",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "25",
    "name": "Steve Gist",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "9",
    "name": "Steve Kelly",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "20",
    "name": "Sue Vinton",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "8",
    "name": "Susan Webber",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "10",
    "name": "Terry Falk",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "87",
    "name": "Terry Nelson",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "15",
    "name": "Thedis Crowe",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "44",
    "name": "Theresa Manzella",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "99",
    "name": "Tom France",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "26",
    "name": "Tom McGillvray",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "2",
    "name": "Tom Millett",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "35",
    "name": "Tony Tezak",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "12",
    "name": "Tracy Sharp",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "16",
    "name": "Tyson Running Wolf",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "29",
    "name": "Valerie Moore",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "27",
    "name": "Vince Ricci",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "12",
    "name": "Wendy McKamey",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "49",
    "name": "Willis Curdy",
    "party": "D"
  },
  {
    "state": "mt",
    "chamber": "Senate",
    "district": "39",
    "name": "Wylie Galt",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "17",
    "name": "Zack Wirth",
    "party": "R"
  },
  {
    "state": "mt",
    "chamber": "House",
    "district": "95",
    "name": "Zooey Zephyr",
    "party": "D"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "13",
    "name": "Ashlei Spivey",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "40",
    "name": "Barry DeKay",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "21",
    "name": "Beau Ballard",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "16",
    "name": "Ben Hansen",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "49",
    "name": "Bob Andersen",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "1",
    "name": "Bob Hallstrom",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "48",
    "name": "Brian Hardin",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "25",
    "name": "Carolyn Bosn",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "18",
    "name": "Christy Armendariz",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "33",
    "name": "Dan Lonowski",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "41",
    "name": "Dan McKeon",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "35",
    "name": "Dan Quick",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "46",
    "name": "Danielle Conrad",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "38",
    "name": "Dave Murman",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "7",
    "name": "Dunixi Guereca",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "29",
    "name": "Eliot Bostar",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "26",
    "name": "George Dungan",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "17",
    "name": "Glen Meyer",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "24",
    "name": "Jana Hughes",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "28",
    "name": "Jane Raybould",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "23",
    "name": "Jared Storm",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "27",
    "name": "Jason Prokop",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "14",
    "name": "John Arch",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "9",
    "name": "John Cavanaugh",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "20",
    "name": "John Fredrickson",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "31",
    "name": "Kathleen Kauth",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "34",
    "name": "Loren Lippincott",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "6",
    "name": "Machaela Cavanaugh",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "5",
    "name": "Margo Juarez",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "8",
    "name": "Megan Hunt",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "12",
    "name": "Merv Riepe",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "42",
    "name": "Mike Jacobson",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "22",
    "name": "Mike Moser",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "30",
    "name": "Myron Dorn",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "47",
    "name": "Paul Strommen",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "4",
    "name": "Brad von Gillern",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "36",
    "name": "Rick Holdcroft",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "45",
    "name": "Rita Sanders",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "2",
    "name": "Rob Clements",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "19",
    "name": "Robert Dover",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "37",
    "name": "Stan Clouse",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "43",
    "name": "Tanya Storer",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "44",
    "name": "Teresa Ibach",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "11",
    "name": "Terrell McKinney",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "32",
    "name": "Tom Brandt",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "39",
    "name": "Tony Sorrentino",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "3",
    "name": "Victor Rountree",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "10",
    "name": "Wendy DeBoer",
    "party": "N"
  },
  {
    "state": "ne",
    "chamber": "House",
    "district": "15",
    "name": "Woody Wordekemper",
    "party": "N"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "32",
    "name": "Alexis Hansen",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "15",
    "name": "Angie Taylor",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "33",
    "name": "Bert Gurr",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "13",
    "name": "Brian Hibbetts",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "5",
    "name": "Brittney Miller",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "5",
    "name": "Carrie Buck",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "16",
    "name": "Cecelia González",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "11",
    "name": "Cinthia Moore",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "1",
    "name": "Daniele Monroe-Moreno",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "23",
    "name": "Danielle Gallant",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "20",
    "name": "David Orentlicher",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "4",
    "name": "Dina Neal",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "8",
    "name": "Duy Nguyen",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "2",
    "name": "Edgar Flores",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "21",
    "name": "Elaine Marzola",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "14",
    "name": "Erica Mosca",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "24",
    "name": "Erica Roth",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "10",
    "name": "Fabian Doñate",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "38",
    "name": "Gregory Koenig",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "36",
    "name": "Greg Hafen",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "34",
    "name": "Hanadi Nadeem",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "27",
    "name": "Heather Goulding",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "2",
    "name": "Heidi Kasama",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "15",
    "name": "Howard Watts",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "14",
    "name": "Ira Hansen",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "21",
    "name": "James Ohrenschall",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "20",
    "name": "Jeff Stone",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "31",
    "name": "Jill Dickman",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "29",
    "name": "Joe Dalia",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "19",
    "name": "John Ellison",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "18",
    "name": "John Steinbeck",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "6",
    "name": "Jovan Jackson",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "12",
    "name": "Julie Pazina",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "39",
    "name": "Ken Gray",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "17",
    "name": "Linda Hunt",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "4",
    "name": "Lisa Cole",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "16",
    "name": "Lisa Krasner",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "11",
    "name": "Lori Rogich",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "8",
    "name": "Marilyn Dondero Loop",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "12",
    "name": "Max Carter",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "9",
    "name": "Melanie Scheible",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "22",
    "name": "Melissa Hardy",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "30",
    "name": "Natha Anderson",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "6",
    "name": "Nicole Cannizzaro",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "40",
    "name": "P.K. O'Neill",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "35",
    "name": "Rebecca Edgeworth",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "28",
    "name": "Reuben D'Silva",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "26",
    "name": "Rich DeLong",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "7",
    "name": "Roberta Lange",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "17",
    "name": "Robin Titus",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "3",
    "name": "Rochelle Nguyen",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "41",
    "name": "Sandra Jauregui",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "25",
    "name": "Selena La Rue Hatch",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "3",
    "name": "Selena Torres-Fossett",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "37",
    "name": "Shea Backus",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "1",
    "name": "Shelly Crawford",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "Senate",
    "district": "13",
    "name": "Skip Daly",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "9",
    "name": "Steve Yeager",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "7",
    "name": "Tanya Flanagan",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "19",
    "name": "Toby Yurek",
    "party": "R"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "42",
    "name": "Tracy Brown-May",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "18",
    "name": "Venicia Considine",
    "party": "D"
  },
  {
    "state": "nv",
    "chamber": "House",
    "district": "10",
    "name": "Venise Karris",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 30",
    "name": "Aboul Khan",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 12",
    "name": "Adam Presa",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 7",
    "name": "Aidan Ankarberg",
    "party": "I"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 33",
    "name": "Alexis Simpson",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 15",
    "name": "Alice Wade",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 7",
    "name": "Alicia Gregg",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 20",
    "name": "Alissandra Murray",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 20",
    "name": "Allan Howland",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 12",
    "name": "Allison Knab",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 26",
    "name": "Alvin See",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 9",
    "name": "Amy Malone",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 13",
    "name": "Andrew Prout",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 2",
    "name": "Anita Burroughs",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Coos 2",
    "name": "Arnie Davis",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 7",
    "name": "Barbara Comtois",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 10",
    "name": "Barry Faulkner",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 17",
    "name": "Beth Richards",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 12",
    "name": "Bill Boyd",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "23",
    "name": "Bill Gannon",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 10",
    "name": "Bill Ohm",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 8",
    "name": "Bill Bolton",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 12",
    "name": "Billie Butler",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 17",
    "name": "Bob Lynn",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 26",
    "name": "Brian Cole",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 2",
    "name": "Brian Labrie",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 1",
    "name": "Brian Sullivan",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 4",
    "name": "Brian Nadeau",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 12",
    "name": "Brian Seaworth",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 8",
    "name": "Brian Taylor",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 3",
    "name": "Bryan Morse",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 26",
    "name": "Buzz Scherr",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 1",
    "name": "Calvin Beaulier",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 27",
    "name": "Carol McGuire",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 28",
    "name": "Carrie Sorensen",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 6",
    "name": "Carry Spier",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 4",
    "name": "Cassandra Levesque",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 13",
    "name": "Cathy Kenny",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 2",
    "name": "Catherine Rombeau",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 7",
    "name": "Catherine Sofikitis",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 6",
    "name": "Cathryn Harvey",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 17",
    "name": "Charles McMahon",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "Charlie Foote",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 20",
    "name": "Charlie Melvin",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 5",
    "name": "Charlie St. Clair",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 29",
    "name": "Chris Muns",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 2",
    "name": "Chris McAleer",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 8",
    "name": "Christal Lloyd",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 21",
    "name": "Christine Seibert",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 24",
    "name": "Chris Herbert",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 4",
    "name": "Cindy Bennett",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "13",
    "name": "Cindy Rosenwald",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 2",
    "name": "Claudine Burnham",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 13",
    "name": "Clayton Wood",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 16",
    "name": "Connie Lane",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 13",
    "name": "Cy Aures",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 6",
    "name": "Dale Girard",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 5",
    "name": "Dale Swanson",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 16",
    "name": "Dan Bergeron",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 14",
    "name": "Dan McGuire",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "7",
    "name": "Dan Innis",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 34",
    "name": "Dan LeClerc",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 17",
    "name": "Daniel Popovici-Muller",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 34",
    "name": "Dan Veilleux",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 1",
    "name": "Darrell Louis",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "22",
    "name": "Daryl Abbas",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "David Love",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 16",
    "name": "David Lundgren",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "David Milz",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 16",
    "name": "David Fracht",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "4",
    "name": "David Watters",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 6",
    "name": "Dave Nagel",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 17",
    "name": "David Preece",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 9",
    "name": "David Luneau",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 37",
    "name": "David Meuse",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 1",
    "name": "David Paige",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "1",
    "name": "David Rochefort",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 19",
    "name": "David Walker",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 5",
    "name": "Deborah Aylward",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "24",
    "name": "Debra Altschiller",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 18",
    "name": "Debra DeSimone",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 11",
    "name": "Denis Murphy",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 6",
    "name": "Denise DeDe-Poulin",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "9",
    "name": "Denise Ricciardi",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 24",
    "name": "Dennis Malloy",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 25",
    "name": "Dennis Mannion",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 32",
    "name": "Diane Kelley",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 36",
    "name": "Diane Pauer",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 12",
    "name": "Dick Thackston",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 13",
    "name": "Dillon Dumont",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 24",
    "name": "Don Bouchard",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 18",
    "name": "Donald McFarlane",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 9",
    "name": "Donald Selby",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "10",
    "name": "Donovan Fenton",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 8",
    "name": "Douglas Trottier",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 16",
    "name": "Doug Thomas",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 2",
    "name": "Dru Fox",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 1",
    "name": "Dylan Germana",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 8",
    "name": "Efstathia Booras",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 8",
    "name": "Eileen Kelly",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 9",
    "name": "Eleana Colby",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 10",
    "name": "Ellen Read",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 12",
    "name": "Ellen Rockmore",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 20",
    "name": "Eric Gallager",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 6",
    "name": "Eric Turer",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "Erica Layon",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 29",
    "name": "Erica de Vries",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 11",
    "name": "Erik Johnson",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 40",
    "name": "Erin Kerwin",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 3",
    "name": "Ernesto Gonzalez",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 3",
    "name": "Fred Davis",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 11",
    "name": "Gaby Grossman",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 16",
    "name": "Gary Gilmore",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 43",
    "name": "Gary Daniels",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 30",
    "name": "Gary Woods",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 21",
    "name": "Geoff Smith",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 14",
    "name": "George Sykes",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 5",
    "name": "George Grant",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 42",
    "name": "Gerry Griffin",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 27",
    "name": "Gerry Ward",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 6",
    "name": "Glen Aldrich",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 2",
    "name": "Glenn Bailey",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 7",
    "name": "Glen Cordelli",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 7",
    "name": "Greg Sargent",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 2",
    "name": "Greg Hill",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 6",
    "name": "Harry Bean",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 4",
    "name": "Heath Howard",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 4",
    "name": "Heather Baldwin",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 5",
    "name": "Heather Raymond",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 29",
    "name": "Henry Giasson",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 8",
    "name": "Hope Damon",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "17",
    "name": "Howard Pearl",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 36",
    "name": "J.D. Bernardy",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 24",
    "name": "Jaci Grote",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 45",
    "name": "Jack Flanagan",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 2",
    "name": "Jim Spillane",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 22",
    "name": "James Roesener",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 9",
    "name": "James Newsom",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "6",
    "name": "James Gray",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 18",
    "name": "Jim MacKay",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 18",
    "name": "Jim Qualey",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 20",
    "name": "Jim Summers",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 25",
    "name": "James Thibault",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Coos 1",
    "name": "James Tierney",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 11",
    "name": "Janet Wall",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 7",
    "name": "Janet Lucas",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 2",
    "name": "Jared Sullivan",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 2",
    "name": "Jason Osborne",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 18",
    "name": "Jay Markell",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 23",
    "name": "Jean Jeudy",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 12",
    "name": "Jeanine Notter",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 1",
    "name": "Jeff Tenczar",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 17",
    "name": "Jennifer Rhodes",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 21",
    "name": "Jennifer Mandelbaum",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 13",
    "name": "Jeremy Slottje",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 3",
    "name": "Jerry Stringham",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 31",
    "name": "Jess Edwards",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 17",
    "name": "Jessica LaMontagne",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 18",
    "name": "Jessica Grill",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 30",
    "name": "Jim Fedolfi",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 16",
    "name": "Jim Gruber",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 1",
    "name": "Jim Guzofski",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 32",
    "name": "Jim Kofalt",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 30",
    "name": "Jim Creighton",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 28",
    "name": "Jim Snodgrass",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 23",
    "name": "Jim Maggiore",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 4",
    "name": "Jodi Newell",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "Jodi Nelson",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 29",
    "name": "Joe Alexander",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 3",
    "name": "Joe Hamblen",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 25",
    "name": "Joe Sweeney",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 10",
    "name": "John Leavitt",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 14",
    "name": "John Hunt",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 25",
    "name": "John Janigian",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 19",
    "name": "John Larochelle",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "John Potucek",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 6",
    "name": "John Cloutier",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 2",
    "name": "John Schneller",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 10",
    "name": "John Sellers",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 12",
    "name": "John Stone",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 36",
    "name": "John Suiter",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 25",
    "name": "John Sytek",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 6",
    "name": "John MacDonald",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 39",
    "name": "Jon Morton",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 33",
    "name": "Jonah Wheeler",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 5",
    "name": "Jonathan Smith",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 13",
    "name": "Jordan Ulery",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 4",
    "name": "Jose Cambrils",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 15",
    "name": "Joe Guthrie",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 1",
    "name": "Joseph Barton",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 4",
    "name": "Judy Aron",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 11",
    "name": "Julie Gilman",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 12",
    "name": "Julie Miles",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 3",
    "name": "Juliet Harvey-Bolia",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 35",
    "name": "Julius Soti",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 3",
    "name": "Karel Crawford",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 7",
    "name": "Karen Ebel",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 41",
    "name": "Karen Hegner",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 35",
    "name": "Kat McGhee",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 22",
    "name": "Kate Murray",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 17",
    "name": "Katelyn Kuttab",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "Katherine Prudhomme-O'Brien",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 25",
    "name": "Kathi Paquette",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 25",
    "name": "Kathy Staub",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 6",
    "name": "Katy Peternel",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 28",
    "name": "Keith Erf",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 42",
    "name": "Keith Ammon",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "16",
    "name": "Keith Murphy",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 19",
    "name": "Kelley Potenza",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 14",
    "name": "Ken Weyler",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "12",
    "name": "Kevin Avard",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 8",
    "name": "Kevin Scully",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 2",
    "name": "Kevin Verville",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 38",
    "name": "Kim Rice",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 2",
    "name": "Kristin Noble",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 29",
    "name": "Kris Schultz",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 16",
    "name": "Kristine Perez",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 16",
    "name": "Larry Gagne",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 7",
    "name": "Larry Miner",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 11",
    "name": "Laura Telerski",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 13",
    "name": "Laurel Stavis",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 6",
    "name": "Lee Ann Kluger",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 4",
    "name": "Len Turcotte",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 11",
    "name": "Lex Berezhny",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 15",
    "name": "Lilli Walsh",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 41",
    "name": "Lily Foss",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 17",
    "name": "Linda DiSilvestro",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 10",
    "name": "Linda Harriott-Gathright",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 6",
    "name": "Linda Franz",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 2",
    "name": "Linda Gould",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 11",
    "name": "Linda Haskins",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 40",
    "name": "Linda McGrath",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 4",
    "name": "Linda Ryan",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 4",
    "name": "Lino Avellani",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 42",
    "name": "Lisa Post",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 8",
    "name": "Lisa Freeman",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 44",
    "name": "Lisa Mazur",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 35",
    "name": "Liz Barbour",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 2",
    "name": "Loren Foxx",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 10",
    "name": "Loren Selig",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Coos 7",
    "name": "Lori Korzen",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 25",
    "name": "Lorie Ball",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 7",
    "name": "Lou Juris",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 5",
    "name": "Louise Andrus",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 8",
    "name": "Lucius Parshall",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 5",
    "name": "Lucy Weber",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 21",
    "name": "Luz Bay",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 11",
    "name": "Manoj Chourasia",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 3",
    "name": "Marc Plamondon",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 7",
    "name": "Margaret Drye",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 5",
    "name": "Marie Bjelobrk",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 10",
    "name": "Marjorie Smith",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 5",
    "name": "Mark Vallone",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "3",
    "name": "Mark McConkey",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 15",
    "name": "Mark Proulx",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 15",
    "name": "Mark McLean",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 11",
    "name": "Mark Paige",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 34",
    "name": "Mark Pearson",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 40",
    "name": "Mark MacKenzie",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 39",
    "name": "Mark Warden",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 10",
    "name": "Martin Jack",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 12",
    "name": "Mary Hakken-Phillips",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 3",
    "name": "Mary Ford",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 23",
    "name": "Mary Georges",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 19",
    "name": "Mary Jane Wallner",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 27",
    "name": "Mary Murphy",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 19",
    "name": "Matt Drew",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 30",
    "name": "Matt Sabourin dit Choinière",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 21",
    "name": "Matt Wilhelm",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 2",
    "name": "Matt Coker",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 11",
    "name": "Matthew Pitaro",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 24",
    "name": "Matthew Hicks",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 2",
    "name": "Matty Lunney",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 12",
    "name": "Maureen Mooney",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 37",
    "name": "Megan Murray",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 32",
    "name": "Melissa Litchfield",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 23",
    "name": "Merryl Gibbs",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 29",
    "name": "Michael Edgar",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 8",
    "name": "Michael Aron",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 10",
    "name": "Michael Cahill",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 18",
    "name": "Mike Harrington",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 2",
    "name": "Michael Granger",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 4",
    "name": "Mike Moffett",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 5",
    "name": "Michael Vose",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 5",
    "name": "Mike Bordes",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 4",
    "name": "Mike Drago",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Coos 6",
    "name": "Mike Murphy",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Coos 3",
    "name": "Mike Ouellet",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 4",
    "name": "Mike Belcher",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 31",
    "name": "Molly Howard",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 9",
    "name": "Muriel Hall",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 12",
    "name": "Myles England",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 12",
    "name": "Nancy Murphy",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 39",
    "name": "Ned Raynolds",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 15",
    "name": "Nick Germana",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 29",
    "name": "Nicholas Bridle",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 22",
    "name": "Nicole Leapley",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 3",
    "name": "Paige Beauchemin",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 14",
    "name": "Pam Brown",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 22",
    "name": "Patricia Cornell",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 26",
    "name": "Patrick Long",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "20",
    "name": "Patrick Long",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 7",
    "name": "Paul Terry",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 1",
    "name": "Paul Tudor",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 43",
    "name": "Paul Dargie",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 6",
    "name": "Paul Berch",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 38",
    "name": "Peggy Balboni",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 14",
    "name": "Peter Schmidt",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 8",
    "name": "Peter Lovett",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 12",
    "name": "Peter Mehegan",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Coos 5",
    "name": "Pete Morency",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 43",
    "name": "Peter Petrigno",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 33",
    "name": "Peter Leishman",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 7",
    "name": "Peter Varney",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 13",
    "name": "Peter Bixby",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 3",
    "name": "Philip Jones",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "Phyllis Katsakiores",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 20",
    "name": "Pierre DuPont",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 38",
    "name": "Ralph Boehm",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 4",
    "name": "Ray Newman",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 14",
    "name": "Ray Peeples",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 27",
    "name": "Ray Plante",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "21",
    "name": "Rebecca Perkins Kwoka",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "19",
    "name": "Regina Birdsell",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 30",
    "name": "Riché Colcombe",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 9",
    "name": "Rich Nalevanko",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 13",
    "name": "Dick Ames",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "Richard Tripp",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 8",
    "name": "Richard Brown",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 14",
    "name": "Rich Lascelles",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 5",
    "name": "Rick Ladd",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 1",
    "name": "Ricky Devoid",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 18",
    "name": "Rita Mattson",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 20",
    "name": "Bob Harb",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 13",
    "name": "Robert Wherry",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 1",
    "name": "Robley Hall",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 16",
    "name": "Ron Dunn",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 12",
    "name": "Rosemarie Rung",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 44",
    "name": "Ross Berry",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 6",
    "name": "Russ Dumais",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 12",
    "name": "Russ Muirhead",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "8",
    "name": "Ruth Ward",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 8",
    "name": "Sallie Fellows",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 8",
    "name": "Sam Farrington",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 15",
    "name": "Samantha Jacobs",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 1",
    "name": "Sandra Panek",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 9",
    "name": "Sanjeev Manohar",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 9",
    "name": "Santosh Salvi",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 8",
    "name": "Sayra DeVito",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 1",
    "name": "Scott Bryer",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Coos 1",
    "name": "Sean Durkin",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Coos 4",
    "name": "Seth King",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 21",
    "name": "Seth Miller",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 32",
    "name": "Shane Sirois",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "14",
    "name": "Sharon Carson",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 29",
    "name": "Sheila Seidel",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 5",
    "name": "Sheri Minor",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 16",
    "name": "Sherm Packard",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 29",
    "name": "Sherri Reinfurt",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 3",
    "name": "Skip Rollins",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 10",
    "name": "Sly Karasinski",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 34",
    "name": "Stephanie Grund",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 8",
    "name": "Stephanie Payeur",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 13",
    "name": "Steve Pearson",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 10",
    "name": "Stephen Boyd",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 1",
    "name": "Steve Woodcock",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 18",
    "name": "Steve Kesselring",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 3",
    "name": "Steven Smith",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 5",
    "name": "Steve Bogert",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 1",
    "name": "Sue DeLemus",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 4",
    "name": "Sue Newman",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 40",
    "name": "Suraj Budathoki",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 5",
    "name": "Susan Elberger",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 3",
    "name": "Susan DeRoy",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 25",
    "name": "Sue Vandecasteele",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 19",
    "name": "Susan Porcelli",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 17",
    "name": "Susan Almy",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 19",
    "name": "Suzanne Chretien",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "5",
    "name": "Sue Prentiss",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 6",
    "name": "Sue Vail",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 25",
    "name": "Tanya Donnelly",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "15",
    "name": "Tara Reardon",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 2",
    "name": "Ted Gorski",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Cheshire 7",
    "name": "Terri O'Rorke",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 31",
    "name": "Terry Roy",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 12",
    "name": "Terry Spahr",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 6",
    "name": "Tom Schamberg",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 10",
    "name": "Thomas Walsh",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 15",
    "name": "Tom Cormen",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Carroll 1",
    "name": "Tom Buco",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 5",
    "name": "Thomas Kaczynski",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 11",
    "name": "Tom Southworth",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Grafton 9",
    "name": "Thomas Oppel",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 41",
    "name": "Tim Hartnett",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 1",
    "name": "Tim Mannion",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "11",
    "name": "Tim McGough",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 21",
    "name": "Timothy Soucy",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "2",
    "name": "Tim Lang",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 10",
    "name": "Timothy Horrigan",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 1",
    "name": "Tom Mannion",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 16",
    "name": "Tom Dolan",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 1",
    "name": "Tom Ploszaj",
    "party": "I"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 10",
    "name": "Toni Weinstein",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 8",
    "name": "Tony Caplan",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 15",
    "name": "Tracy Bricchi",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 28",
    "name": "Travis Corcoran",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Belknap 4",
    "name": "Travis Toner",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 40",
    "name": "Trinidad Tellez",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 25",
    "name": "Valerie McDonnell",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 43",
    "name": "Vanessa Sheehan",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 9",
    "name": "Vicki Wilson",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "Senate",
    "district": "18",
    "name": "Victoria Sullivan",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 3",
    "name": "Terry Spilsbury",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 16",
    "name": "Wayne MacDonald",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 6",
    "name": "Wayne Hemingway",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 10",
    "name": "Wayne Burton",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Strafford 12",
    "name": "Wayne Pearson",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 12",
    "name": "Wendy Thomas",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 11",
    "name": "Will Darby",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Hillsborough 9",
    "name": "Bill Dolan",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Sullivan 2",
    "name": "Bill Palmer",
    "party": "D"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Merrimack 10",
    "name": "Yury Polozov",
    "party": "R"
  },
  {
    "state": "nh",
    "chamber": "House",
    "district": "Rockingham 12",
    "name": "Zoe Manos",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "35",
    "name": "Al Abdelaziz",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "40",
    "name": "Al Barlas",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "12",
    "name": "Alex Sauickie",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "27",
    "name": "Alixon Collazos-Gill",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "8",
    "name": "Andrea Katz",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "16",
    "name": "Andrew Zwicker",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "31",
    "name": "Angela McKnight",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "20",
    "name": "Annette Quijano",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "25",
    "name": "Tony Bucco",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "15",
    "name": "Anthony Verrelli",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "1",
    "name": "Antwan McClellan",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "25",
    "name": "Aura Dunn",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "30",
    "name": "Avi Schnall",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "7",
    "name": "Balvir Singh",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "31",
    "name": "Barbara McCann Stamato",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "35",
    "name": "Benjie Wimberly",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "17",
    "name": "Bob Smith",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "26",
    "name": "Brian Bergen",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "9",
    "name": "Brian Rumpf",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "33",
    "name": "Brian Stack",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "34",
    "name": "Britnee Timberlake",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "9",
    "name": "Carmen Amato",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "34",
    "name": "Carmen Morales",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "7",
    "name": "Carol Murphy",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "25",
    "name": "Chris Barranco",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "40",
    "name": "Chris DePhillips",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "2",
    "name": "Claire Swift",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "28",
    "name": "Cleopatra Tucker",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "36",
    "name": "Clinton Calabrese",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "4",
    "name": "Cody Miller",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "19",
    "name": "Craig Coughlin",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "4",
    "name": "Dan Hutchison",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "3",
    "name": "Dave Bailey",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "24",
    "name": "Dawn Fantasia",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "13",
    "name": "Declan O'Scanlon",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "2",
    "name": "Don Guardian",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "23",
    "name": "Doug Steinhardt",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "29",
    "name": "Eliana Pintor Marin",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "37",
    "name": "Ellen Park",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "23",
    "name": "Erik Peterson",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "1",
    "name": "Erik Simonsen",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "33",
    "name": "Gabe Rodriguez",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "28",
    "name": "Garnet Hall",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "36",
    "name": "Gary Schaer",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "13",
    "name": "Gerry Scharfenberger",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "37",
    "name": "Gordon Johnson",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "9",
    "name": "Greg Myhre",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "10",
    "name": "Greg McGuckin",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "3",
    "name": "Heather Simmons",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "39",
    "name": "Holly Schepisi",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "6",
    "name": "Jim Beach",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "22",
    "name": "Jim Kennedy",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "10",
    "name": "Jim Holzapfel",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "26",
    "name": "Jay Webber",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "32",
    "name": "Jessica Ramirez",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "17",
    "name": "Joe Danielsen",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "32",
    "name": "John Allen",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "39",
    "name": "John Azzariti",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "23",
    "name": "John DiMaio",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "27",
    "name": "John McKeon",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "3",
    "name": "John Burzichelli",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "21",
    "name": "Jon Bramnick",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "38",
    "name": "Joe Lagana",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "19",
    "name": "Joe Vitale",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "20",
    "name": "Joe Cryan",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "26",
    "name": "Joe Pennacchio",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "33",
    "name": "Julio Marenco",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "17",
    "name": "Kevin Egan",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "40",
    "name": "Kristin Corrado",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "8",
    "name": "Latham Tiver",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "14",
    "name": "Linda Greenstein",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "22",
    "name": "Linda Carter",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "38",
    "name": "Lisa Swain",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "6",
    "name": "Lou Greenwald",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "11",
    "name": "Luanne Peterpaul",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "29",
    "name": "Teresa Ruiz",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "11",
    "name": "Margie Donlon",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "6",
    "name": "Melinda Kane",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "1",
    "name": "Mike Testa",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "8",
    "name": "Mike Torrissi",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "21",
    "name": "Michele Matsikoudis",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "24",
    "name": "Mike Inganamort",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "34",
    "name": "Mike Venezia",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "16",
    "name": "Mitchelle Drulis",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "21",
    "name": "Nancy Muñoz",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "22",
    "name": "Nick Scutari",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "5",
    "name": "Nilsa Cruz-Perez",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "12",
    "name": "Owen Henry",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "38",
    "name": "Chris Tully",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "24",
    "name": "Parker Space",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "18",
    "name": "Patrick Diegnan",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "36",
    "name": "Paul Sarlo",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "4",
    "name": "Paul Moriarty",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "10",
    "name": "Paul Kanitra",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "32",
    "name": "Raj Mukherji",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "20",
    "name": "Reginald Atkins",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "28",
    "name": "Renee Burgess",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "39",
    "name": "Bob Auth",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "12",
    "name": "Rob Clifton",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "18",
    "name": "Robert Karabinchak",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "30",
    "name": "Bob Singer",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "27",
    "name": "Rosy Bagolie",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "16",
    "name": "Roy Freiman",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "30",
    "name": "Sean Kean",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "37",
    "name": "Shama Haider",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "29",
    "name": "Shanique Speight",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "35",
    "name": "Shavonda Sumter",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "15",
    "name": "Shirley Turner",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "18",
    "name": "Sterley Stanley",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "14",
    "name": "Tennille McCoy",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "7",
    "name": "Troy Singleton",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "15",
    "name": "Verlina Reynolds-Jackson",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "13",
    "name": "Vicky Flynn",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "11",
    "name": "Vin Gopal",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "Senate",
    "district": "2",
    "name": "Vince Polistina",
    "party": "R"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "14",
    "name": "Wayne DeAngelo",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "31",
    "name": "Will Sampson",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "5",
    "name": "Bill Moen",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "5",
    "name": "Bill Spearman",
    "party": "D"
  },
  {
    "state": "nj",
    "chamber": "House",
    "district": "19",
    "name": "Yvonne Lopez",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "23",
    "name": "Alan Martinez",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "64",
    "name": "Andi Reeb",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "46",
    "name": "Andrea Romero",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "30",
    "name": "Angel Charley",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "35",
    "name": "Angelica Rubio",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "58",
    "name": "Angelita Mejia",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "70",
    "name": "Anita Gonzales",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "19",
    "name": "Ant Thornton",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "16",
    "name": "Antoinette Sedillo Lopez",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "26",
    "name": "Moe Maestas",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "12",
    "name": "Art De La Cruz",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "22",
    "name": "Benny Shendo",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "3",
    "name": "Bill Hall",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "8",
    "name": "Brian Baca",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "32",
    "name": "Candy Ezzell",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "38",
    "name": "Carrie Hamblen",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "57",
    "name": "Catherine Cullen",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "55",
    "name": "Cathrynn Brown",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "68",
    "name": "Charlotte Little",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "43",
    "name": "Chris Chandler",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "9",
    "name": "Cindy Nava",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "40",
    "name": "Craig Brandt",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "25",
    "name": "Cristina Parajón",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "35",
    "name": "Crystal Brantley",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "17",
    "name": "Cynthia Borrego",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "5",
    "name": "Wonda Johnson",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "41",
    "name": "David Gallegos",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "15",
    "name": "Day Hochman-Vigil",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "13",
    "name": "Debbie O'Malley",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "21",
    "name": "Debbie Sariñana",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "65",
    "name": "Derrick Lente",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "30",
    "name": "Diane Torres-Velásquez",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "52",
    "name": "Doreen Gallegos",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "62",
    "name": "Elaine Sena Cortez",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "26",
    "name": "Eleanor Chávez",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "39",
    "name": "Liz Stefanics",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "24",
    "name": "Liz Thomson",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "10",
    "name": "Andrés Romero",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "28",
    "name": "Gabriel Ramos",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "49",
    "name": "Gail Armstrong",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "4",
    "name": "George Muñoz",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "56",
    "name": "Harlan Vincent",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "23",
    "name": "Harold Pope",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "15",
    "name": "Heather Berghmans",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "67",
    "name": "Jack Chatfield",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "34",
    "name": "Jim Townsend",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "19",
    "name": "Janelle Anyanonu",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "11",
    "name": "Javier Martínez",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "12",
    "name": "Jay Block",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "36",
    "name": "Jeff Steinborn",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "32",
    "name": "Jenifer Jones",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "66",
    "name": "Jimmy Mason",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "37",
    "name": "Joanne Ferrary",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "51",
    "name": "John Block",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "54",
    "name": "Jon Henry",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "31",
    "name": "Joe Cervantes",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "4",
    "name": "Joseph Hernandez",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "40",
    "name": "Joseph Sanchez",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "29",
    "name": "Joshua Sanchez",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "60",
    "name": "Josh Hernandez",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "29",
    "name": "Joy Garratt",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "44",
    "name": "Kathleen Cates",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "10",
    "name": "Katy Duhigg",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "42",
    "name": "Kristina Ortez",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "42",
    "name": "Larry Scott",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "5",
    "name": "Leo Jaramillo",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "11",
    "name": "Linda López",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "24",
    "name": "Linda Trujillo",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "45",
    "name": "Linda Serrato",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "39",
    "name": "Luis Terrazas",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "27",
    "name": "Marian Matthews",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "18",
    "name": "Marianna Anaya",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "2",
    "name": "Mark Duncan",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "59",
    "name": "Mark Murphy",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "6",
    "name": "Martha Garcia",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "20",
    "name": "Martin Hickey",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "63",
    "name": "Martin Zamora",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "50",
    "name": "Matthew McQueen",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "20",
    "name": "Meredith Dixon",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "33",
    "name": "Micaela Cadena",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "14",
    "name": "Michael Padilla",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "14",
    "name": "Miguel García",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "17",
    "name": "Mimi Stewart",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "18",
    "name": "Natalie Figueroa",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "36",
    "name": "Nathan Small",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "33",
    "name": "Nick Paul",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "31",
    "name": "Nicole Chavez",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "21",
    "name": "Nicole Tobiassen",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "28",
    "name": "Pamelya Herndon",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "27",
    "name": "Pat Boone",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "7",
    "name": "Pat Woods",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "9",
    "name": "Patty Lundstrom",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "13",
    "name": "Pat Roybal Caballero",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "69",
    "name": "Paulene Abeyta",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "8",
    "name": "Pete Campos",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "25",
    "name": "Peter Wirth",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "61",
    "name": "Randy Pettigrew",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "34",
    "name": "Ray Lara",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "38",
    "name": "Rebecca Dow",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "47",
    "name": "Reena Szczepanski",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "6",
    "name": "Bobby Gonzales",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "1",
    "name": "Rod Montoya",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "53",
    "name": "Sarah Silva",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "3",
    "name": "Shannon Pinto",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "22",
    "name": "Stefani Lord",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "2",
    "name": "Steve Lanier",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "41",
    "name": "Susan Herrera",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "7",
    "name": "Tanya Moya",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "48",
    "name": "Tara Luján",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "1",
    "name": "Bill Sharer",
    "party": "R"
  },
  {
    "state": "nm",
    "chamber": "Senate",
    "district": "37",
    "name": "Bill Soules",
    "party": "D"
  },
  {
    "state": "nm",
    "chamber": "House",
    "district": "16",
    "name": "Yanira Gurrola",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "127",
    "name": "Al Stirpe",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "71",
    "name": "Al Taylor",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "46",
    "name": "Alec Brook-Krasny",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "73",
    "name": "Alex Bores",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "8",
    "name": "Alexis Weik",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "29",
    "name": "Alicia Hyndman",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "84",
    "name": "Amanda Septimo",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "88",
    "name": "Amy Paulin",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "133",
    "name": "Andrea Bailey",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "35",
    "name": "Andrea Stewart-Cousins",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "26",
    "name": "Andrew Gounardes",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "28",
    "name": "Andrew Hevesi",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "24",
    "name": "Andrew Lanza",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "150",
    "name": "Andrew Molitor",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "145",
    "name": "Angelo Morinello",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "111",
    "name": "Angelo Santabarbara",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "105",
    "name": "Anil Beephan",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "125",
    "name": "Anna Kelles",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "1",
    "name": "Tony Palumbo",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "63",
    "name": "April Baskin",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "20",
    "name": "Ari Brown",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "97",
    "name": "Aron Wieder",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "38",
    "name": "Bill Weber",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "115",
    "name": "Billy Jones",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "47",
    "name": "Brad Hoylman-Sigal",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "43",
    "name": "Brian Cunningham",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "27",
    "name": "Brian Kavanagh",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "101",
    "name": "Brian Maher",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "130",
    "name": "Brian Manktelow",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "122",
    "name": "Brian Miller",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "83",
    "name": "Carl Heastie",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "113",
    "name": "Carrie Woerner",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "39",
    "name": "Catalina Cruz",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "79",
    "name": "Chantel Jackson",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "61",
    "name": "Charles Fall",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "13",
    "name": "Charles Lavine",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "93",
    "name": "Chris Burdick",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "99",
    "name": "Chris Eachus",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "50",
    "name": "Chris Ryan",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "102",
    "name": "Chris Tague",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "124",
    "name": "Chris Friend",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "37",
    "name": "Claire Valdez",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "33",
    "name": "Clyde Vanel",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "30",
    "name": "Cordell Cleare",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "141",
    "name": "Crystal Peoples-Stokes",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "95",
    "name": "Dana Levenberg",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "45",
    "name": "Dan Stec",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "16",
    "name": "Danny Norber",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "147",
    "name": "Dave DiPietro",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "14",
    "name": "Dave McDonough",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "24",
    "name": "David Weprin",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "3",
    "name": "Dean Murray",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "66",
    "name": "Deborah Glick",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "137",
    "name": "Demond Meeks",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "106",
    "name": "Didi Barrett",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "123",
    "name": "Donna Lupardo",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "5",
    "name": "Doug Smith",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "68",
    "name": "Eddie Gibbs",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "26",
    "name": "Ed Braunstein",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "19",
    "name": "Ed Ra",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "50",
    "name": "Emily Gallagher",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "85",
    "name": "Emérita Torres",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "54",
    "name": "Erik Dilan",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "109",
    "name": "Gabriella Romero",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "78",
    "name": "George Alvarez",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "57",
    "name": "George Borrello",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "65",
    "name": "Grace Lee",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "33",
    "name": "Gustavo Rivera",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "138",
    "name": "Harry Bronson",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "74",
    "name": "Harvey Epstein",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "89",
    "name": "Gary Pretlow",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "25",
    "name": "Jabari Brisport",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "7",
    "name": "Jack Martins",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "59",
    "name": "Jaime Williams",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "43",
    "name": "Jake Ashby",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "15",
    "name": "Jake Blumencranz",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "36",
    "name": "Jamaal Bailey",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "10",
    "name": "James Sanders",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "42",
    "name": "James Skoufis",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "44",
    "name": "Jim Tedisco",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "7",
    "name": "Jarett Gandolfo",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "131",
    "name": "Jeff Gallahan",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "81",
    "name": "Jeffrey Dinowitz",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "38",
    "name": "Jenifer Rajkumar",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "135",
    "name": "Jen Lunsford",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "56",
    "name": "Jeremy Cooney",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "34",
    "name": "Jessica González-Rojas",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "13",
    "name": "Jessica Ramos",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "23",
    "name": "Jessica Scarcella-Spanton",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "52",
    "name": "Jo Anne Simon",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "2",
    "name": "Jodi Giglio",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "121",
    "name": "Joe Angelino",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "3",
    "name": "Joe DeStefano",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "148",
    "name": "Joe Sempolinski",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "108",
    "name": "John McDonald",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "126",
    "name": "John Lemondes",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "16",
    "name": "John Liu",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "17",
    "name": "John Mikulin",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "80",
    "name": "John Zaccaro",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "104",
    "name": "Jonathan Jacobson",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "149",
    "name": "Jon Rivera",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "70",
    "name": "Jordan Wright",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "29",
    "name": "Jose Serrano",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "53",
    "name": "Joe Griffo",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "15",
    "name": "Joe Addabbo",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "134",
    "name": "Josh Jensen",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "21",
    "name": "Judy Griffin",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "18",
    "name": "Julia Salazar",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "41",
    "name": "Kalman Yeger",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "146",
    "name": "Karen McMahon",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "87",
    "name": "Karines Reyes",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "98",
    "name": "Karl Brabenec",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "12",
    "name": "Keith Brown",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "117",
    "name": "Ken Blankenbush",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "21",
    "name": "Kevin Parker",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "31",
    "name": "Khaleel Anderson",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "59",
    "name": "Kristen Gonzalez",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "11",
    "name": "Kwani O'Pharrow",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "77",
    "name": "Landon Dais",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "35",
    "name": "Larinda Hooks",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "55",
    "name": "Latrice Walker",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "52",
    "name": "Lea Webb",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "14",
    "name": "Leroy Comrie",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "49",
    "name": "Lester Chang",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "67",
    "name": "Linda Rosenthal",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "28",
    "name": "Liz Krueger",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "32",
    "name": "Luis Sepúlveda",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "72",
    "name": "Manny De Los Santos",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "51",
    "name": "Marcela Mitaynes",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "119",
    "name": "Marianne Buttenschon",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "2",
    "name": "Mario Mattera",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "53",
    "name": "Maritza Davila",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "49",
    "name": "Mark Walczyk",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "112",
    "name": "Mary Beth Walsh",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "92",
    "name": "MaryJane Shimsky",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "94",
    "name": "Matt Slater",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "114",
    "name": "Matt Simpson",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "69",
    "name": "Micah Lasher",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "82",
    "name": "Michael Benedetto",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "9",
    "name": "Michael Durso",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "8",
    "name": "Mike Fitzpatrick",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "12",
    "name": "Michael Gianaris",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "45",
    "name": "Misha Novakhov",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "62",
    "name": "Mike Reilly",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "64",
    "name": "Mike Tannousis",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "22",
    "name": "Michaelle Solages",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "41",
    "name": "Michelle Hinchey",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "4",
    "name": "Monica Martinez",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "58",
    "name": "Monique Chandler-Waterman",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "90",
    "name": "Nader Sayegh",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "34",
    "name": "Nathalia Fernández",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "60",
    "name": "Nikki Lucas",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "25",
    "name": "Nily Rozic",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "18",
    "name": "Noah Burroughs",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "54",
    "name": "Pam Helming",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "128",
    "name": "Pamela Hunter",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "143",
    "name": "Pat Chludzinski",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "9",
    "name": "Patricia Canzoneri-Fitzpatrick",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "46",
    "name": "Pat Fahy",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "142",
    "name": "Pat Burke",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "96",
    "name": "Pat Carroll",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "60",
    "name": "Patrick Gallivan",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "144",
    "name": "Paul Bologna",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "100",
    "name": "Paula Kay",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "40",
    "name": "Pete Harckham",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "51",
    "name": "Peter Oberacker",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "57",
    "name": "Phara Souffrant Forrest",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "6",
    "name": "Phil Ramos",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "110",
    "name": "Phil Steck",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "132",
    "name": "Phil Palmesano",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "48",
    "name": "Rachel May",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "4",
    "name": "Rebecca Kassay",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "76",
    "name": "Rebecca Seawright",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "44",
    "name": "Robert Carroll",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "62",
    "name": "Rob Ortt",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "31",
    "name": "Robert Jackson",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "39",
    "name": "Rob Rolison",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "118",
    "name": "Robert Smullen",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "42",
    "name": "Rodneyse Bichotte Hermelyn",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "40",
    "name": "Ron Kim",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "19",
    "name": "Roxanne Persaud",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "27",
    "name": "Sam Berger",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "63",
    "name": "Sam Pirozzolo",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "22",
    "name": "Sam Sutton",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "55",
    "name": "Samra Brouk",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "136",
    "name": "Sarah Clark",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "103",
    "name": "Sarahana Shrestha",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "107",
    "name": "Scott Bendett",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "116",
    "name": "Scott Gray",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "61",
    "name": "Sean Ryan",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "37",
    "name": "Shelley Mayer",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "6",
    "name": "Siela Bynoe",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "48",
    "name": "Simcha Eichenstein",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "23",
    "name": "Stacey Pheffer Amato",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "56",
    "name": "Stefani Zinerman",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "139",
    "name": "Steve Hawley",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "17",
    "name": "Steve Chan",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "10",
    "name": "Steve Stern",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "5",
    "name": "Steve Rhoads",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "91",
    "name": "Steve Otis",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "30",
    "name": "Steven Raga",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "58",
    "name": "Tom O'Mara",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "11",
    "name": "Toby Stavisky",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "1",
    "name": "Tommy John Schiavoni",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "75",
    "name": "Tony Simone",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "32",
    "name": "Vivian Cook",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "120",
    "name": "Will Barclay",
    "party": "R"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "47",
    "name": "William Colton",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "140",
    "name": "Bill Conrad",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "129",
    "name": "Bill Magnarelli",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "86",
    "name": "Yudelka Tapia",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "Senate",
    "district": "20",
    "name": "Zellnor Myrie",
    "party": "D"
  },
  {
    "state": "ny",
    "chamber": "House",
    "district": "36",
    "name": "Zohran Mamdani",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "65",
    "name": "Reece Pyrtle",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "38",
    "name": "Abe Jones",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "107",
    "name": "Aisha Dew",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "59",
    "name": "Alan Branson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "56",
    "name": "Allen Buansi",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "25",
    "name": "Allen Chesser",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "11",
    "name": "Allison Dahle",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "72",
    "name": "Amber Baker",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "58",
    "name": "Amos Quick",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "25",
    "name": "Amy Galey",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "2",
    "name": "Ray Jeffers",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "102",
    "name": "Becky Carney",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "52",
    "name": "Ben Moss",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "10",
    "name": "Benton Sawrey",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "98",
    "name": "Beth Gardner Helfrich",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "8",
    "name": "Bill Rabon",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "5",
    "name": "Bill Ward",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "94",
    "name": "Blair Eddins",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "3",
    "name": "Bob Brinson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "1",
    "name": "Bobby Hanig",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "43",
    "name": "Brad Overcash",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "104",
    "name": "Brandon Lofton",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "46",
    "name": "Brenden Jones",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "9",
    "name": "Brent Jackson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "70",
    "name": "Brian Biggs",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "82",
    "name": "Brian Echevarria",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "116",
    "name": "Brian Turner",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "32",
    "name": "Bryan Cohn",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "41",
    "name": "Caleb Theodros",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "33",
    "name": "Carl Ford",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "106",
    "name": "Carla Cunningham",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "101",
    "name": "Carolyn Logan",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "16",
    "name": "Carson Smith",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "60",
    "name": "Cecil Brockman",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "13",
    "name": "Celeste Cairns",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "44",
    "name": "Charles Smith",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "19",
    "name": "Charlie Miller",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "12",
    "name": "Chris Humphrey",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "34",
    "name": "Chris Measmer",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "67",
    "name": "Cody Huneycutt",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "49",
    "name": "Cynthia Ball",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "14",
    "name": "Dan Blue",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "31",
    "name": "Dana Jones",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "24",
    "name": "Danny Britt",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "24",
    "name": "Dante Pittman",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "29",
    "name": "Dave Craven",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "68",
    "name": "David Willis",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "39",
    "name": "DeAndrea Salvador",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "69",
    "name": "Dean Arp",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "18",
    "name": "Deb Butler",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "64",
    "name": "Dennis Riddell",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "87",
    "name": "Destin Hall",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "43",
    "name": "Diane Wheatley",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "26",
    "name": "Donna White",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "109",
    "name": "Donnie Loftis",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "75",
    "name": "Donny Lambeth",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "85",
    "name": "Dudley Greene",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "4",
    "name": "Buck Newton",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "36",
    "name": "Eddie Settle",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "1",
    "name": "Ed Goodwin",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "114",
    "name": "Eric Ager",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "37",
    "name": "Erin Paré",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "45",
    "name": "Frances Jackson",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "17",
    "name": "Frank Iler",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "16",
    "name": "Gale Adcock",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "48",
    "name": "Garland Pierce",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "28",
    "name": "Gladys Robinson",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "8",
    "name": "Gloristine Brown",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "23",
    "name": "Graig Meyer",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "83",
    "name": "Grant Campbell",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "76",
    "name": "Harry Warren",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "97",
    "name": "Heather Rhyne",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "53",
    "name": "Howard Penny",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "86",
    "name": "Hugh Blackwell",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "113",
    "name": "Jake Johnson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "39",
    "name": "James Roberson",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "47",
    "name": "Jarrod Lowery",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "96",
    "name": "Jay Adams",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "15",
    "name": "Jay Chaudhuri",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "74",
    "name": "Jeff Zenger",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "84",
    "name": "Jeff McNeely",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "117",
    "name": "Jennifer Balkcom",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "12",
    "name": "Jim Burgin",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "4",
    "name": "Jimmy Dixon",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "108",
    "name": "John Torbett",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "62",
    "name": "John Blust",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "10",
    "name": "John Bell",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "51",
    "name": "John Sauls",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "73",
    "name": "Jonathan Almond",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "112",
    "name": "Jordan Lopez",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "6",
    "name": "Joe Pike",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "40",
    "name": "Joyce Waddell",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "77",
    "name": "Julia Howard",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "100",
    "name": "Julia Greenfield",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "49",
    "name": "Julie Mayfield",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "36",
    "name": "Julie von Haefen",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "5",
    "name": "Kandie Smith",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "71",
    "name": "Kanika Brown",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "120",
    "name": "Karl Gillespie",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "79",
    "name": "Keith Kidwell",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "110",
    "name": "Kelly Hastings",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "50",
    "name": "Kevin Corbin",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "91",
    "name": "Kyle Hall",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "28",
    "name": "Larry Strickland",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "81",
    "name": "Larry Potts",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "103",
    "name": "Laura Budd",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "115",
    "name": "Lindsey Prather",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "13",
    "name": "Lisa Grafstein",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "11",
    "name": "Lisa Barnes",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "30",
    "name": "Marcia Morey",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "41",
    "name": "Maria Cervania",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "55",
    "name": "Mark Brody",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "118",
    "name": "Mark Pless",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "45",
    "name": "Mark Hollo",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "88",
    "name": "Mary Belk",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "7",
    "name": "Matthew Winslow",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "6",
    "name": "Michael Lazzara",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "27",
    "name": "Michael Garrett",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "7",
    "name": "Michael Lee",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "119",
    "name": "Mike Clampitt",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "42",
    "name": "Mike Colvin",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "35",
    "name": "Mike Schietzelt",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "89",
    "name": "Mitchell Setzer",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "33",
    "name": "Monika Johnson-Hostler",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "38",
    "name": "Mujtaba Mohammed",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "99",
    "name": "Nasif Majeed",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "20",
    "name": "Natalie Murdock",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "78",
    "name": "Neal Jackson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "2",
    "name": "Norman Sanderson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "32",
    "name": "Paul Lowe",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "111",
    "name": "Paul Scott",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "26",
    "name": "Phil Berger",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "40",
    "name": "Phil Rubin",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "15",
    "name": "Phil Shepard",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "61",
    "name": "Pricey Harrison",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "47",
    "name": "Ralph Hise",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "93",
    "name": "Ray Pickett",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "50",
    "name": "Renée Price",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "54",
    "name": "Robert Reives",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "27",
    "name": "Rodney Pierce",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "80",
    "name": "Sam Watford",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "66",
    "name": "Sarah Crawford",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "90",
    "name": "Sarah Stevens",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "23",
    "name": "Shelly Willingham",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "22",
    "name": "Sophia Chitlik",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "63",
    "name": "Stephen Ross",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "30",
    "name": "Steve Jarvis",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "3",
    "name": "Steve Tyson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "17",
    "name": "Sydney Batch",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "20",
    "name": "Ted Davis",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "18",
    "name": "Terence Everitt",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "92",
    "name": "Terry Brown",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "48",
    "name": "Tim Moffitt",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "34",
    "name": "Tim Longest",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "9",
    "name": "Tim Reeder",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "95",
    "name": "Todd Carver",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "35",
    "name": "Todd Johnson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "21",
    "name": "Tom McInnis",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "57",
    "name": "Tracy Clark",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "105",
    "name": "Tricia Cotham",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "19",
    "name": "Val Applewhite",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "29",
    "name": "Vernetta Alston",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "37",
    "name": "Vickie Sawyer",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "44",
    "name": "Ted Alexander",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "46",
    "name": "Warren Daniel",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "22",
    "name": "William Brisson",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "Senate",
    "district": "42",
    "name": "Woodson Bradley",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "14",
    "name": "Wyatt Gable",
    "party": "R"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "21",
    "name": "Ya Liu",
    "party": "D"
  },
  {
    "state": "nc",
    "chamber": "House",
    "district": "31",
    "name": "Zack Hawkins",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "25",
    "name": "Alisa Mitskog",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "16",
    "name": "Andrew Marschall",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "33",
    "name": "Anna Novak",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "13",
    "name": "Austen Schauer",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "44",
    "name": "Austin Foss",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "16",
    "name": "Ben Koppelman",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "12",
    "name": "Bernie Satrom",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "2",
    "name": "Bert Anderson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "33",
    "name": "Bill Tveit",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "35",
    "name": "Bob Martinson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "3",
    "name": "Bob Paulson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "1",
    "name": "Brad Bekkedahl",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "22",
    "name": "Brandy Pyle",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "45",
    "name": "Carrie McLeod",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "38",
    "name": "Christina Wolff",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "4",
    "name": "Chuck Walen",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "42",
    "name": "Claire Cory",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "4B",
    "name": "Clayton Fegley",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "12",
    "name": "Cole Conley",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "9",
    "name": "Collette Brown",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "29",
    "name": "Craig Headland",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "26",
    "name": "Dale Patten",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "24",
    "name": "Dan Johnston",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "38",
    "name": "Dan Ruby",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "6",
    "name": "Dan Vollmer",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "16",
    "name": "David Clemens",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "38",
    "name": "David Hogue",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "19",
    "name": "Dave Monson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "1",
    "name": "David Richter",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "31",
    "name": "Dawson Holle",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "37",
    "name": "Dean Rummel",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "23",
    "name": "Dennis Nehring",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "46",
    "name": "Desiree Morton",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "36",
    "name": "Desiree Van Oosting",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "30",
    "name": "Diane Larson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "6",
    "name": "Dick Anderson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "32",
    "name": "Dick Dever",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "29",
    "name": "Don Vigesaa",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "31",
    "name": "Don Schaible",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "2",
    "name": "Donald Longmuir",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "15",
    "name": "Donna Henderson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "36",
    "name": "Dori Hauck",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "42",
    "name": "Doug Osowski",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "24",
    "name": "Dwight Kiefert",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "42",
    "name": "Emily O'Brien",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "43",
    "name": "Eric Murphy",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "30",
    "name": "Glenn Bosch",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "39",
    "name": "Greg Kessel",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "27",
    "name": "Greg Stemen",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "11",
    "name": "Gretchen Dobervich",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "19",
    "name": "Janne Myrdal",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "20",
    "name": "Jared Hagert",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "10",
    "name": "Jared Hendrix",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "7",
    "name": "Jason Dockter",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "5",
    "name": "Jay Fisher",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "9",
    "name": "Jayme Davis",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "3",
    "name": "Jeff Hoverson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "43",
    "name": "Jeff Barta",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "8",
    "name": "Jeff Magrum",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "14",
    "name": "Jerry Klein",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "28",
    "name": "Jim Grueneich",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "13",
    "name": "Jim Jonas",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "46",
    "name": "Jim Kasper",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "14",
    "name": "Jon Nelson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "17",
    "name": "Jonathan Sickler",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "22",
    "name": "Jonathan Warrey",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "41",
    "name": "Jorin Johnson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "40",
    "name": "Jose Castaneda",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "44",
    "name": "Josh Boschee",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "13",
    "name": "Judy Lee",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "34",
    "name": "Justin Gerhardt",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "19",
    "name": "Karen Anderson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "41",
    "name": "Karen Grindberg",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "35",
    "name": "Karen Karls",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "31",
    "name": "Karen Rohr",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "44",
    "name": "Karla Rose Hanson",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "15",
    "name": "Kathy Frelich",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "21",
    "name": "Kathy Hogan",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "33",
    "name": "Keith Boehm",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "39",
    "name": "Keith Kempenich",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "26",
    "name": "Kelby Timmons",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "15",
    "name": "Kent Weston",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "27",
    "name": "Kristin Roers",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "41",
    "name": "Kyle Davison",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "17",
    "name": "Landon Bahl",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "25",
    "name": "Larry Luick",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "21",
    "name": "LaurieBeth Hager",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "47",
    "name": "Larry Klemin",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "4A",
    "name": "Lisa Finley-DeVille",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "32",
    "name": "Lisa Meier",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "11",
    "name": "Liz Conmy",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "3",
    "name": "Lori VanWinkle",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "40",
    "name": "Macy Bolinske",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "2",
    "name": "Mark Enget",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "22",
    "name": "Mark Weber",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "17",
    "name": "Mark Sanford",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "21",
    "name": "Mary Schneider",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "7",
    "name": "Matt Heilman",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "40",
    "name": "Matt Ruby",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "24",
    "name": "Mike Wobbema",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "47",
    "name": "Mike Dwyer",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "7",
    "name": "Michelle Axtman",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "46",
    "name": "Michelle Powers",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "20",
    "name": "Mike Beltz",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "8",
    "name": "Mike Berg",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "28",
    "name": "Mike Brandenburg",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "37",
    "name": "Mike Lefor",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "47",
    "name": "Mike Motschenbacher",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "30",
    "name": "Mike Nathe",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "39",
    "name": "Mike Schatz",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "12",
    "name": "Mitch Ostlie",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "34",
    "name": "Nathan Toman",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "18",
    "name": "Nels Christianson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "23",
    "name": "Nico Rios",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "32",
    "name": "Pat Heinert",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "1",
    "name": "Patrick Hatlestad",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "6",
    "name": "Paul Thomas",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "5",
    "name": "Randy Burckhard",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "20",
    "name": "Randy Lemm",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "9",
    "name": "Richard Marcellais",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "28",
    "name": "Robert Erbele",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "14",
    "name": "Robin Weisz",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "26",
    "name": "Roger Maki",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "45",
    "name": "Ron Sorvaag",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "10",
    "name": "Ryan Braunberger",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "5",
    "name": "Scott Louser",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "18",
    "name": "Scott Meyer",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "45",
    "name": "Scott Wagner",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "35",
    "name": "Sean Cleary",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "10",
    "name": "Steve Swiontek",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "18",
    "name": "Steve Vetter",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "8",
    "name": "SuAnn Olson",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "27",
    "name": "T.J. Brown",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "29",
    "name": "Terry Wanzek",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "11",
    "name": "Tim Mathern",
    "party": "D"
  },
  {
    "state": "nd",
    "chamber": "Senate",
    "district": "23",
    "name": "Todd Beard",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "34",
    "name": "Todd Porter",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "36",
    "name": "Ty Dressler",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "37",
    "name": "Vicky Steiner",
    "party": "R"
  },
  {
    "state": "nd",
    "chamber": "House",
    "district": "43",
    "name": "Zac Ista",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "63",
    "name": "Adam Bird",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "97",
    "name": "Adam Holmes",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "56",
    "name": "Adam Mathews",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "33",
    "name": "Al Cutrona",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "31",
    "name": "Al Landis",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "36",
    "name": "Andrea White",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "19",
    "name": "Andrew Brenner",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "84",
    "name": "Angie King",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "8",
    "name": "Anita Somani",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "74",
    "name": "Bernie Willis",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "4",
    "name": "Beryl Piccolantonio",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "61",
    "name": "Beth Lear",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "16",
    "name": "Beth Liston",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "26",
    "name": "Bill Reineke",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "31",
    "name": "Bill Roemer",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "91",
    "name": "Bob Peterson",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "70",
    "name": "Brian Lampton",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "60",
    "name": "Brian Lorenz",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "30",
    "name": "Brian Chavez",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "12",
    "name": "Brian Stewart",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "16",
    "name": "Bride Sweeney",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "7",
    "name": "Allison Russo",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "28",
    "name": "Casey Weinstein",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "9",
    "name": "Catherine Ingram",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "25",
    "name": "Cecil Thomas",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "15",
    "name": "Chris Glassburn",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "6",
    "name": "Christine Cockley",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "29",
    "name": "Cindy Abrams",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "11",
    "name": "Crystal Lett",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "89",
    "name": "D.J. Swearingen",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "24",
    "name": "Dani Isaacsohn",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "23",
    "name": "Dan Troy",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "22",
    "name": "Darnell Brewer",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "65",
    "name": "David Thomas",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "34",
    "name": "Derrick Hall",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "38",
    "name": "Desireè Tims",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "47",
    "name": "Diane Mullins",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "1",
    "name": "Dontavius Jarrells",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "42",
    "name": "Elgin Rogers",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "21",
    "name": "Eric Synenberg",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "41",
    "name": "Erika White",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "88",
    "name": "Gary Click",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "52",
    "name": "Gayle Manning",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "4",
    "name": "George Lang",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "75",
    "name": "Haraz Ghanbari",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "15",
    "name": "Hearcel Craig",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "72",
    "name": "Heidi Workman",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "3",
    "name": "Ismail Mohamed",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "10",
    "name": "Kyle Koehler",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "32",
    "name": "Jack Daniels",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "81",
    "name": "Jim Hoops",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "57",
    "name": "Jamie Callender",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "29",
    "name": "Jane Timken",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "93",
    "name": "Jason Stephens",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "62",
    "name": "Jean Schmidt",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "73",
    "name": "Jeff LaRe",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "45",
    "name": "Jennifer Gross",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "18",
    "name": "Jerry Cirino",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "49",
    "name": "Jim Thomas",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "51",
    "name": "Jodi Salvo",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "80",
    "name": "Johnathan Newman",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "53",
    "name": "Joe Miller",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "44",
    "name": "Josh Williams",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "18",
    "name": "Juanita Brent",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "90",
    "name": "Justin Pizzulli",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "28",
    "name": "Karen Brownlee",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "54",
    "name": "Kellie Deeter",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "21",
    "name": "Kent Smith",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "69",
    "name": "Kevin Miller",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "94",
    "name": "Kevin Ritter",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "27",
    "name": "Kristina Roegner",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "2",
    "name": "Latyna Humphrey",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "58",
    "name": "Lauren McNally",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "71",
    "name": "Levi Dean",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "8",
    "name": "Bill Blessing",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "76",
    "name": "Marilyn John",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "98",
    "name": "Mark Hiner",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "92",
    "name": "Mark Johnson",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "22",
    "name": "Mark Romanchuk",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "10",
    "name": "Mark Sigrist",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "78",
    "name": "Matt Huffman",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "50",
    "name": "Matt Kishman",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "67",
    "name": "Melanie Miller",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "77",
    "name": "Meredith Craig",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "5",
    "name": "Meredith Lawson‐Rowe",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "43",
    "name": "Michele Grim",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "3",
    "name": "Michele Reynolds",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "55",
    "name": "Michelle Teska",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "17",
    "name": "Mike Dovilla",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "30",
    "name": "Mike Odioso",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "79",
    "name": "Monica Blasdel",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "9",
    "name": "Munira Abdullahi",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "13",
    "name": "Nathan Manning",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "64",
    "name": "Nick Santucci",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "23",
    "name": "Nickie Antonio",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "11",
    "name": "Paula Hicks-Hudson",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "39",
    "name": "Phil Plummer",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "19",
    "name": "Phil Robinson",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "27",
    "name": "Rachel Baker",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "87",
    "name": "Riordan McClain",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "1",
    "name": "Rob McColley",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "40",
    "name": "Rodney Creech",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "96",
    "name": "Ron Ferguson",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "82",
    "name": "Roy Klopfenstein",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "32",
    "name": "Sandy O'Brien",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "99",
    "name": "Sarah Fowler Arthur",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "48",
    "name": "Scott Oelslager",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "14",
    "name": "Sean Brennan",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "26",
    "name": "Sedrick Denson",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "17",
    "name": "Shane Wilkin",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "66",
    "name": "Sharon Ray",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "5",
    "name": "Steve Huffman",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "35",
    "name": "Steve Demetriou",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "7",
    "name": "Steve Wilson",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "12",
    "name": "Susan Manchester",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "20",
    "name": "Terrence Upchurch",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "14",
    "name": "Terry Johnson",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "59",
    "name": "Tex Fischer",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "68",
    "name": "Thad Claggett",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "2",
    "name": "Theresa Gavarone",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "24",
    "name": "Tom Patton",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "46",
    "name": "Thomas Hall",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "85",
    "name": "Tim Barhorst",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "20",
    "name": "Tim Schaffer",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "37",
    "name": "Tom Young",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "86",
    "name": "Tracy Richardson",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "13",
    "name": "Tristan Rader",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "83",
    "name": "Ty Mathews",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "95",
    "name": "Ty Moore",
    "party": "R"
  },
  {
    "state": "oh",
    "chamber": "House",
    "district": "33",
    "name": "Veronica Sims",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "25",
    "name": "Bill DeMora",
    "party": "D"
  },
  {
    "state": "oh",
    "chamber": "Senate",
    "district": "6",
    "name": "Willis Blackshear",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "37",
    "name": "Aaron Reinhardt",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "41",
    "name": "Adam Pugh",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "99",
    "name": "Ajay Pittman",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "97",
    "name": "Aletia Timmons",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "2",
    "name": "Ally Seifried",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "71",
    "name": "Amanda Clinton",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "94",
    "name": "Andy Fugate",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "45",
    "name": "Annie Menz",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "57",
    "name": "Anthony Moore",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "89",
    "name": "Arturo Alonso",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "9",
    "name": "Avery Frix",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "10",
    "name": "Bill Coleman",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "4",
    "name": "Bob Culver",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "51",
    "name": "Brad Boles",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "42",
    "name": "Brenda Stanley",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "38",
    "name": "Brent Howard",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "25",
    "name": "Brian Guthrie",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "47",
    "name": "Brian Hill",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "8",
    "name": "Bryan Logan",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "58",
    "name": "Carl Newton",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "40",
    "name": "Carri Hicks",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "27",
    "name": "Casey Murdock",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "40",
    "name": "Chad Caldwell",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "24",
    "name": "Chris Banning",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "91",
    "name": "Chris Kannady",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "14",
    "name": "Chris Sneed",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "33",
    "name": "Christi Gillespie",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "20",
    "name": "Chuck Hall",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "66",
    "name": "Clay Staires",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "21",
    "name": "Cody Maynard",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "31",
    "name": "Collin Duel",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "85",
    "name": "Cyndi Munson",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "42",
    "name": "Cindy Roe",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "34",
    "name": "Dana Prieto",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "62",
    "name": "Daniel Pae",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "27",
    "name": "Danny Sterling",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "28",
    "name": "Danny Williams",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "26",
    "name": "Darcy Jech",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "24",
    "name": "Darrell Weaver",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "39",
    "name": "Dave Rader",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "6",
    "name": "David Bullard",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "86",
    "name": "David Hardin",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "18",
    "name": "David Smith",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "26",
    "name": "Dell Kerbs",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "41",
    "name": "Denise Crosswhite Hader",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "23",
    "name": "Derrick Hildebrant",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "56",
    "name": "Dick Lowe",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "32",
    "name": "Dusty Deevers",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "1",
    "name": "Eddy Dempsey",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "88",
    "name": "Ellen Pogemiller",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "87",
    "name": "Ellyn Hefner",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "90",
    "name": "Emily Gise",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "83",
    "name": "Eric Roberts",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "39",
    "name": "Erick Harris",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "92",
    "name": "Forrest Bennett",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "98",
    "name": "Gabe Woolley",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "5",
    "name": "George Burns",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "52",
    "name": "Gerrid Kendrix",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "28",
    "name": "Grant Green",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "18",
    "name": "Jack Stewart",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "46",
    "name": "Jacob Rosecrants",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "44",
    "name": "Jared Deck",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "53",
    "name": "Jason Blair",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "43",
    "name": "Jay Steagall",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "14",
    "name": "Jerry Alvord",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "17",
    "name": "Jim Grego",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "2",
    "name": "Jim Olsen",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "32",
    "name": "Jim Shaw",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "35",
    "name": "Jo Anna Dossett",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "36",
    "name": "John George",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "36",
    "name": "John Haste",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "11",
    "name": "John Kane",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "38",
    "name": "John Pfeiffer",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "77",
    "name": "John Waldron",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "20",
    "name": "Jonathan Wilk",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "13",
    "name": "Jonathan Wingard",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "49",
    "name": "Josh Cantrell",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "5",
    "name": "Josh West",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "10",
    "name": "Judd Strom",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "30",
    "name": "Julia Kirt",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "29",
    "name": "Julie Daniels",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "3",
    "name": "Julie McIntosh",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "19",
    "name": "Justin Humphrey",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "47",
    "name": "Kelly Hines",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "37",
    "name": "Ken Luttrell",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "43",
    "name": "Kendal Sacchieri",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "61",
    "name": "Kenton Patzkowsky",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "74",
    "name": "Kevin Norwood",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "54",
    "name": "Kevin West",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "22",
    "name": "Kristen Thompson",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "29",
    "name": "Kyle Hilbert",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "15",
    "name": "Lisa Standridge",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "23",
    "name": "Lonnie Paxton",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "100",
    "name": "Marilyn Stark",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "12",
    "name": "Mark Chapman",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "30",
    "name": "Mark Lawson",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "9",
    "name": "Mark Lepak",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "46",
    "name": "Mark Mann",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "69",
    "name": "Mark Tedford",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "16",
    "name": "Mary Boren",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "95",
    "name": "Max Wolfley",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "79",
    "name": "Melissa Provenzano",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "78",
    "name": "Meloyde Blancett",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "44",
    "name": "Michael Brooks",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "1",
    "name": "Micheal Bergstrom",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "72",
    "name": "Michelle McCane",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "93",
    "name": "Mickey Dollens",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "59",
    "name": "Mike Dobrinski",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "60",
    "name": "Mike Kelley",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "68",
    "name": "Mike Lay",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "81",
    "name": "Mike Osburn",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "33",
    "name": "Molly Jenkins",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "13",
    "name": "Neil Hays",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "55",
    "name": "Nick Archer",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "82",
    "name": "Nicole Miller",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "48",
    "name": "Nikki Nice",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "45",
    "name": "Paul Rosino",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "96",
    "name": "Preston Stinson",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "64",
    "name": "Rande Worthen",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "21",
    "name": "Randy Grellner",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "11",
    "name": "Regina Goodwin",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "3",
    "name": "Rick West",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "67",
    "name": "Rob Hall",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "101",
    "name": "Robert Manger",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "19",
    "name": "Roland Pederson",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "73",
    "name": "Ron Stewart",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "25",
    "name": "Ronny Johns",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "76",
    "name": "Ross Ford",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "6",
    "name": "Rusty Cornwell",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "22",
    "name": "Ryan Eaves",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "16",
    "name": "Scott Fetgatter",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "17",
    "name": "Shane Jett",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "31",
    "name": "Spencer Kern",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "50",
    "name": "Stacy Adams",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "80",
    "name": "Stan May",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "7",
    "name": "Steve Bashore",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "70",
    "name": "Suzanne Schreiber",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "75",
    "name": "T.J. Marti",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "48",
    "name": "Tammy Townley",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "84",
    "name": "Tammy West",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "15",
    "name": "Tim Turner",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "12",
    "name": "Todd Gollihare",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "8",
    "name": "Tom Gann",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "4",
    "name": "Tom Woods",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "65",
    "name": "Toni Hasenbeck",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "63",
    "name": "Trey Caldwell",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "34",
    "name": "Trish Ranson",
    "party": "D"
  },
  {
    "state": "ok",
    "chamber": "House",
    "district": "35",
    "name": "Ty Burns",
    "party": "R"
  },
  {
    "state": "ok",
    "chamber": "Senate",
    "district": "7",
    "name": "Warren Hamilton",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "4",
    "name": "Alek Skarlatos",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "47",
    "name": "Andrea Valderrama",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "23",
    "name": "Anna Scharf",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "40",
    "name": "Annessa Hartman",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "27",
    "name": "Anthony Broadman",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "39",
    "name": "April Dobson",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "25",
    "name": "Ben Bowman",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "58",
    "name": "Bobby Levy",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "9",
    "name": "Boomer Wright",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "12",
    "name": "Bruce Starr",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "6",
    "name": "Cedric Hayden",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "25",
    "name": "Chris Gorsek",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "51",
    "name": "Christine Drazan",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "1",
    "name": "Court Boice",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "13",
    "name": "Courtney Neron Misslin",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "32",
    "name": "Cyrus Javadi",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "28",
    "name": "Dacia Grayber",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "26",
    "name": "Daniel Bonham",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "38",
    "name": "Daniel Nguyen",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "31",
    "name": "Darcey Edwards",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "12",
    "name": "Darin Harbick",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "1",
    "name": "David Smith",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "10",
    "name": "David Gomberg",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "10",
    "name": "Deb Patterson",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "28",
    "name": "Diane Linthicum",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "5",
    "name": "Dick Anderson",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "3",
    "name": "Dwayne Yunker",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "55",
    "name": "Werner Reschke",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "17",
    "name": "Ed Diehl",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "53",
    "name": "Em Levy",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "56",
    "name": "Emily McIntire",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "35",
    "name": "Farrah Chaichi",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "4",
    "name": "Floyd Prozanski",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "9",
    "name": "Fred Girod",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "57",
    "name": "Greg Smith",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "36",
    "name": "Hai Pham",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "48",
    "name": "Hoa Nguyen",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "7",
    "name": "James Manning",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "11",
    "name": "Jami Cate",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "15",
    "name": "Janeen Sollman",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "54",
    "name": "Jason Kropf",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "3",
    "name": "Jeff Golden",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "52",
    "name": "Jeff Helfrich",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "7",
    "name": "John Lively",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "37",
    "name": "Jules Walters",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "14",
    "name": "Julie Fahey",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "14",
    "name": "Kate Lieber",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "21",
    "name": "Kathleen Taylor",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "24",
    "name": "Kayse Jama",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "27",
    "name": "Ken Helm",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "21",
    "name": "Kevin Mannix",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "23",
    "name": "Khanh Pham",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "11",
    "name": "Kim Thatcher",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "6",
    "name": "Kim Wallan",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "22",
    "name": "Lesly Muñoz",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "22",
    "name": "Lew Frederick",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "8",
    "name": "Lisa Fragala",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "17",
    "name": "Lisa Reynolds",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "24",
    "name": "Lucetta Elmer",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "34",
    "name": "Mari Watanabe",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "41",
    "name": "Mark Gamba",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "20",
    "name": "Mark Meek",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "60",
    "name": "Mark Owens",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "30",
    "name": "Mike McLane",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "13",
    "name": "Nancy Nathanson",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "30",
    "name": "Nathan Sosa",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "2",
    "name": "Noah Robinson",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "5",
    "name": "Pam Marsh",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "20",
    "name": "Paul Evans",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "18",
    "name": "Rick Lewis",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "50",
    "name": "Ricki Ruiz",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "42",
    "name": "Rob Nosse",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "19",
    "name": "Rob Wagner",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "8",
    "name": "Sara Gelser Blouin",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "16",
    "name": "Sarah McDonald",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "33",
    "name": "Shannon Isadore",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "15",
    "name": "Shelly Davis",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "26",
    "name": "Sue Rieke Smith",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "29",
    "name": "Susan McLain",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "16",
    "name": "Suzanne Weber",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "43",
    "name": "Tawna Sanchez",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "45",
    "name": "Thuy Tran",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "29",
    "name": "Todd Nash",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "19",
    "name": "Tom Andersen",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "44",
    "name": "Travis Nelson",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "59",
    "name": "Vikki Breese Iverson",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "2",
    "name": "Virgle Osborne",
    "party": "R"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "46",
    "name": "Willy Chotzen",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "Senate",
    "district": "18",
    "name": "Wlnsvey Campos",
    "party": "D"
  },
  {
    "state": "or",
    "chamber": "House",
    "district": "49",
    "name": "Zach Hudson",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "8",
    "name": "Aaron Bernstine",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "60",
    "name": "Abby Major",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "34",
    "name": "Abigail Salisbury",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "19",
    "name": "Aerion Abney",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "119",
    "name": "Alec Ryncavage",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "17",
    "name": "Amanda Cappelletti",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "10",
    "name": "Amen Brown",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "201",
    "name": "Andre Carroll",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "39",
    "name": "Andrew Kuzma",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "45",
    "name": "Anita Kulik",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "138",
    "name": "Ann Flood",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "203",
    "name": "Anthony Bellmon",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "8",
    "name": "Tony Williams",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "4",
    "name": "Art Haywood",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "30",
    "name": "Arvind Venkat",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "199",
    "name": "Barb Gleim",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "182",
    "name": "Ben Waxman",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "153",
    "name": "Ben Sanchez",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "6",
    "name": "Brad Roae",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "25",
    "name": "Brandon Markosek",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "120",
    "name": "Brenda Pugh",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "41",
    "name": "Brett Miller",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "144",
    "name": "Brian Munroe",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "56",
    "name": "Brian Rasel",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "66",
    "name": "Brian Smith",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "114",
    "name": "Bridget Malloy Kosierowski",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "100",
    "name": "Bryan Cutler",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "50",
    "name": "Bud Cook",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "46",
    "name": "Camera Bartolotta",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "69",
    "name": "Carl Metzgar",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "95",
    "name": "Carol Hill-Evans",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "159",
    "name": "Carol Kazeem",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "19",
    "name": "Carolyn Comitta",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "90",
    "name": "Chad Reichard",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "51",
    "name": "Charity Krupa",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "156",
    "name": "Chris Pielli",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "158",
    "name": "Christina Sappey",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "2",
    "name": "Tina Tartaglione",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "48",
    "name": "Chris Gebhard",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "200",
    "name": "Chris Rabb",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "68",
    "name": "Clint Owlett",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "145",
    "name": "Craig Staats",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "160",
    "name": "Craig Williams",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "25",
    "name": "Cris Dush",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "73",
    "name": "Dallas Kephart",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "23",
    "name": "Dan Frankel",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "35",
    "name": "Dan Goughnour",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "74",
    "name": "Dan Williams",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "42",
    "name": "Dan Miller",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "91",
    "name": "Dan Moul",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "116",
    "name": "Dane Watro",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "27",
    "name": "Dan Deasy",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "49",
    "name": "Dan Laughlin",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "155",
    "name": "Danielle Otten",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "197",
    "name": "Danilo Burgos",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "198",
    "name": "Darisha Parker",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "162",
    "name": "Dave Delloso",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "104",
    "name": "Dave Madsen",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "29",
    "name": "Dave Argall",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "99",
    "name": "Dave Zimmerman",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "130",
    "name": "David Maloney",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "85",
    "name": "David Rowe",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "31",
    "name": "Dawn Keefer",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "37",
    "name": "Devlin Robinson",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "147",
    "name": "Donna Scheuren",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "33",
    "name": "Doug Mastriano",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "122",
    "name": "Doyle Heffley",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "174",
    "name": "Ed Neilson",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "121",
    "name": "Eddie Pashinski",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "47",
    "name": "Elder Vogel",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "184",
    "name": "Elizabeth Fiedler",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "20",
    "name": "Emily Kinkead",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "58",
    "name": "Eric Davanzo",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "57",
    "name": "Eric Nelson",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "5",
    "name": "Eric Weaknecht",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "6",
    "name": "Frank Farry",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "72",
    "name": "Frank Burns",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "190",
    "name": "Roni Green",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "187",
    "name": "Gary Day",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "23",
    "name": "Gene Yaw",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "164",
    "name": "Gina Curry",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "34",
    "name": "Greg Rothman",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "54",
    "name": "Greg Scott",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "166",
    "name": "Greg Vitali",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "163",
    "name": "Heather Boyd",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "49",
    "name": "Izzy Smith-Wade-El",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "176",
    "name": "Jack Rader",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "126",
    "name": "Jacklyn Rusnock",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "4",
    "name": "Jake Banta",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "62",
    "name": "Jim Struzzi",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "36",
    "name": "James Malone",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "124",
    "name": "Jamie Barton",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "83",
    "name": "Jamie Flick",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "117",
    "name": "Jamie Walsh",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "202",
    "name": "Jared Solomon",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "16",
    "name": "Jarrett Coleman",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "179",
    "name": "Jason Dawkins",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "46",
    "name": "Jason Ortitay",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "43",
    "name": "Jay Costa",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "133",
    "name": "Jeanne McNeill",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "139",
    "name": "Jeff Olsommer",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "165",
    "name": "Jenn O'Mara",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "28",
    "name": "Jeremy Shaffer",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "78",
    "name": "Jesse Topper",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "36",
    "name": "Jessica Benham",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "55",
    "name": "Jill Cooper",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "118",
    "name": "Jim Haddock",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "140",
    "name": "Jim Prokopiak",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "71",
    "name": "Jim Rigby",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "191",
    "name": "Joanna McClinton",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "107",
    "name": "Joanne Stehr",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "146",
    "name": "Joe Ciresi",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "137",
    "name": "Joe Emrick",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "84",
    "name": "Joe Hamm",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "142",
    "name": "Joe Hogan",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "125",
    "name": "Joe Kerwin",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "32",
    "name": "Joe McAndrew",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "5",
    "name": "Joe Picozzi",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "41",
    "name": "Joe Pittman",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "150",
    "name": "Joe Webster",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "129",
    "name": "Johanny Cepeda-Freytiz",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "13",
    "name": "John Lawrence",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "101",
    "name": "John Schlegel",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "9",
    "name": "John Kane",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "38",
    "name": "John Inglis",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "111",
    "name": "Jonathan Fritz",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "186",
    "name": "Jordan Harris",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "180",
    "name": "José Giral",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "177",
    "name": "Joe Hohenstein",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "47",
    "name": "Joe D'Orsie",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "63",
    "name": "Josh Bashline",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "15",
    "name": "Josh Kail",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "22",
    "name": "Josh Siegel",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "11",
    "name": "Judy Schwank",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "30",
    "name": "Judy Ward",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "105",
    "name": "Justin Fleming",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "169",
    "name": "Kate Klunk",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "18",
    "name": "K.C. Tomlinson",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "65",
    "name": "Kathy Rapp",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "44",
    "name": "Katie Muth",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "195",
    "name": "Keith Harris",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "43",
    "name": "Keith Greiner",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "171",
    "name": "Kerry Benninghoff",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "39",
    "name": "Kim Ward",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "28",
    "name": "Kristin Phillips-Hill",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "178",
    "name": "Kristin Marcell",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "167",
    "name": "Kristine Howard",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "113",
    "name": "Kyle Donahue",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "112",
    "name": "Kyle Mullins",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "24",
    "name": "La'Tasha Mayes",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "161",
    "name": "Leanne Krueger",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "59",
    "name": "Leslie Rossi",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "21",
    "name": "Lindsay Powell",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "38",
    "name": "Lindsey Williams",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "168",
    "name": "Lisa Borowski",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "20",
    "name": "Lisa Baker",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "18",
    "name": "Lisa Boscola",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "61",
    "name": "Liz Hanbidge",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "79",
    "name": "Lou Schmitt",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "27",
    "name": "Lynda Culver",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "181",
    "name": "Malcolm Kenyatta",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "33",
    "name": "Mandy Steele",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "127",
    "name": "Manny Guzman",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "92",
    "name": "Marc Anderson",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "11",
    "name": "Marci Mustello",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "12",
    "name": "Maria Collett",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "128",
    "name": "Mark Gillen",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "9",
    "name": "Marla Brown",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "67",
    "name": "Marty Causer",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "170",
    "name": "Martina White",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "22",
    "name": "Marty Flynn",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "148",
    "name": "Mary Jo Daley",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "175",
    "name": "Mary Isaacson",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "70",
    "name": "Matt Bradford",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "115",
    "name": "Maureen Madden",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "151",
    "name": "Missy Cerrato",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "157",
    "name": "Melissa Shusterman",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "108",
    "name": "Michael Stender",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "132",
    "name": "Mike Schlossberg",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "50",
    "name": "Michele Brooks",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "75",
    "name": "Mike Armanini",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "93",
    "name": "Mike Jones",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "131",
    "name": "Milou Mackenzie",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "37",
    "name": "Mindy Fee",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "192",
    "name": "Morgan Cephas",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "152",
    "name": "Nancy Guenst",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "154",
    "name": "Napoleon Nelson",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "40",
    "name": "Natalie Mihalek",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "103",
    "name": "Nate Davidson",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "14",
    "name": "Nick Miller",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "45",
    "name": "Nick Pisciottano",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "1",
    "name": "Nikil Saval",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "96",
    "name": "Nikki Rivera",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "7",
    "name": "Parke Wentling",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "173",
    "name": "Pat Gallagher",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "1",
    "name": "Pat Harkins",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "32",
    "name": "Pat Stefano",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "15",
    "name": "Patty Kim",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "26",
    "name": "Paul Friel",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "82",
    "name": "Paul Takac",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "86",
    "name": "Perry Stambaugh",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "31",
    "name": "Perry Warren",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "134",
    "name": "Pete Schweyer",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "64",
    "name": "Lee James",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "185",
    "name": "Regina Young",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "81",
    "name": "Rich Irvin",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "188",
    "name": "Rick Krajewski",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "89",
    "name": "Rob Kauffman",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "2",
    "name": "Bob Merski",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "16",
    "name": "Rob Matzie",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "136",
    "name": "Bob Freeman",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "109",
    "name": "Robert Leadbeter",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "14",
    "name": "Roman Kozak",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "40",
    "name": "Rosemary Brown",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "102",
    "name": "Russ Diamond",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "3",
    "name": "Ryan Bizzarro",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "52",
    "name": "Ryan Warner",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "80",
    "name": "Scott Barger",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "77",
    "name": "Scott Conklin",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "21",
    "name": "Scott Hutchinson",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "13",
    "name": "Scott Martin",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "172",
    "name": "Sean Dougherty",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "196",
    "name": "Seth Grove",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "3",
    "name": "Sharif Street",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "143",
    "name": "Shelby Labs",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "88",
    "name": "Sheryl Delozier",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "76",
    "name": "Stephanie Borowicz",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "12",
    "name": "Stephenie Scialabba",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "135",
    "name": "Steve Samuelson",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "97",
    "name": "Steve Mentzer",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "10",
    "name": "Steve Santarsiero",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "53",
    "name": "Steve Malagari",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "189",
    "name": "Tarah Probst",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "194",
    "name": "Tarik Khan",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "87",
    "name": "Thomas Kutz",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "106",
    "name": "Tom Mehaffie",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "29",
    "name": "Tim Brennan",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "149",
    "name": "Tim Briggs",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "123",
    "name": "Tim Twardzik",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "48",
    "name": "Tim O'Neal",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "26",
    "name": "Tim Kearney",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "17",
    "name": "Tim Bonner",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "141",
    "name": "Tina Davis",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "110",
    "name": "Tina Pickett",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "98",
    "name": "Tom Jones",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "193",
    "name": "Torren Ecker",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "24",
    "name": "Tracy Pennycuick",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "44",
    "name": "Valerie Gaydos",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "7",
    "name": "Vincent Hughes",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "42",
    "name": "Wayne Fontana",
    "party": "D"
  },
  {
    "state": "pa",
    "chamber": "Senate",
    "district": "35",
    "name": "Wayne Langerholc",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "94",
    "name": "Wendy Fink",
    "party": "R"
  },
  {
    "state": "pa",
    "chamber": "House",
    "district": "183",
    "name": "Zach Mako",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "36",
    "name": "Alana DiMario",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "52",
    "name": "Alex Marszalkowski",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "74",
    "name": "Alex Finkelman",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "2",
    "name": "Ana Quezada",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "25",
    "name": "Andrew Dimitri",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "5",
    "name": "Anthony DeSimone",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "18",
    "name": "Arthur Handy",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "55",
    "name": "Doc Corvese",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "16",
    "name": "Brandon Potter",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "57",
    "name": "Brandon Voas",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "48",
    "name": "Brian Newberry",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "38",
    "name": "Brian Kennedy",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "20",
    "name": "Brian Thompson",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "35",
    "name": "Bridget Valverde",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "33",
    "name": "Carol McEntee",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "14",
    "name": "Charlene Lima",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "58",
    "name": "Cherie Cruz",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "15",
    "name": "Chris Paplauskas",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "2",
    "name": "Chris Blazejewski",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "20",
    "name": "David Bennett",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "47",
    "name": "David Place",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "7",
    "name": "David Morales",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "22",
    "name": "David Tikoian",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "13",
    "name": "Dawn Euer",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "43",
    "name": "Deb Fellela",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "42",
    "name": "Dick Fascia",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "26",
    "name": "Earl Read",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "1",
    "name": "Edith Ajello",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "34",
    "name": "Elaine Morgan",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "9",
    "name": "Enrique Sanchez",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "24",
    "name": "Evan Shanley",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "7",
    "name": "Frank Ciccone",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "28",
    "name": "George Nardone",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "21",
    "name": "Gordon Rogers",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "11",
    "name": "Grace Diaz",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "44",
    "name": "Greg Costantino",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "27",
    "name": "Hanna Gallo",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "1",
    "name": "Jake Bissaillon",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "17",
    "name": "Jackie Baginski",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "67",
    "name": "Jason Knight",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "64",
    "name": "Jenni Furtado",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "59",
    "name": "Jennifer Stewart",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "66",
    "name": "Jennifer Boylan",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "23",
    "name": "Jessica de la Cruz",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "70",
    "name": "Jay Edwards",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "8",
    "name": "John Lombardi",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "9",
    "name": "John Burke",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "49",
    "name": "Jon Brien",
    "party": "I"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "16",
    "name": "Jonathon Acosta",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "12",
    "name": "Jose Batista",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "22",
    "name": "Joseph Solomon",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "19",
    "name": "Joseph McNamara",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "56",
    "name": "Joshua Giraldo",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "31",
    "name": "Julie Casimiro",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "68",
    "name": "June Speakman",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "30",
    "name": "Justine Caldwell",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "23",
    "name": "Joe Shekarchi",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "60",
    "name": "Karen Alzate",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "63",
    "name": "Katie Kazarian",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "35",
    "name": "Kathleen Fogarty",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "28",
    "name": "Lammis Vargas",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "75",
    "name": "Lauren Carson",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "61",
    "name": "Leo Felix",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "33",
    "name": "Lou Raptakis",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "11",
    "name": "Linda Ujifusa",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "8",
    "name": "Lori Urso",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "12",
    "name": "Lou DiPalma",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "21",
    "name": "Marie Hopkins",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "30",
    "name": "Mark McKenney",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "73",
    "name": "Marvin Abney",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "46",
    "name": "Mary Ann Shallcross-Smith",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "62",
    "name": "Mary Messier",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "31",
    "name": "Matt LaMountain",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "65",
    "name": "Matthew Dawson",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "39",
    "name": "Megan Cotter",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "15",
    "name": "Meghan Kallman",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "24",
    "name": "Melissa Murray",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "45",
    "name": "Mia Ackerman",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "40",
    "name": "Mike Chippendale",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "71",
    "name": "Michelle McGaw",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "3",
    "name": "Nathan Biah",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "32",
    "name": "Pam Lauria",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "27",
    "name": "Pat Serpa",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "53",
    "name": "Paul Santucci",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "29",
    "name": "Pete Appollonio",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "13",
    "name": "Ramon Perez",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "6",
    "name": "Raymond Hull",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "4",
    "name": "Rebecca Kislak",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "51",
    "name": "Bob Phillips",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "32",
    "name": "Robert Craven",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "41",
    "name": "Bob Quattrocchi",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "18",
    "name": "Bob Britto",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "19",
    "name": "Ryan Pearson",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "37",
    "name": "Samuel Azzinaro",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "3",
    "name": "Sam Zurier",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "5",
    "name": "Sam Bell",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "10",
    "name": "Scott Slater",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "29",
    "name": "Sherry Roberts",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "50",
    "name": "Stephen Casey",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "69",
    "name": "Susan Donovan",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "34",
    "name": "Teresa Tanzi",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "72",
    "name": "Terri Cortvriend",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "25",
    "name": "Tom Noret",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "17",
    "name": "Thomas Paolino",
    "party": "R"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "6",
    "name": "Tiara Mack",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "36",
    "name": "Tina Spears",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "26",
    "name": "Todd Patalano",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "37",
    "name": "Sue Sosnowski",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "14",
    "name": "Val Lawson",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "38",
    "name": "Victoria Gu",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "Senate",
    "district": "10",
    "name": "Walter Felag",
    "party": "D"
  },
  {
    "state": "ri",
    "chamber": "House",
    "district": "54",
    "name": "Bill O'Brien",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "25",
    "name": "Shane Massey",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "2",
    "name": "Adam Duncan",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "27",
    "name": "Allen Blackmon",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "41",
    "name": "Annie McDaniel",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "6",
    "name": "April Cromer",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "78",
    "name": "Beth Bernstein",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "86",
    "name": "Bill Taylor",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "10",
    "name": "Billy Garrett",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "9",
    "name": "Blake Sanders",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "21",
    "name": "Bobby Cox",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "40",
    "name": "Brad Hutto",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "48",
    "name": "Brandon Guffey",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "92",
    "name": "Brandon Cox",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "45",
    "name": "Brandon Newton",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "44",
    "name": "Brian Adams",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "24",
    "name": "Bruce Bannister",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "39",
    "name": "Cal Forrest",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "103",
    "name": "Carl Anderson",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "61",
    "name": "Carla Schuessler",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "23",
    "name": "Carlisle Kennedy",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "23",
    "name": "Chandra Dillard",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "81",
    "name": "Charlie Hartz",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "28",
    "name": "Chris Huff",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "98",
    "name": "Chris Murphy",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "69",
    "name": "Chris Wooten",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "73",
    "name": "Chris Hart",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "65",
    "name": "Cody Mitchell",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "113",
    "name": "Courtney Waters",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "11",
    "name": "Craig Gagnon",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "9",
    "name": "Danny Verdin",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "12",
    "name": "Daniel Gibson",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "21",
    "name": "Darrell Jackson",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "26",
    "name": "David Martin",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "4",
    "name": "Davey Hiott",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "27",
    "name": "David Vaughan",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "29",
    "name": "Dennis Moss",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "42",
    "name": "Deon Tedder",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "8",
    "name": "Don Chapman",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "96",
    "name": "Ryan McCabe",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "20",
    "name": "Ed Sutton",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "115",
    "name": "Spencer Wetmore",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "17",
    "name": "Everett Stubbs",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "64",
    "name": "Fawn Pedalino",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "67",
    "name": "Murrell Smith",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "114",
    "name": "Gary Brewer",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "43",
    "name": "Chip Campsen",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "94",
    "name": "Gil Gatch",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "95",
    "name": "Gilda Cobb-Hunter",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "28",
    "name": "Greg Hembree",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "79",
    "name": "Hamilton Grant",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "102",
    "name": "Harriet Holman",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "14",
    "name": "Harvey Peeler",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "46",
    "name": "Heath Sessions",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "68",
    "name": "Heather Crawford",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "75",
    "name": "Heather Bauer",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "51",
    "name": "David Weeks",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "74",
    "name": "Todd Rutherford",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "15",
    "name": "J.A. Moore",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "29",
    "name": "J.D. Chaplin",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "55",
    "name": "Jackie Hayes",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "66",
    "name": "Jackie Terribile",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "44",
    "name": "Mike Neese",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "17",
    "name": "Mike Burns",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "116",
    "name": "James Teeple",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "6",
    "name": "Jason Elliott",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "54",
    "name": "Jason Luck",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "36",
    "name": "Jeff Zell",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "123",
    "name": "Jeff Bradley",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "58",
    "name": "Jeff Johnson",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "35",
    "name": "Jeffrey Graham",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "52",
    "name": "Jermaine Johnson",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "93",
    "name": "Jerry Govan",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "85",
    "name": "Jay Kilmartin",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "13",
    "name": "John McCravy",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "49",
    "name": "John King",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "117",
    "name": "Jordan Pace",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "112",
    "name": "Joe Bustos",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "40",
    "name": "Joe White",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "11",
    "name": "Josh Kimbrell",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "38",
    "name": "Josiah Magnuson",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "90",
    "name": "Justin Bamberg",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "77",
    "name": "Kambrell Garvin",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "7",
    "name": "Karl Allen",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "80",
    "name": "Kathy Landing",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "50",
    "name": "Keishan Scott",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "30",
    "name": "Kent Williams",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "105",
    "name": "Kevin Hardee",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "37",
    "name": "Larry Grooms",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "7",
    "name": "Lee Gilreath",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "108",
    "name": "Lee Hewitt",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "42",
    "name": "Doug Gilliam",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "76",
    "name": "Leon Howard",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "119",
    "name": "Leon Stavrinakis",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "91",
    "name": "Lonnie Hosey",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "57",
    "name": "Lucas Atkinson",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "33",
    "name": "Luke Rankin",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "14",
    "name": "Luke Rankin",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "30",
    "name": "Brian Lawson",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "45",
    "name": "Margie Bright Matthews",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "16",
    "name": "Mark Willis",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "99",
    "name": "Mark Smith",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "41",
    "name": "Matt Leber",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "84",
    "name": "Melissa Oremus",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "89",
    "name": "Micah Caskey",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "121",
    "name": "Michael Rivers",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "16",
    "name": "Michael Johnson",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "4",
    "name": "Mike Gambrell",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "31",
    "name": "Mike Reichenbach",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "71",
    "name": "Nathan Ballentine",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "5",
    "name": "Neal Collins",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "22",
    "name": "Overture Walker",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "19",
    "name": "Patrick Haddon",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "22",
    "name": "Paul Wickensimer",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "87",
    "name": "Paula Calhoon",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "3",
    "name": "Phillip Bowers",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "60",
    "name": "Phillip Lowe",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "2",
    "name": "Rex Rice",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "3",
    "name": "Richard Cash",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "53",
    "name": "Richie Yow",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "97",
    "name": "Robby Robbins",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "88",
    "name": "R.J. May",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "36",
    "name": "Rob Harris",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "62",
    "name": "Robert Williams",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "70",
    "name": "Robert Reese",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "12",
    "name": "Roger Nutt",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "101",
    "name": "Roger Kirby",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "32",
    "name": "Ronnie Sabb",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "18",
    "name": "Ronnie Cromer",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "31",
    "name": "Rosalyn Henderson Myers",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "8",
    "name": "Ross Turner",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "26",
    "name": "Russell Ott",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "34",
    "name": "Sarita Edgerton",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "32",
    "name": "Scott Montgomery",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "38",
    "name": "Sean Bennett",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "72",
    "name": "Seth Rose",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "13",
    "name": "Shane Martin",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "124",
    "name": "Shannon Erickson",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "20",
    "name": "Stephen Frank",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "34",
    "name": "Stephen Goldfinch",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "37",
    "name": "Steven Long",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "100",
    "name": "Sylleste Davis",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "18",
    "name": "Alan Morgan",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "19",
    "name": "Tameika Isaac Devine",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "59",
    "name": "Terry Alexander",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "10",
    "name": "Thomas Beach",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "1",
    "name": "Thomas Alexander",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "107",
    "name": "Case Brittain",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "5",
    "name": "Tom Corbin",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "106",
    "name": "Val Guest",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "47",
    "name": "Tommy Pope",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "110",
    "name": "Tom Hartnett",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "43",
    "name": "Randy Ligon",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "109",
    "name": "Tiffany Spann-Wilder",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "56",
    "name": "Tim McGinnis",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "46",
    "name": "Tom Davis",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "39",
    "name": "Tom Fernandez",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "24",
    "name": "Tom Young",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "33",
    "name": "Travis Moore",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "63",
    "name": "Jay Jordan",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "111",
    "name": "Wendell Gilliard",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "25",
    "name": "Wendell Jones",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "Senate",
    "district": "15",
    "name": "Wes Climer",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "82",
    "name": "Bill Clyburn",
    "party": "D"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "118",
    "name": "Bill Herbkersman",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "104",
    "name": "William Bailey",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "35",
    "name": "Bill Chumley",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "83",
    "name": "Bill Hixon",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "1",
    "name": "Bill Whitmire",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "122",
    "name": "Bill Hager",
    "party": "R"
  },
  {
    "state": "sc",
    "chamber": "House",
    "district": "120",
    "name": "Weston Newton",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "6",
    "name": "Aaron Aylward",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "3",
    "name": "Al Novstrup",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "12",
    "name": "Amber Arlint",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "30",
    "name": "Amber Hulse",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "12",
    "name": "Arch Beal",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "9",
    "name": "Bethany Soye",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "10",
    "name": "Bobbi Andera",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "3",
    "name": "Brandei Schaefbauer",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "11",
    "name": "Brian Mulder",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "3",
    "name": "Carl Perry",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "8",
    "name": "Casey Crabtree",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "11",
    "name": "Chris Karr",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "17",
    "name": "Chris Kassin",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "33",
    "name": "Curt Massie",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "33",
    "name": "Curt Voight",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "2",
    "name": "David Kull",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "19",
    "name": "Drew Peterson",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "4",
    "name": "Dylan Jordan",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "26A",
    "name": "Eric Emery",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "15",
    "name": "Erik Muckey",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "10",
    "name": "Erin Healy",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "6",
    "name": "Ernie Otten",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "5",
    "name": "Glen Vilhauer",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "35",
    "name": "Greg Blanc",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "12",
    "name": "Greg Jamison",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "34",
    "name": "Heather Baxter",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "25",
    "name": "Les Heinemann",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "32",
    "name": "Helene Duhamel",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "13",
    "name": "Jack Kolbeck",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "15",
    "name": "Jamie Smith",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "28A",
    "name": "Jana Hunt",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "20",
    "name": "Jeff Bathke",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "19",
    "name": "Jessica Bahmuller",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "21",
    "name": "Jim Halverson",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "24",
    "name": "Jim Mehlhaff",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "29",
    "name": "John Carley",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "13",
    "name": "John Hughes",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "2",
    "name": "John Sjaarda",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "25",
    "name": "Jon Hansen",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "5",
    "name": "Josephine Garcia",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "9",
    "name": "Joy Hohn",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "18",
    "name": "Julie Auch",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "15",
    "name": "Kadyn Wittman",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "20",
    "name": "Kaley Nolz",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "16",
    "name": "Karla Lems",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "29",
    "name": "Kathy Rice",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "4",
    "name": "Kent Roe",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "11",
    "name": "Keri Weems",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "16",
    "name": "Kevin Jensen",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "22",
    "name": "Kevin Van Diepen",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "19",
    "name": "Kyle Schoenfish",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "22",
    "name": "Lana Greenfield",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "14",
    "name": "Larry Zikmund",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "18",
    "name": "Lauren Nelson",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "10",
    "name": "Liz Larson",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "27",
    "name": "Liz May",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "1",
    "name": "Logan Manhart",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "23",
    "name": "Mark Lapka",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "21",
    "name": "Marty Overweg",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "31",
    "name": "Mary Fitzgerald",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "5",
    "name": "Matt Roby",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "7",
    "name": "Mellissa Heermann",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "1",
    "name": "Michael Rohl",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "18",
    "name": "Mike Stevens",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "34",
    "name": "Mike Derby",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "24",
    "name": "Mike Weisgram",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "21",
    "name": "MyKala Voita",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "32",
    "name": "Nicole Uhre-Balk",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "20",
    "name": "Paul Miskimins",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "27",
    "name": "Peri Pourier",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "33",
    "name": "Phil Jensen",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "31",
    "name": "Randy Deibert",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "26B",
    "name": "Rebecca Reimer",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "27",
    "name": "Red Dawn Foster",
    "party": "D"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "16",
    "name": "Richard Vasgaard",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "7",
    "name": "Roger DeGroot",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "28",
    "name": "Sam Marty",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "23",
    "name": "Scott Moore",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "31",
    "name": "Scott Odenbach",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "23",
    "name": "Spencer Gosch",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "4",
    "name": "Stephanie Sauder",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "32",
    "name": "Steve Duffy",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "2",
    "name": "Steve Kolbeck",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "13",
    "name": "Sue Peterson",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "17",
    "name": "Sydney Davis",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "34",
    "name": "Taffy Howard",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "26",
    "name": "Tamara Grove",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "14",
    "name": "Taylor Rehfeldt",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "29",
    "name": "Terri Jorgenson",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "9",
    "name": "Tesa Schwans",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "6",
    "name": "Tim Czmowski",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "30",
    "name": "Tim Goodwin",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "7",
    "name": "Tim Reed",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "8",
    "name": "Tim Reisch",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "8",
    "name": "Tim Walburg",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "35",
    "name": "Tina Mulally",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "Senate",
    "district": "25",
    "name": "Tom Pischke",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "14",
    "name": "Tony Kayser",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "35",
    "name": "Tony Randolph",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "28B",
    "name": "Travis Ismay",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "30",
    "name": "Trish Ladner",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "24",
    "name": "Will Mortenson",
    "party": "R"
  },
  {
    "state": "sd",
    "chamber": "House",
    "district": "17",
    "name": "William Shorma",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "1",
    "name": "Adam Lowe",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "51",
    "name": "Aftyn Behn",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "17",
    "name": "Andrew Farmer",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "68",
    "name": "Aron Maberry",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "6",
    "name": "Becky Massey",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "22",
    "name": "Bill Powers",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "50",
    "name": "Bo Mitchell",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "11",
    "name": "Bo Watson",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "56",
    "name": "Bob Freeman",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "4",
    "name": "Bobby Harshbarger",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "31",
    "name": "Brent Taylor",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "79",
    "name": "Brock Martin",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "48",
    "name": "Bryan Terry",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "2",
    "name": "Bud Hulsey",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "59",
    "name": "Caleb Hemmer",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "25",
    "name": "Cameron Sexton",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "19",
    "name": "Charlane Oliver",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "37",
    "name": "Charlie Baum",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "82",
    "name": "Chris Hurt",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "73",
    "name": "Chris Todd",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "46",
    "name": "Clark Boyd",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "70",
    "name": "Clay Doggett",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "22",
    "name": "Dan Howell",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "19",
    "name": "Dave Wright",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "5",
    "name": "David Hawk",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "13",
    "name": "Dawn White",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "81",
    "name": "Debra Moody",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "36",
    "name": "Dennis Powers",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "41",
    "name": "Ed Butler",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "25",
    "name": "Ed Jackson",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "18",
    "name": "Elaine Davis",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "30",
    "name": "Esther Helton-Haynes",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "18",
    "name": "Ferrell Haile",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "12",
    "name": "Fred Atchley",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "93",
    "name": "G.A. Hardaway",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "96",
    "name": "Gabby Salinas",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "9",
    "name": "Gary Hicks",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "61",
    "name": "Gino Bulso",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "90",
    "name": "Gloria Johnson",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "26",
    "name": "Greg Martin",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "29",
    "name": "Greg Vital",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "58",
    "name": "Harold Love",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "20",
    "name": "Heidi Campbell",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "39",
    "name": "Iris Rudder",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "27",
    "name": "Jack Johnson",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "63",
    "name": "Jake McCalmon",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "16",
    "name": "Janice Bowling",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "53",
    "name": "Jason Powell",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "14",
    "name": "Jason Zachary",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "74",
    "name": "Jay Reedy",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "75",
    "name": "Jeff Burkhart",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "21",
    "name": "Jeff Yarbro",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "11",
    "name": "Jeremy Faison",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "8",
    "name": "Jerome Moon",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "85",
    "name": "Jesse Chism",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "8",
    "name": "Jessie Seal",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "69",
    "name": "Jody Barrett",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "84",
    "name": "Joe Towns",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "28",
    "name": "Joey Hensley",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "1",
    "name": "John Crawford",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "97",
    "name": "John Gillespie",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "55",
    "name": "John Clemmons",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "24",
    "name": "John Stevens",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "45",
    "name": "Johnny Garrett",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "80",
    "name": "Johnny Shaw",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "86",
    "name": "Justin Pearson",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "52",
    "name": "Justin Jones",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "89",
    "name": "Justin Lafferty",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "87",
    "name": "Karen Camper",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "38",
    "name": "Kelly Keisling",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "12",
    "name": "Ken Yager",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "23",
    "name": "Kerry Roberts",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "24",
    "name": "Kevin Raper",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "95",
    "name": "Kevin Vaughan",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "71",
    "name": "Kip Capley",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "72",
    "name": "Kirk Haston",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "88",
    "name": "Larry Miller",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "65",
    "name": "Lee Reeves",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "33",
    "name": "London Lamar",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "21",
    "name": "Lowell Russell",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "23",
    "name": "Mark Cochran",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "17",
    "name": "Mark Pody",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "83",
    "name": "Mark White",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "78",
    "name": "Mary Littleton",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "40",
    "name": "Michael Hale",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "16",
    "name": "Michele Carringer",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "27",
    "name": "Michele Reneau",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "49",
    "name": "Mike Sparks",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "32",
    "name": "Monty Fritts",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "26",
    "name": "Page Walley",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "62",
    "name": "Pat Marsh",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "15",
    "name": "Paul Bailey",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "32",
    "name": "Paul Rose",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "43",
    "name": "Paul Sherrell",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "5",
    "name": "Randy McNally",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "29",
    "name": "Raumesh Akbari",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "7",
    "name": "Becky Jo Alexander",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "4",
    "name": "Renea Jones",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "98",
    "name": "Antonio Parkinson",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "7",
    "name": "Richard Briggs",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "10",
    "name": "Rick Eldridge",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "33",
    "name": "Rick Scarbrough",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "13",
    "name": "Robert Stevens",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "94",
    "name": "Ron Gant",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "31",
    "name": "Ron Travis",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "67",
    "name": "Ronnie Glynn",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "47",
    "name": "Rush Bricken",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "3",
    "name": "Rusty Crowe",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "77",
    "name": "Rusty Grills",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "42",
    "name": "Ryan Williams",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "66",
    "name": "Doc Kumar",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "15",
    "name": "Sam McKenzie",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "30",
    "name": "Sara Kyle",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "64",
    "name": "Scott Cepicky",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "14",
    "name": "Shane Reeves",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "60",
    "name": "Shaundelle Brooks",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "9",
    "name": "Steve Southerland",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "57",
    "name": "Susan Lynn",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "76",
    "name": "Tandy Darby",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "6",
    "name": "Tim Hicks",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "34",
    "name": "Tim Rudd",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "3",
    "name": "Timothy Hill",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "10",
    "name": "Todd Gardenhire",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "92",
    "name": "Todd Warner",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "Senate",
    "district": "2",
    "name": "Tom Hatcher",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "99",
    "name": "Tom Leatherwood",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "20",
    "name": "Tommy Stinnett",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "91",
    "name": "Torrey Harris",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "54",
    "name": "Vincent Dixie",
    "party": "D"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "44",
    "name": "William Lamberth",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "35",
    "name": "William Slater",
    "party": "R"
  },
  {
    "state": "tn",
    "chamber": "House",
    "district": "28",
    "name": "Yusuf Hakeem",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "30",
    "name": "A.J. Louderback",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "27",
    "name": "Adam Hinojosa",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "109",
    "name": "Aicha Davis",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "44",
    "name": "Alan Schoolcraft",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "131",
    "name": "Alma Allen",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "143",
    "name": "Ana Hernandez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "102",
    "name": "Ana-Maria Rodriguez Ramos",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "64",
    "name": "Andy Hopper",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "8",
    "name": "Angela Paxton",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "13",
    "name": "Angelia Orr",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "112",
    "name": "Angie Button",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "134",
    "name": "Ann Johnson",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "39",
    "name": "Mando Martinez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "140",
    "name": "Armando Walle",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "120",
    "name": "Barbara Gervin-Hawkins",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "63",
    "name": "Ben Bumgarner",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "2",
    "name": "Bob Hall",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "41",
    "name": "Bobby Guerra",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "13",
    "name": "Borris Miles",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "54",
    "name": "Brad Buckley",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "4",
    "name": "Brandon Creighton",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "30",
    "name": "Brent Hagenbuch",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "2",
    "name": "Brent Money",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "22",
    "name": "Brian Birdwell",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "10",
    "name": "Brian Harrison",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "128",
    "name": "Briscoe Cain",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "81",
    "name": "Brooks Landgraf",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "1",
    "name": "Bryan Hughes",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "89",
    "name": "Candy Noble",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "84",
    "name": "Carl Tepper",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "6",
    "name": "Carol Alvarado",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "87",
    "name": "Caroline Fairly",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "52",
    "name": "Caroline Harris Davila",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "73",
    "name": "Carrie Isaac",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "115",
    "name": "Cas Garcia Hernandez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "3",
    "name": "Cecil Bell",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "139",
    "name": "Charlene Ward Johnson",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "127",
    "name": "Charles Cunningham",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "28",
    "name": "Charles Perry",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "5",
    "name": "Charles Schwertner",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "99",
    "name": "Charlie Geren",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "101",
    "name": "Chris Turner",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "22",
    "name": "Christian Manuel",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "145",
    "name": "Christina Morales",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "79",
    "name": "Claudia Ordaz",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "8",
    "name": "Cody Harris",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "25",
    "name": "Cody Vasut",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "5",
    "name": "Cole Hefner",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "29",
    "name": "César Blanco",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "21",
    "name": "Dade Phelan",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "6",
    "name": "Daniel Alders",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "96",
    "name": "David Cook",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "91",
    "name": "David Lowe",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "68",
    "name": "David Spiller",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "34",
    "name": "Denise Villalobos",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "129",
    "name": "Dennis Paul",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "123",
    "name": "Diego Bernal",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "80",
    "name": "Don McLaughlin",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "25",
    "name": "Donna Campbell",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "48",
    "name": "Donna Howard",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "72",
    "name": "Drew Darby",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "83",
    "name": "Dustin Burrows",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "74",
    "name": "Eddie Morales",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "119",
    "name": "Liz Campos",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "19",
    "name": "Ellen Troxclair",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "38",
    "name": "Erin Gámez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "45",
    "name": "Erin Zwiener",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "28",
    "name": "Gary Gates",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "1",
    "name": "Gary VanDeaver",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "137",
    "name": "Gene Wu",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "49",
    "name": "Gina Hinojosa",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "98",
    "name": "Giovanni Capriglione",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "24",
    "name": "Greg Bonnen",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "142",
    "name": "Harold Dutton",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "58",
    "name": "Helen Kerwin",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "55",
    "name": "Hillary Hickland",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "149",
    "name": "Hubert Vo",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "43",
    "name": "J.M. Lozano",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "69",
    "name": "James Frank",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "50",
    "name": "James Talarico",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "37",
    "name": "Janie Lopez",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "18",
    "name": "Janis Holt",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "106",
    "name": "Jared Patterson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "7",
    "name": "Jay Dean",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "29",
    "name": "Jeff Barry",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "67",
    "name": "Jeff Leach",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "104",
    "name": "Jessica González",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "17",
    "name": "Joan Huffman",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "11",
    "name": "Joanne Shofner",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "78",
    "name": "Joe Moody",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "114",
    "name": "John Bryant",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "136",
    "name": "John Bucy",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "118",
    "name": "John Lujan",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "97",
    "name": "John McQueeney",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "86",
    "name": "John Smithee",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "147",
    "name": "Jo Jones",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "135",
    "name": "Jon Rosenthal",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "26",
    "name": "José Menéndez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "124",
    "name": "Josey Garcia",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "20",
    "name": "Chuy Hinojosa",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "21",
    "name": "Judith Zaffirini",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "33",
    "name": "Katrina Pierson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "4",
    "name": "Keith Bell",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "88",
    "name": "Ken King",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "61",
    "name": "Keresa Richardson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "31",
    "name": "Kevin Sparks",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "138",
    "name": "Lacey Hull",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "146",
    "name": "Lauren Simmons",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "107",
    "name": "Linda Garcia",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "18",
    "name": "Lois Kolkhorst",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "51",
    "name": "Lulu Flores",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "133",
    "name": "Mano DeAyala",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "121",
    "name": "Marc LaHood",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "122",
    "name": "Mark Dorazio",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "144",
    "name": "Mary Ann Perez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "75",
    "name": "Mary González",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "26",
    "name": "Matt Morgan",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "66",
    "name": "Matt Shaheen",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "11",
    "name": "Mayes Middleton",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "70",
    "name": "Mihaela Plesa",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "60",
    "name": "Mike Olcott",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "132",
    "name": "Mike Schofield",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "65",
    "name": "Mitch Little",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "15",
    "name": "Molly Cook",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "108",
    "name": "Morgan Meyer",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "93",
    "name": "Nate Schatzline",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "16",
    "name": "Nathan Johnson",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "95",
    "name": "Nicole Collier",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "35",
    "name": "Oscar Longoria",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "56",
    "name": "Pat Curry",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "7",
    "name": "Paul Bettencourt",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "14",
    "name": "Paul Dyson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "148",
    "name": "Penny Morales Shaw",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "24",
    "name": "Pete Flores",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "10",
    "name": "Phil King",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "117",
    "name": "Philip Cortez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "103",
    "name": "Rafael Anchía",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "90",
    "name": "Ramon Romero",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "125",
    "name": "Ray Lopez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "113",
    "name": "Rhetta Bowers",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "57",
    "name": "Richard Hayes",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "42",
    "name": "Richard Raymond",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "3",
    "name": "Robert Nichols",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "19",
    "name": "Roland Gutierrez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "27",
    "name": "Ron Reynolds",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "23",
    "name": "Royce West",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "31",
    "name": "Ryan Guillen",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "92",
    "name": "Salman Bhojani",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "126",
    "name": "Sam Harless",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "14",
    "name": "Sarah Eckhardt",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "141",
    "name": "Senfronia Thompson",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "36",
    "name": "Sergio Muñoz",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "59",
    "name": "Shelby Slawson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "62",
    "name": "Shelley Luther",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "46",
    "name": "Sheryl Cole",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "17",
    "name": "Stan Gerdes",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "85",
    "name": "Stan Kitzman",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "71",
    "name": "Stan Lambert",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "15",
    "name": "Steve Toth",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "76",
    "name": "Suleman Lalani",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "Senate",
    "district": "12",
    "name": "Tan Parker",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "23",
    "name": "Terri Leo-Wilson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "40",
    "name": "Terry Canales",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "20",
    "name": "Terry Wilson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "105",
    "name": "Terry Meza",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "32",
    "name": "Todd Hunter",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "82",
    "name": "Tom Craddick",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "130",
    "name": "Tom Oliverson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "110",
    "name": "Toni Rose",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "94",
    "name": "Tony Tinderholt",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "9",
    "name": "Trent Ashby",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "116",
    "name": "Trey Martinez Fischer",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "12",
    "name": "Trey Wharton",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "150",
    "name": "Valoree Swanson",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "100",
    "name": "Venton Jones",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "47",
    "name": "Vikki Goodwin",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "77",
    "name": "Vince Perez",
    "party": "D"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "53",
    "name": "Wes Virdell",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "16",
    "name": "Will Metcalf",
    "party": "R"
  },
  {
    "state": "tx",
    "chamber": "House",
    "district": "111",
    "name": "Yvonne Davis",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "52",
    "name": "Cory Maloy",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "40",
    "name": "Andrew Stoddard",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "25",
    "name": "Angela Romero",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "5",
    "name": "Ann Millner",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "27",
    "name": "Anthony Loubet",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "15",
    "name": "Ariel Defay",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "37",
    "name": "Ashlee Matthews",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "21",
    "name": "Brady Brammer",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "29",
    "name": "Bridger Bolinder",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "46",
    "name": "Cal Roberts",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "4",
    "name": "Cal Musselman",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "49",
    "name": "Candice Pierucci",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "70",
    "name": "Carl Albrecht",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "34",
    "name": "Carol Moss",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "5",
    "name": "Casey Snider",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "38",
    "name": "Cheryl Acton",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "2",
    "name": "Chris Wilson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "67",
    "name": "Christine Watkins",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "42",
    "name": "Clint Okerlund",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "73",
    "name": "Colin Jack",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "18",
    "name": "Dan McCay",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "11",
    "name": "Daniel Thatcher",
    "party": "F"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "58",
    "name": "Dave Shallenberger",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "26",
    "name": "David Hinkins",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "27",
    "name": "Derrin Owens",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "29",
    "name": "Don Ipson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "48",
    "name": "Doug Fiefia",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "33",
    "name": "Doug Owens",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "65",
    "name": "Doug Welton",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "28",
    "name": "Evan Vickers",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "41",
    "name": "Gay Lynn Bennion",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "24",
    "name": "Grant Miller",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "22",
    "name": "Heidi Balderree",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "23",
    "name": "Hoang Nguyen",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "7",
    "name": "Stuart Adams",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "30",
    "name": "Jake Fitisemanu",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "9",
    "name": "Jake Sawyer",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "36",
    "name": "Jim Dunnigan",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "8",
    "name": "Jason Kyle",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "3",
    "name": "Jason Thompson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "64",
    "name": "Jeff Burton",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "22",
    "name": "Jen Dailey-Provost",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "9",
    "name": "Jen Plumb",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "6",
    "name": "Jerry Stevenson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "10",
    "name": "Jill Koford",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "3",
    "name": "John Johnson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "55",
    "name": "Jon Hawkins",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "44",
    "name": "Jordan Teuscher",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "72",
    "name": "Joseph Elison",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "12",
    "name": "Karen Kwan",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "13",
    "name": "Karen Peterson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "14",
    "name": "Karianne Lisonbee",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "15",
    "name": "Kathleen Riebe",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "11",
    "name": "Katy Hall",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "53",
    "name": "Kay Christofferson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "23",
    "name": "Keith Grover",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "39",
    "name": "Ken Ivory",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "24",
    "name": "Keven Stratton",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "19",
    "name": "Kirk Cullimore",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "54",
    "name": "Kristen Chevrier",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "17",
    "name": "Lincoln Fillmore",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "61",
    "name": "Lisa Shepherd",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "69",
    "name": "Logan Monson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "10",
    "name": "Luz Escamilla",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "47",
    "name": "Mark Strong",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "26",
    "name": "Matt MacPherson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "6",
    "name": "Matt Gwynn",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "20",
    "name": "Melissa Ballard",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "25",
    "name": "Mike McKell",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "59",
    "name": "Mike Kohler",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "2",
    "name": "Mike Petersen",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "12",
    "name": "Mike Schultz",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "13",
    "name": "Nate Blouin",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "57",
    "name": "Nelson Abbott",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "28",
    "name": "Nicholeen Peck",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "62",
    "name": "Norm Thurston",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "18",
    "name": "Paul Cutler",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "74",
    "name": "Neil Walter",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "19",
    "name": "Ray Ward",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "71",
    "name": "Rex Shipp",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "20",
    "name": "Ron Winterton",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "35",
    "name": "Rosalba Dominguez",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "7",
    "name": "Ryan Wilcox",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "32",
    "name": "Sahara Hayes",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "21",
    "name": "Sandra Hollins",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "1",
    "name": "Scott Sandall",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "68",
    "name": "Scott Chew",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "50",
    "name": "Stephanie Gricius",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "14",
    "name": "Stephanie Pitcher",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "63",
    "name": "Stephen Whyte",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "43",
    "name": "Steve Eliason",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "17",
    "name": "Stewart Barlow",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "1",
    "name": "Tom Peterson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "4",
    "name": "Tiara Auxier",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "8",
    "name": "Todd Weiler",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "45",
    "name": "Tracy Miller",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "16",
    "name": "Trevor Lee",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "66",
    "name": "Troy Shelley",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "60",
    "name": "Tyler Clancy",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "56",
    "name": "Val Peterson",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "31",
    "name": "Verona Mauga",
    "party": "D"
  },
  {
    "state": "ut",
    "chamber": "House",
    "district": "75",
    "name": "Walt Brooks",
    "party": "R"
  },
  {
    "state": "ut",
    "chamber": "Senate",
    "district": "16",
    "name": "Wayne Harper",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-17",
    "name": "Abbey Duke",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-3",
    "name": "Alice Emmons",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-8",
    "name": "Alicia Malay",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Windsor",
    "name": "Alison Clarkson",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-24",
    "name": "Alyssa Black",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-1",
    "name": "Amy Sheldon",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Washington",
    "name": "Andrew Perchlik",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-2",
    "name": "Angela Arsenault",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Washington",
    "name": "Ann Cummings",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-1",
    "name": "Anne Donahue",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Washington",
    "name": "Anne Watson",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-Franklin",
    "name": "Tony Micklus",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-1",
    "name": "Ashley Bartley",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-14",
    "name": "Barbara Rachelson",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Caledonia-3",
    "name": "Beth Quimby",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-13",
    "name": "Bram Kleppner",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-25",
    "name": "Brenda Steady",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-15",
    "name": "Brian Cina",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Rutland",
    "name": "Brian Collamore",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-11",
    "name": "Brian Minier",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-8",
    "name": "Bridget Burkhardt",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-2",
    "name": "Candice White",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-18",
    "name": "Carol Ode",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-1",
    "name": "Carolyn Branagan",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-8",
    "name": "Casey Toof",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-5",
    "name": "Charlie Kimbell",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-5",
    "name": "Chea Evans",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-21",
    "name": "Chloe Tomlinson",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-7",
    "name": "Chris Keyser",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-Bennington",
    "name": "Chris Pritchard",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-Franklin",
    "name": "Chris Taylor",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-4",
    "name": "Christopher Howland",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Chittenden North",
    "name": "Chris Mattos",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-Windsor-Bennington",
    "name": "Chris Morrow",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-4",
    "name": "Conor Casey",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-21",
    "name": "Daisy Berbeco",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Lamoille-2",
    "name": "Dan Noyes",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-2",
    "name": "Dara Torre",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Lamoille-Washington",
    "name": "Dave Yacovone",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-2",
    "name": "Dave Bosch",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-3",
    "name": "David Durfee",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Rutland",
    "name": "Dave Weeks",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Caledonia-Essex",
    "name": "Debbie Dolgin",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Caledonia-1",
    "name": "Debbie Powers",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-20",
    "name": "Doug Bishop",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-3",
    "name": "Edye Graning",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-2",
    "name": "Lynn Dickinson",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-5",
    "name": "Ela Chapin",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-1",
    "name": "Elizabeth Burrows",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-7",
    "name": "Emilie Kornheiser",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-9",
    "name": "Emilie Krasnow",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-6",
    "name": "Emily Carris-Duncan",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-5",
    "name": "Emily Long",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-5",
    "name": "Eric Maguire",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-2",
    "name": "Erin Brady",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-6",
    "name": "Esme Cole",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-Orange",
    "name": "Topper McFaun",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-20",
    "name": "Gayle Pezzo",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-Orange",
    "name": "Gina Galfetti",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Caledonia-Washington",
    "name": "Greg Burtt",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-4",
    "name": "Heather Surprenant",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-4",
    "name": "Herb Olson",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-9",
    "name": "Ian Goodnow",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-6",
    "name": "James Gregoire",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-11",
    "name": "Jim Harrison",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-Orange-2",
    "name": "Jim Masland",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-1",
    "name": "Jana Brown",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Lamoille-1",
    "name": "Jed Lipsky",
    "party": "I"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-16",
    "name": "Jill Krowinski",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-Rutland",
    "name": "Jim Casey",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-3",
    "name": "Joe Luneau",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Windsor",
    "name": "Joe Major",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Essex-Caledonia",
    "name": "John Kascenska",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-1",
    "name": "John Bartholomew",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-Orange-1",
    "name": "John O'Brien",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-1",
    "name": "Jonathan Cooper",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orange-Caledonia",
    "name": "Joseph Parsons",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orange-3",
    "name": "Josh Dobrovich",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-5",
    "name": "Jubilee McGill",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-22",
    "name": "Karen Dolan",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-6",
    "name": "Kate Lalley",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-16",
    "name": "Kate Logan",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-4",
    "name": "Kate McCann",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-10",
    "name": "Kate Nugent",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-4",
    "name": "Kathleen James",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orleans-3",
    "name": "Ken Wells",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-1",
    "name": "Kenneth Goslant",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Chittenden Southeast",
    "name": "Kesha Ram Hinsdale",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-6",
    "name": "Kevin Christie",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-Windsor",
    "name": "Kevin Winter",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-Addison",
    "name": "Kirk White",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-3",
    "name": "Kristi Morris",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Orange",
    "name": "Larry Hart",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Essex-Orleans",
    "name": "Larry Labor",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orange-Washington-Addison",
    "name": "Larry Satcowitz",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-2",
    "name": "Laura Sibilia",
    "party": "I"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orleans-4",
    "name": "Leanne Harple",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Grand Isle-Chittenden",
    "name": "Leland Morgan",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-23",
    "name": "Leonora Dodge",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-3",
    "name": "Leslie Goldman",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-5",
    "name": "Lisa Hango",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-22",
    "name": "Lori Houghton",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Lamoille-3",
    "name": "Lucy Boyden",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-6",
    "name": "Marc Mihaly",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-4",
    "name": "Mari Cordes",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orleans-Lamoille",
    "name": "Mark Higley",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-12",
    "name": "Martin LaLonde",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Chittenden Central",
    "name": "Martine Gulick",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Caledonia-3",
    "name": "Marty Feltus",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-5",
    "name": "Mary Morrissey",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-6",
    "name": "Mary Howard",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-14",
    "name": "Mary-Katherine Stone",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-4",
    "name": "Matt Walker",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-3",
    "name": "Matt Birong",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-3",
    "name": "Michael Boutin",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orleans-Lamoille",
    "name": "Michael Marcotte",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-4",
    "name": "Mike Mrowicki",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-5",
    "name": "Michael Nigro",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Caledonia-2",
    "name": "Mike Southworth",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orange-1",
    "name": "Mike Tagliavia",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-3",
    "name": "Michelle Bos-Lun",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Grand Isle-Chittenden",
    "name": "Mike Morgan",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-8",
    "name": "Mollie Burke",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orange-2",
    "name": "Monique Priestley",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Windham",
    "name": "Nader Hashim",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-1",
    "name": "Pattie McCoy",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Grand Isle",
    "name": "Patrick Brennan",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-7",
    "name": "Penny Demar",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-2",
    "name": "Peter Conlon",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Chittenden Central",
    "name": "Phil Baruth",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-4",
    "name": "Phil Pouech",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orange-Washington-Addison",
    "name": "Jay Hooper",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Caledonia-Essex",
    "name": "Scott Campbell",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Franklin",
    "name": "Randy Brock",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-Orange-2",
    "name": "Rebecca Holcombe",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Windsor",
    "name": "Becca White",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-23",
    "name": "Rey Garofano",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Lamoille-2",
    "name": "Richard Bailey",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orleans-1",
    "name": "Richard Nelson",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Lamoille",
    "name": "Richard Westman",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-4",
    "name": "Rob Hunter",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-3",
    "name": "Rob North",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-18",
    "name": "Bob Hooper",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Franklin",
    "name": "Bob Norris",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Bennington",
    "name": "Rob Plunkett",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Addison-1",
    "name": "Robin Scheu",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Essex",
    "name": "Russ Ingalls",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Addison",
    "name": "Ruth Hardy",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Orleans",
    "name": "Sam Douglass",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-Rutland",
    "name": "Sandy Pinsonault",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-19",
    "name": "Sarita Austin",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Lamoille-Washington",
    "name": "Saudia Lamont",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Caledonia",
    "name": "Scott Beck",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Bennington",
    "name": "Seth Bongartz",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-7",
    "name": "Shawn Sweeney",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Addison",
    "name": "Steven Heffernan",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Chittenden Central",
    "name": "Tanya Vyhovsky",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-3",
    "name": "Teddy Waszazak",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Rutland",
    "name": "Terry Williams",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-Chittenden",
    "name": "Theresa Wood",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-2",
    "name": "Tom Burditt",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-Windham",
    "name": "Tom Charlton",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Chittenden Southeast",
    "name": "Thomas Chittenden",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-4",
    "name": "Tom Oliver",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Washington-Chittenden",
    "name": "Tom Stevens",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-13",
    "name": "Tiff Bluemle",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-2",
    "name": "Timothy Corcoran",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-9",
    "name": "Todd Nielsen",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-3",
    "name": "Trevor Squirrell",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-15",
    "name": "Troy Headrick",
    "party": "I"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windsor-2",
    "name": "V.L. Coffin",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Chittenden Southeast",
    "name": "Ginny Lyons",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Franklin-5",
    "name": "Wayne Laroche",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Chittenden-19",
    "name": "Wendy Critchlow",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "Senate",
    "district": "Windham",
    "name": "Wendy Harrison",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Bennington-2",
    "name": "Will Greer",
    "party": "D"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-10",
    "name": "Bill Canfield",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Orleans-2",
    "name": "Woody Page",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Rutland-3",
    "name": "Zak Harvey",
    "party": "R"
  },
  {
    "state": "vt",
    "chamber": "House",
    "district": "Windham-1",
    "name": "Zon Eastes",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "86",
    "name": "A.C. Cordoza",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "22",
    "name": "Aaron Rouse",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "39",
    "name": "Adam Ebbin",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "2",
    "name": "Adele McClure",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "95",
    "name": "Alex Askew",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "3",
    "name": "Alfonso Lopez",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "71",
    "name": "Amanda Batten",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "55",
    "name": "Amy Laufer",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "21",
    "name": "Angelia Graves",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "99",
    "name": "Anne Ferrell Tata",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "27",
    "name": "Atoosa Reaser",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "40",
    "name": "Barbara Favola",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "98",
    "name": "Barry Knight",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "78",
    "name": "Betsy Carr",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "20",
    "name": "Bill DeSteph",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "92",
    "name": "Bonita Anthony",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "25",
    "name": "Briana Sewell",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "28",
    "name": "Bryce Reeves",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "91",
    "name": "Cliff Hayes",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "23",
    "name": "Candi King",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "75",
    "name": "Carrie Coyner",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "4",
    "name": "Charniele Herring",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "41",
    "name": "Chris Obenshain",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "35",
    "name": "Chris Runion",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "19",
    "name": "Christie Craig",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "3",
    "name": "Chris Head",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "10",
    "name": "Dan Helmer",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "30",
    "name": "Danica Roem",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "49",
    "name": "Danny Marshall",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "28",
    "name": "David Reid",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "11",
    "name": "David Bulova",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "57",
    "name": "David Owen",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "4",
    "name": "David Suetterlein",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "35",
    "name": "Dave Marsden",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "76",
    "name": "Debra Gardner",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "81",
    "name": "Delores McQuinn",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "31",
    "name": "Delores Oates",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "80",
    "name": "Destiny LeVere Bolling",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "88",
    "name": "Don Scott",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "5",
    "name": "Elizabeth Bennett-Parker",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "36",
    "name": "Ellen Campbell",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "17",
    "name": "Emily Jordan",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "48",
    "name": "Eric Phillips",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "51",
    "name": "Eric Zehr",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "30",
    "name": "Geary Higgins",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "15",
    "name": "Ghazala Hashmi",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "12",
    "name": "Glen Sturtevant",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "83",
    "name": "Otto Wachsmann",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "67",
    "name": "Hillary Pugh Kent",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "12",
    "name": "Holly Seibold",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "59",
    "name": "Buddy Fowler",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "22",
    "name": "Ian Lovejoy",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "8",
    "name": "Irene Shin",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "44",
    "name": "Israel O'Quinn",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "24",
    "name": "Danny Diggs",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "26",
    "name": "J.J. Singh",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "93",
    "name": "Jackie Glass",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "90",
    "name": "Jay Leftwich",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "43",
    "name": "Will Morefield",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "42",
    "name": "Jason Ballard",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "87",
    "name": "Jeion Ward",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "38",
    "name": "Jennifer Boysko",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "33",
    "name": "Jennifer Carroll Foy",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "29",
    "name": "Jeremy McPike",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "46",
    "name": "Jed Arnold",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "40",
    "name": "Joe McNamara",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "21",
    "name": "Josh Thomas",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "65",
    "name": "Josh Cole",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "32",
    "name": "Kannan Srinivasan",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "7",
    "name": "Karen Keys-Gamarra",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "9",
    "name": "Karrie Delaney",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "18",
    "name": "Kathy Tran",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "54",
    "name": "Katrina Callsen",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "96",
    "name": "Kelly Fowler",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "82",
    "name": "Kim Taylor",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "18",
    "name": "Louise Lucas",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "14",
    "name": "Lamont Bagby",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "13",
    "name": "Lashrecse Aird",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "15",
    "name": "Laura Jane Cohen",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "24",
    "name": "Luke Torian",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "10",
    "name": "Luther Cifers",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "68",
    "name": "Keith Hodges",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "23",
    "name": "Mamie Locke",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "85",
    "name": "Cia Price",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "13",
    "name": "Marcus Simon",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "2",
    "name": "Mark Obenshain",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "17",
    "name": "Mark Sickles",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "8",
    "name": "Mark Peake",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "73",
    "name": "Mark Earley",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "29",
    "name": "Marty Martinez",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "97",
    "name": "Michael Feggans",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "77",
    "name": "Mike Jones",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "61",
    "name": "Mike Webert",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "20",
    "name": "Michelle Maldonado",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "74",
    "name": "Mike Cherry",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "89",
    "name": "Baxter Ennis",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "84",
    "name": "Nadarius Clark",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "62",
    "name": "Nick Freitas",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "1",
    "name": "Patrick Hope",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "16",
    "name": "Paul Krizek",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "64",
    "name": "Paul Milde",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "94",
    "name": "Phil Hernandez",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "63",
    "name": "Phil Scott",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "11",
    "name": "Creigh Deeds",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "72",
    "name": "Lee Ware",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "79",
    "name": "Rae Cousins",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "6",
    "name": "Rip Sullivan",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "25",
    "name": "Richard Stuart",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "66",
    "name": "Bobby Orrock",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "100",
    "name": "Rob Bloxom",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "58",
    "name": "Rod Willett",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "19",
    "name": "J.R. Henson",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "31",
    "name": "Russet Perry",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "26",
    "name": "Ryan McDougle",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "37",
    "name": "Saddam Salim",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "38",
    "name": "Sam Rasoul",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "16",
    "name": "Schuyler VanValkenburg",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "34",
    "name": "Scott Surovell",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "60",
    "name": "Scott Wyatt",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "70",
    "name": "Shelly Simonds",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "36",
    "name": "Stella Pekarsky",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "5",
    "name": "Travis Hackworth",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "9",
    "name": "Tammy Mulchi",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "27",
    "name": "Tara Durant",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "45",
    "name": "Terry Kilgore",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "37",
    "name": "Terry Austin",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "50",
    "name": "Tommy Wright",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "53",
    "name": "Tim Griffin",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "1",
    "name": "Timmy French",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "6",
    "name": "Todd Pillion",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "56",
    "name": "Tom Garrett",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "34",
    "name": "Tony Wilt",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "14",
    "name": "Vivian Watts",
    "party": "D"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "69",
    "name": "Chad Green",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "52",
    "name": "Wendell Walker",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "39",
    "name": "Will Davis",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "Senate",
    "district": "7",
    "name": "Bill Stanley",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "32",
    "name": "Bill Wiley",
    "party": "R"
  },
  {
    "state": "va",
    "chamber": "House",
    "district": "47",
    "name": "Wren Williams",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "24",
    "name": "Adam Bernbaum",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "26",
    "name": "Adison Richards",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "18",
    "name": "Adrian Cortes",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "40",
    "name": "Alex Ramel",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "13",
    "name": "Alex Ybarra",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "42",
    "name": "Alicia Rule",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "48",
    "name": "Amy Walen",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "2",
    "name": "Andrew Barkis",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "7",
    "name": "Andrew Engell",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "49",
    "name": "Annette Cleveland",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "44",
    "name": "April Berg",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "8",
    "name": "April Connors",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "22",
    "name": "Beth Doglio",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "11",
    "name": "Bob Hasegawa",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "44",
    "name": "Brandy Donaghy",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "12",
    "name": "Brian Burnett",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "34",
    "name": "Brianna Thomas",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "39",
    "name": "Carolyn Eslick",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "37",
    "name": "Chipalo Street",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "15",
    "name": "Chris Corry",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "25",
    "name": "Chris Gildon",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "47",
    "name": "Chris Stearns",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "32",
    "name": "Cindy Ryu",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "30",
    "name": "Claire Wilson",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "47",
    "name": "Claudia Kauffman",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "10",
    "name": "Clyde Shavers",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "14",
    "name": "Curtis King",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "25",
    "name": "Cyndy Jacobsen",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "28",
    "name": "Dan Bronoske",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "35",
    "name": "Dan Griffey",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "46",
    "name": "Darya Farivar",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "10",
    "name": "Dave Paul",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "17",
    "name": "Dave Stuebe",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "11",
    "name": "David Hackney",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "1",
    "name": "Davina Duerr",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "26",
    "name": "Deb Krishnadasan",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "14",
    "name": "Deb Manjarrez",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "47",
    "name": "Debra Entenman",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "40",
    "name": "Debra Lekanoff",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "1",
    "name": "Derek Stanford",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "23",
    "name": "Drew Hansen",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "35",
    "name": "Drew MacEwen",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "31",
    "name": "Drew Stokesbary",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "20",
    "name": "Ed Orcutt",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "33",
    "name": "Edwin Obras",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "34",
    "name": "Emily Alvarado",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "46",
    "name": "Gerry Pollet",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "14",
    "name": "Gloria Mendoza",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "23",
    "name": "Greg Nance",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "7",
    "name": "Hunter Abell",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "27",
    "name": "Jake Fey",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "43",
    "name": "Jamie Pedersen",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "30",
    "name": "Jamila Taylor",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "41",
    "name": "Janice Zahn",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "46",
    "name": "Javier Valdez",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "6",
    "name": "Jeff Holy",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "19",
    "name": "Jeff Wilson",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "6",
    "name": "Jenny Graham",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "15",
    "name": "Jeremie Dufault",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "32",
    "name": "Jesse Salomon",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "22",
    "name": "Jess Bateman",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "2",
    "name": "Jim McCune",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "19",
    "name": "Jim Walsh",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "34",
    "name": "Joe Fitzgibbon",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "9",
    "name": "Joe Schmick",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "42",
    "name": "Joe Timmons",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "19",
    "name": "Joel McEntire",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "20",
    "name": "John Braun",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "18",
    "name": "John Ley",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "44",
    "name": "John Lovick",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "31",
    "name": "Josh Penner",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "13",
    "name": "Judy Warnick",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "36",
    "name": "Julia Reed",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "38",
    "name": "Julio Cortes",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "38",
    "name": "June Robinson",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "12",
    "name": "Keith Goehner",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "39",
    "name": "Keith Wagoner",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "17",
    "name": "Kevin Waters",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "30",
    "name": "Kristine Reeves",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "45",
    "name": "Larry Springer",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "32",
    "name": "Lauren Davis",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "27",
    "name": "Laurie Jinkins",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "4",
    "name": "Leonard Christian",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "21",
    "name": "Lillian Ortiz-Self",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "5",
    "name": "Lisa Callan",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "22",
    "name": "Lisa Parshley",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "41",
    "name": "Lisa Wellman",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "36",
    "name": "Liz Berry",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "40",
    "name": "Liz Lovelett",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "45",
    "name": "Manka Dhingra",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "3",
    "name": "Marcus Riccelli",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "28",
    "name": "Mari Leavitt",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "16",
    "name": "Mark Klicker",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "9",
    "name": "Mark Schoesler",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "21",
    "name": "Marko Liias",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "9",
    "name": "Mary Dye",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "38",
    "name": "Mary Fosse",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "8",
    "name": "Matt Boehnke",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "2",
    "name": "Matt Marshall",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "29",
    "name": "Melanie Morgan",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "33",
    "name": "Mia Gregerson",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "25",
    "name": "Michael Keaton",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "26",
    "name": "Michelle Caldier",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "24",
    "name": "Mike Chapman",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "12",
    "name": "Mike Steele",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "6",
    "name": "Mike Volz",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "49",
    "name": "Monica Stonier",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "41",
    "name": "My-Linh Thai",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "3",
    "name": "Natasha Hill",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "43",
    "name": "Nicole Macri",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "15",
    "name": "Nikki Torres",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "36",
    "name": "Noel Frame",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "48",
    "name": "Osman Salahuddin",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "17",
    "name": "Paul Harris",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "16",
    "name": "Perry Dozier",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "20",
    "name": "Peter Abbarno",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "31",
    "name": "Phil Fortunato",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "37",
    "name": "Rebecca Saldaña",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "4",
    "name": "Rob Chase",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "45",
    "name": "Roger Goodman",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "10",
    "name": "Ron Muzzall",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "39",
    "name": "Sam Low",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "29",
    "name": "Sharlett Mena",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "42",
    "name": "Sharon Shewmake",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "37",
    "name": "Sharon Tomiko Santos",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "49",
    "name": "Sharon Wylie",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "43",
    "name": "Shaun Scott",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "1",
    "name": "Shelley Kloba",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "7",
    "name": "Shelly Short",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "16",
    "name": "Skyler Rude",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "8",
    "name": "Stephanie Barnard",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "18",
    "name": "Stephanie McClintock",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "11",
    "name": "Steve Bergquist",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "29",
    "name": "Steve Conway",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "24",
    "name": "Steve Tharinger",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "21",
    "name": "Strom Peterson",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "4",
    "name": "Suzanne Schmidt",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "23",
    "name": "Tarra Simmons",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "3",
    "name": "Timm Ormsby",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "33",
    "name": "Tina Orwall",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "13",
    "name": "Tom Dent",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "35",
    "name": "Travis Couture",
    "party": "R"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "28",
    "name": "T'wina Nobles",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "48",
    "name": "Vandana Slatter",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "5",
    "name": "Victoria Hunt",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "Senate",
    "district": "27",
    "name": "Yasmin Trudeau",
    "party": "D"
  },
  {
    "state": "wa",
    "chamber": "House",
    "district": "5",
    "name": "Zach Hall",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "64",
    "name": "Adam Burkhammer",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "35",
    "name": "Adam Vance",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "4",
    "name": "Amy Grady",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "59",
    "name": "Andy Shamblin",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "81",
    "name": "Anitra Hamilton",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "17",
    "name": "Anne Charnock",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "12",
    "name": "Ben Queen",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "8",
    "name": "Bill Bell",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "4",
    "name": "Bill Flanigan",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "11",
    "name": "Bill Hamilton",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "100",
    "name": "Bill Ridenour",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "44",
    "name": "Bill Roop",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "11",
    "name": "Bob Fehrenbacher",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "42",
    "name": "Brandon Steele",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "9",
    "name": "Brian Helton",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "73",
    "name": "Bryan Smith",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "86",
    "name": "Bryan Ward",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "65",
    "name": "Robbie Martin",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "2",
    "name": "Charles Clements",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "7",
    "name": "Chuck Sheedy",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "97",
    "name": "Chris Anders",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "68",
    "name": "Chris Phillips",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "2",
    "name": "Chris Rose",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "43",
    "name": "Chris Toney",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "95",
    "name": "Chuck Horst",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "72",
    "name": "Clay Riley",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "6",
    "name": "Craig Hart",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "84",
    "name": "Buck Jennings",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "60",
    "name": "Dana Ferrell",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "22",
    "name": "Daniel Linville",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "15",
    "name": "Darren Thorne",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "14",
    "name": "Dave Foggin",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "82",
    "name": "Dave McCormick",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "89",
    "name": "David Cannon",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "50",
    "name": "Elliott Pritt",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "36",
    "name": "David Green",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "61",
    "name": "Dean Jeffries",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "3",
    "name": "Donna Boley",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "39",
    "name": "Doug Smith",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "67",
    "name": "Elías Coop-González",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "45",
    "name": "Eric Brooks",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "4",
    "name": "Eric Tarr",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "15",
    "name": "Erica Moore",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "79",
    "name": "Evan Hansen",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "23",
    "name": "Evan Worrell",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "87",
    "name": "Gary Howell",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "78",
    "name": "Geno Chiarelli",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "90",
    "name": "George Miller",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "83",
    "name": "George Street",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "8",
    "name": "Glenn Jeffries",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "29",
    "name": "Corby Dillon",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "57",
    "name": "Hollis Lewis",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "91",
    "name": "Ian Masters",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "55",
    "name": "J.B. Akers",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "10",
    "name": "Jack Woodrum",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "21",
    "name": "Jarred Cannon",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "16",
    "name": "Jason Barrett",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "14",
    "name": "Jay Taylor",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "46",
    "name": "Jeff Campbell",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "30",
    "name": "Jeff Eldridge",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "6",
    "name": "Jeff Stephens",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "18",
    "name": "Jim Butler",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "3",
    "name": "Jimmy Willis",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "38",
    "name": "Joe Ellington",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "98",
    "name": "Joe Funkhouser",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "16",
    "name": "Joe Parsons",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "77",
    "name": "Joe Statler",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "13",
    "name": "Joey Garcia",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "85",
    "name": "John Paul Hott",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "80",
    "name": "John Williams",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "66",
    "name": "Jonathan Kyle",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "17",
    "name": "Jonathan Pinson",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "33",
    "name": "Jordan Bridges",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "41",
    "name": "Jordan Maynor",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "32",
    "name": "Josh Holstein",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "19",
    "name": "Kathie Hess Crouse",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "56",
    "name": "Kayla Young",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "69",
    "name": "Keith Marple",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "8",
    "name": "Kevan Bartlett",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "94",
    "name": "Larry Kump",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "71",
    "name": "Laura Kimble",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "1",
    "name": "Laura Chapman",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "96",
    "name": "Lisa White",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "63",
    "name": "Lori Dittman",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "31",
    "name": "Margitta Mazzocchi",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "34",
    "name": "Mark Dean",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "6",
    "name": "Mark Maynard",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "2",
    "name": "Mark Zatezalo",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "51",
    "name": "Marshall Clay",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "37",
    "name": "Marty Gearheart",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "26",
    "name": "Matthew Rohrbach",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "27",
    "name": "Michael Amos",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "92",
    "name": "Mike Hite",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "93",
    "name": "Mike Hornby",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "70",
    "name": "Mickey Petitto",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "3",
    "name": "Mike Azinger",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "74",
    "name": "Mike DeVault",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "13",
    "name": "Mike Oliverio",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "54",
    "name": "Mike Pushkin",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "7",
    "name": "Mike Stuart",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "5",
    "name": "Mike Woelfel",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "1",
    "name": "Pat McGeehan",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "16",
    "name": "Patricia Rucker",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "24",
    "name": "Patrick Lucas",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "12",
    "name": "Patrick Martin",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "75",
    "name": "Phil Mallow",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "14",
    "name": "Randy Smith",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "47",
    "name": "Ray Canterbury",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "76",
    "name": "Rick Garcia",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "88",
    "name": "Rick Hillenbrand",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "11",
    "name": "Robbie Morris",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "62",
    "name": "Roger Hanshaw",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "9",
    "name": "Rollan Roberts",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "40",
    "name": "Roy Cooper",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "7",
    "name": "Rupie Phillips",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "28",
    "name": "Ryan Browning",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "1",
    "name": "Ryan Weld",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "20",
    "name": "Sarah Drennan",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "13",
    "name": "Scot Heckert",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "5",
    "name": "Scott Fuller",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "25",
    "name": "Sean Hornbuckle",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "5",
    "name": "Shawn Fluharty",
    "party": "D"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "49",
    "name": "Stan Adkins",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "48",
    "name": "Tom Clark",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "17",
    "name": "Tom Takubo",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "15",
    "name": "Tom Willis",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "9",
    "name": "Trenton Barnhart",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "52",
    "name": "Tresa Howell",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "53",
    "name": "Tristan Leavitt",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "12",
    "name": "Vernon Criss",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "Senate",
    "district": "10",
    "name": "Vince Deeds",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "58",
    "name": "Walter Hall",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "99",
    "name": "Wayne Clark",
    "party": "R"
  },
  {
    "state": "wv",
    "chamber": "House",
    "district": "10",
    "name": "Bill Anderson",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "15",
    "name": "Adam Neylon",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "39",
    "name": "Alex Dallman",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "81",
    "name": "Alex Joers",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "90",
    "name": "Amaad Rivera-Wagner",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "32",
    "name": "Amanda Nedweski",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "1",
    "name": "André Jacque",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "48",
    "name": "Andrew Hysell",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "73",
    "name": "Angela Stroud",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "62",
    "name": "Angelina Cruz",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "14",
    "name": "Angelito Tenorio",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "44",
    "name": "Ann Roe",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "99",
    "name": "Barbara Dittrich",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "65",
    "name": "Ben DeSmidt",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "88",
    "name": "Ben Franklin",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "61",
    "name": "Bob Donovan",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "32",
    "name": "Brad Pfaff",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "87",
    "name": "Brent Jacobson",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "43",
    "name": "Brienne Brown",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "35",
    "name": "Calvin Callahan",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "74",
    "name": "Chanz Green",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "33",
    "name": "Chris Kapenga",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "7",
    "name": "Chris Larson",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "93",
    "name": "Christian Phelps",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "20",
    "name": "Christine Sinicki",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "84",
    "name": "Chuck Wichgers",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "97",
    "name": "Cindi Duchow",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "92",
    "name": "Clint Moses",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "45",
    "name": "Clint Anderson",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "29",
    "name": "Cory Tomczyk",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "20",
    "name": "Dan Feyen",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "24",
    "name": "Dan Knodl",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "10",
    "name": "Darrin Madison",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "83",
    "name": "Dave Maxey",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "67",
    "name": "Dave Armstrong",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "56",
    "name": "Dave Murphy",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "4",
    "name": "David Steffen",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "53",
    "name": "Dean Kaufert",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "23",
    "name": "Deb Andraca",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "9",
    "name": "Devin LeMahieu",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "27",
    "name": "Dianne Hesselbein",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "4",
    "name": "Dora Drake",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "75",
    "name": "Duke Tucker",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "6",
    "name": "Elijah Behnke",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "2",
    "name": "Eric Wimberger",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "76",
    "name": "Francesca Hong",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "66",
    "name": "Greta Neubauer",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "17",
    "name": "Howard Marklein",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "30",
    "name": "Jamie Wall",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "31",
    "name": "Jeff Smith",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "36",
    "name": "Jeff Mursau",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "50",
    "name": "Jenna Jacobson",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "60",
    "name": "Jerry O'Connor",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "23",
    "name": "Jesse James",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "21",
    "name": "Jessie Rodriguez",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "95",
    "name": "Jill Billings",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "98",
    "name": "Jim Piwowarczyk",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "46",
    "name": "Joan Fitzgerald",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "91",
    "name": "Jodi Emerson",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "8",
    "name": "Jodi Habush Sinykin",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "26",
    "name": "Joe Sheehan",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "1",
    "name": "Joel Kitchens",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "13",
    "name": "John Jagler",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "86",
    "name": "John Spiros",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "5",
    "name": "Joy Goeben",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "28",
    "name": "Julian Bradley",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "16",
    "name": "Kalan Haywood",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "40",
    "name": "Karen DeSanto",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "69",
    "name": "Karen Hurd",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "7",
    "name": "Karen Kirsch",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "26",
    "name": "Kelda Roys",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "57",
    "name": "Kevin Petersen",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "18",
    "name": "Kris Alfheim",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "6",
    "name": "LaTonya Johnson",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "52",
    "name": "Lee Snodgrass",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "27",
    "name": "Lindee Brill",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "79",
    "name": "Lisa Subeck",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "54",
    "name": "Lori Palmeri",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "18",
    "name": "Margaret Arney",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "37",
    "name": "Mark Born",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "15",
    "name": "Mark Spreitzer",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "12",
    "name": "Mary Felzkowski",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "42",
    "name": "Maureen McCarville",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "16",
    "name": "Melissa Ratcliff",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "80",
    "name": "Mike Bare",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "70",
    "name": "Nancy VanderMeer",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "55",
    "name": "Gus Gustafson",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "85",
    "name": "Pat Snyder",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "24",
    "name": "Patrick Testin",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "22",
    "name": "Paul Melotik",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "25",
    "name": "Paul Tittl",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "9",
    "name": "Priscilla Prado",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "19",
    "name": "Rachael Cabral-Guevara",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "47",
    "name": "Randy Udell",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "77",
    "name": "Renuka Mayadev",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "58",
    "name": "Rick Gundrum",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "5",
    "name": "Rob Hutton",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "28",
    "name": "Rob Kreibich",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "10",
    "name": "Rob Stafsholt",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "68",
    "name": "Rob Summerfield",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "34",
    "name": "Rob Swearingen",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "59",
    "name": "Rob Brooks",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "22",
    "name": "Bob Wirch",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "63",
    "name": "Bob Wittke",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "33",
    "name": "Robin Vos",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "13",
    "name": "Robyn Vining",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "25",
    "name": "Romaine Quinn",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "3",
    "name": "Ron Tusler",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "12",
    "name": "Russell Goodwin",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "19",
    "name": "Ryan Clancy",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "89",
    "name": "Ryan Spaude",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "14",
    "name": "Sarah Keyeski",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "82",
    "name": "Scott Allen",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "72",
    "name": "Scott Krug",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "11",
    "name": "Sequanna Taylor",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "2",
    "name": "Shae Sortwell",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "30",
    "name": "Shannon Zimmerman",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "78",
    "name": "Shelia Stubbs",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "11",
    "name": "Steve Nass",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "94",
    "name": "Steve Doyle",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "17",
    "name": "Supreme Moore Omokunde",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "8",
    "name": "Sylvia Ortiz-Velez",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "96",
    "name": "Tara Johnson",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "3",
    "name": "Tim Carpenter",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "64",
    "name": "Tip McGuire",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "51",
    "name": "Todd Novak",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "41",
    "name": "Tony Kurtz",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "49",
    "name": "Travis Tranel",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "29",
    "name": "Treig Pronschinske",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "31",
    "name": "Tyler August",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "Senate",
    "district": "21",
    "name": "Van Wanggaard",
    "party": "R"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "71",
    "name": "Vinnie Miresse",
    "party": "D"
  },
  {
    "state": "wi",
    "chamber": "House",
    "district": "38",
    "name": "Will Penterman",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "3",
    "name": "Abby Angelos",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "22",
    "name": "Andrew Byron",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "43",
    "name": "Ann Lucas",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "36",
    "name": "Art Washut",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "22",
    "name": "Barry Crago",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "58",
    "name": "Bill Allemand",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "27",
    "name": "Bill Landen",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "21",
    "name": "Bo Biteman",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "47",
    "name": "Bob Davis",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "29",
    "name": "Bob Ide",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "7",
    "name": "Bob Nicholas",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "2",
    "name": "Brian Boner",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "25",
    "name": "Cale Case",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "30",
    "name": "Charles Scott",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "3",
    "name": "Cheri Steinmetz",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "1",
    "name": "Chip Neiman",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "9",
    "name": "Chris Rothfuss",
    "party": "D"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "53",
    "name": "Chris Knapp",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "12",
    "name": "Clarence Styvar",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "39",
    "name": "Cody Wylie",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "26",
    "name": "Dalton Banks",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "16",
    "name": "Dan Dockstader",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "19",
    "name": "Dan Laursen",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "61",
    "name": "Daniel Singh",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "48",
    "name": "Darin McCann",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "6",
    "name": "Darin Smith",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "20",
    "name": "Ed Cooper",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "56",
    "name": "Elissa Campbell",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "23",
    "name": "Eric Barlow",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "31",
    "name": "Evie Brennan",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "41",
    "name": "Gary Brown",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "10",
    "name": "Gary Crum",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "33",
    "name": "Ivan Posey",
    "party": "D"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "2",
    "name": "J.D. Williams",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "59",
    "name": "J.R. Riggins",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "17",
    "name": "J.T. Larson",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "11",
    "name": "Jacob Wasserburger",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "8",
    "name": "Jared Olsen",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "38",
    "name": "Jayme Lien",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "4",
    "name": "Jeremy Haroldson",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "28",
    "name": "Jim Anderson",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "19",
    "name": "Joe Webb",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "55",
    "name": "Joel Guggenmos",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "31",
    "name": "John Bear",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "10",
    "name": "John Eklund",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "12",
    "name": "John Kolb",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "28",
    "name": "John Winter",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "57",
    "name": "Julie Jarvis",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "45",
    "name": "Karlee Provenza",
    "party": "D"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "13",
    "name": "Ken Chestek",
    "party": "D"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "32",
    "name": "Ken Clouston",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "29",
    "name": "Ken Pendergraft",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "62",
    "name": "Kevin Campbell",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "9",
    "name": "Landon Brown",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "11",
    "name": "Larry Hicks",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "14",
    "name": "Laura Pearson",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "51",
    "name": "Laurie Bratten",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "44",
    "name": "Lee Filer",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "23",
    "name": "Liz Storer",
    "party": "D"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "54",
    "name": "Lloyd Larsen",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "5",
    "name": "Lynn Hutchings",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "40",
    "name": "Marilyn Connolly",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "60",
    "name": "Marlene Brady",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "27",
    "name": "Martha Lawley",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "21",
    "name": "McKay Erickson",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "17",
    "name": "Mike Gierau",
    "party": "D"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "20",
    "name": "Mike Schmid",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "16",
    "name": "Mike Yin",
    "party": "D"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "24",
    "name": "Nina Webber",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "46",
    "name": "Ocean Andrew",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "1",
    "name": "Ogden Driskill",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "15",
    "name": "Pam Thayer",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "25",
    "name": "Paul Hoeft",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "34",
    "name": "Pepper Ottman",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "50",
    "name": "Rachel Rodriguez-Williams",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "52",
    "name": "Reuben Tarver",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "42",
    "name": "Rob Geringer",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "49",
    "name": "Bob Wharff",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "18",
    "name": "Scott Heiner",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "5",
    "name": "Scott Smith",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "13",
    "name": "Stacy Jones",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "7",
    "name": "Stephan Pappas",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "37",
    "name": "Steve Harshman",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "8",
    "name": "Steve Johnson",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "4",
    "name": "Tara Nethercott",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "18",
    "name": "Tim French",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "26",
    "name": "Tim Salazar",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "30",
    "name": "Tom Kelly",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "6",
    "name": "Tomi Strock",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "35",
    "name": "Tony Locke",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "House",
    "district": "14",
    "name": "Trey Sherwood",
    "party": "D"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "24",
    "name": "Troy McKeown",
    "party": "R"
  },
  {
    "state": "wy",
    "chamber": "Senate",
    "district": "15",
    "name": "Wendy Schuler",
    "party": "R"
  }
];

export function findLegislator(state: string, chamber: string, district: string): Legislator | null {
  const stateKey = state.toLowerCase();
  const chamberKey = chamber.toLowerCase().includes('senate') ? 'Senate' : 'House';
  
  return stateLegislators.find(leg => 
    leg.state === stateKey &&
    leg.chamber === chamberKey &&
    leg.district === district
  ) || null;
}

export function formatLegislatorName(legislator: Legislator): string {
  const title = legislator.chamber === 'Senate' ? 'Sen.' : 'Rep.';
  return `${title} ${legislator.name}`;
}

// Statistics for reference
export const legislatorStats = {
  totalLegislators: 7361,
  statesAndJurisdictions: 51,
  senatorsCount: 1910,
  representativesCount: 5451,
  byState: {
  "AK": 60,
  "AL": 136,
  "AR": 135,
  "AZ": 90,
  "CA": 119,
  "CO": 100,
  "CT": 187,
  "DC": 8,
  "DE": 61,
  "FL": 159,
  "GA": 235,
  "HI": 76,
  "IA": 149,
  "ID": 104,
  "IL": 177,
  "IN": 150,
  "KS": 164,
  "KY": 138,
  "LA": 144,
  "MA": 194,
  "MD": 188,
  "ME": 187,
  "MI": 147,
  "MN": 200,
  "MO": 195,
  "MS": 171,
  "MT": 149,
  "NC": 170,
  "ND": 140,
  "NE": 49,
  "NH": 422,
  "NJ": 120,
  "NM": 112,
  "NV": 63,
  "NY": 213,
  "OH": 132,
  "OK": 149,
  "OR": 90,
  "PA": 253,
  "RI": 112,
  "SC": 170,
  "SD": 103,
  "TN": 132,
  "TX": 180,
  "UT": 103,
  "VA": 139,
  "VT": 180,
  "WA": 147,
  "WI": 132,
  "WV": 134,
  "WY": 93
}
};
